// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/nucleo-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/nucleo-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/nucleo-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/nucleo-icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjQwcHgiIGhlaWdodD0iNDBweCIgdmlld0JveD0iMTIgMTIgNDAgNDAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMTIgMTIgNDAgNDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxwYXRoIGZpbGw9IiMzMzMzMzMiIGQ9Ik0zMiAxMy40Yy0xMC41IDAtMTkgOC41LTE5IDE5YzAgOC40IDUuNSAxNS41IDEzIDE4YzEgMC4yIDEuMy0wLjQgMS4zLTAuOWMwLTAuNSAwLTEuNyAwLTMuMiBjLTUuMyAxLjEtNi40LTIuNi02LjQtMi42QzIwIDQxLjYgMTguOCA0MSAxOC44IDQxYy0xLjctMS4yIDAuMS0xLjEgMC4xLTEuMWMxLjkgMC4xIDIuOSAyIDIuOSAyYzEuNyAyLjkgNC41IDIuMSA1LjUgMS42IGMwLjItMS4yIDAuNy0yLjEgMS4yLTIuNmMtNC4yLTAuNS04LjctMi4xLTguNy05LjRjMC0yLjEgMC43LTMuNyAyLTUuMWMtMC4yLTAuNS0wLjgtMi40IDAuMi01YzAgMCAxLjYtMC41IDUuMiAyIGMxLjUtMC40IDMuMS0wLjcgNC44LTAuN2MxLjYgMCAzLjMgMC4yIDQuNyAwLjdjMy42LTIuNCA1LjItMiA1LjItMmMxIDIuNiAwLjQgNC42IDAuMiA1YzEuMiAxLjMgMiAzIDIgNS4xYzAgNy4zLTQuNSA4LjktOC43IDkuNCBjMC43IDAuNiAxLjMgMS43IDEuMyAzLjVjMCAyLjYgMCA0LjYgMCA1LjJjMCAwLjUgMC40IDEuMSAxLjMgMC45YzcuNS0yLjYgMTMtOS43IDEzLTE4LjFDNTEgMjEuOSA0Mi41IDEzLjQgMzIgMTMuNHoiLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!

 =========================================================
 * Paper Dashboard React - v1.3.0 based on Paper Dashboard 2 - v2.0.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/paper-dashboard-2
 * Copyright 2021 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license - http://opensource.org/licenses/MIT

Copyright (c) 2015 Daniel Eden
*/
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.animated.infinite {
  animation-iteration-count: infinite;
}

.animated.hinge {
  animation-duration: 2s;
}

.animated.bounceIn,
.animated.bounceOut {
  animation-duration: 0.75s;
}

.animated.flipOutX,
.animated.flipOutY {
  animation-duration: 0.75s;
}
@keyframes shake {
  from, to {
    transform: translate3d(0, 0, 0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translate3d(-10px, 0, 0);
  }
  20%, 40%, 60%, 80% {
    transform: translate3d(10px, 0, 0);
  }
}
.shake {
  animation-name: shake;
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInDown {
  animation-name: fadeInDown;
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.fadeOut {
  animation-name: fadeOut;
}
@keyframes fadeOutDown {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}
.fadeOutDown {
  animation-name: fadeOutDown;
}
@keyframes fadeOutUp {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}
.fadeOutUp {
  animation-name: fadeOutUp;
}

/* perfect-scrollbar v0.6.13 */
.ps-container {
  touch-action: auto;
  overflow: hidden !important;
  -ms-overflow-style: none;
}

@supports (-ms-overflow-style: none) {
  .ps-container {
    overflow: auto !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps-container {
    overflow: auto !important;
  }
}
.ps-container.ps-active-x > .ps-scrollbar-x-rail,
.ps-container.ps-active-y > .ps-scrollbar-y-rail {
  display: block;
  background-color: transparent;
}

.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  background-color: #999;
  height: 11px;
}

.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  background-color: #999;
  width: 11px;
}

.ps-container > .ps-scrollbar-x-rail {
  display: none;
  position: absolute;
  /* please don't change 'position' */
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  bottom: 0px;
  /* there must be 'bottom' for ps-scrollbar-x-rail */
  height: 15px;
}

.ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  position: absolute;
  /* please don't change 'position' */
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s linear, width 0.2s ease-in-out, border-radius 0.2s ease-in-out;
  bottom: 2px;
  /* there must be 'bottom' for ps-scrollbar-x */
  height: 6px;
}

.ps-container > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x, .ps-container > .ps-scrollbar-x-rail:active > .ps-scrollbar-x {
  height: 11px;
}

.ps-container > .ps-scrollbar-y-rail {
  display: none;
  position: absolute;
  /* please don't change 'position' */
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  right: 0;
  /* there must be 'right' for ps-scrollbar-y-rail */
  width: 15px;
}

.ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  position: absolute;
  /* please don't change 'position' */
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s linear, width 0.2s ease-in-out, border-radius 0.2s ease-in-out;
  right: 2px;
  /* there must be 'right' for ps-scrollbar-y */
  width: 6px;
}

.ps-container > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y, .ps-container > .ps-scrollbar-y-rail:active > .ps-scrollbar-y {
  width: 11px;
}

.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  background-color: #999;
  height: 11px;
}

.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  background-color: #999;
  width: 11px;
}

.ps-container:hover > .ps-scrollbar-x-rail,
.ps-container:hover > .ps-scrollbar-y-rail {
  opacity: 0.6;
}

.ps-container:hover > .ps-scrollbar-x-rail:hover {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {
  background-color: #999;
}

.ps-container:hover > .ps-scrollbar-y-rail:hover {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {
  background-color: #999;
}

.btn,
.navbar .navbar-nav > a.btn {
  border-width: 2px;
  font-weight: 600;
  font-size: 0.8571em;
  line-height: 1.35em;
  text-transform: uppercase;
  border: none;
  margin: 10px 1px;
  border-radius: 3px;
  padding: 11px 22px;
  cursor: pointer;
  background-color: #66615B;
  color: #FFFFFF;
  transition: all 150ms linear;
}
.btn:hover, .btn:focus, .btn:active, .btn.active, .btn:active:focus, .btn:active:hover, .btn.active:focus, .btn.active:hover, .show > .btn.dropdown-toggle, .show > .btn.dropdown-toggle:focus, .show > .btn.dropdown-toggle:hover,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.navbar .navbar-nav > a.btn:active:focus,
.navbar .navbar-nav > a.btn:active:hover,
.navbar .navbar-nav > a.btn.active:focus,
.navbar .navbar-nav > a.btn.active:hover,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle:focus,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle:hover {
  background-color: #403D39 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn:not([data-action]):hover,
.navbar .navbar-nav > a.btn:not([data-action]):hover {
  box-shadow: none;
}
.btn.disabled, .btn.disabled:hover, .btn.disabled:focus, .btn.disabled.focus, .btn.disabled:active, .btn.disabled.active, .btn:disabled, .btn:disabled:hover, .btn:disabled:focus, .btn:disabled.focus, .btn:disabled:active, .btn:disabled.active, .btn[disabled], .btn[disabled]:hover, .btn[disabled]:focus, .btn[disabled].focus, .btn[disabled]:active, .btn[disabled].active, fieldset[disabled] .btn, fieldset[disabled] .btn:hover, fieldset[disabled] .btn:focus, fieldset[disabled] .btn.focus, fieldset[disabled] .btn:active, fieldset[disabled] .btn.active,
.navbar .navbar-nav > a.btn.disabled,
.navbar .navbar-nav > a.btn.disabled:hover,
.navbar .navbar-nav > a.btn.disabled:focus,
.navbar .navbar-nav > a.btn.disabled.focus,
.navbar .navbar-nav > a.btn.disabled:active,
.navbar .navbar-nav > a.btn.disabled.active,
.navbar .navbar-nav > a.btn:disabled,
.navbar .navbar-nav > a.btn:disabled:hover,
.navbar .navbar-nav > a.btn:disabled:focus,
.navbar .navbar-nav > a.btn:disabled.focus,
.navbar .navbar-nav > a.btn:disabled:active,
.navbar .navbar-nav > a.btn:disabled.active,
.navbar .navbar-nav > a.btn[disabled],
.navbar .navbar-nav > a.btn[disabled]:hover,
.navbar .navbar-nav > a.btn[disabled]:focus,
.navbar .navbar-nav > a.btn[disabled].focus,
.navbar .navbar-nav > a.btn[disabled]:active,
.navbar .navbar-nav > a.btn[disabled].active,
fieldset[disabled] .navbar .navbar-nav > a.btn,
fieldset[disabled] .navbar .navbar-nav > a.btn:hover,
fieldset[disabled] .navbar .navbar-nav > a.btn:focus,
fieldset[disabled] .navbar .navbar-nav > a.btn.focus,
fieldset[disabled] .navbar .navbar-nav > a.btn:active,
fieldset[disabled] .navbar .navbar-nav > a.btn.active {
  background-color: #66615B;
  border-color: #66615B;
}
.btn.btn-simple,
.navbar .navbar-nav > a.btn.btn-simple {
  color: #66615B;
  border-color: #66615B;
}
.btn.btn-simple:hover, .btn.btn-simple:focus, .btn.btn-simple:active,
.navbar .navbar-nav > a.btn.btn-simple:hover,
.navbar .navbar-nav > a.btn.btn-simple:focus,
.navbar .navbar-nav > a.btn.btn-simple:active {
  background-color: transparent;
  color: #403D39;
  border-color: #403D39;
  box-shadow: none;
}
.btn.btn-link,
.navbar .navbar-nav > a.btn.btn-link {
  color: #66615B;
}
.btn.btn-link:hover, .btn.btn-link:focus, .btn.btn-link:active, .btn.btn-link:active:focus,
.navbar .navbar-nav > a.btn.btn-link:hover,
.navbar .navbar-nav > a.btn.btn-link:focus,
.navbar .navbar-nav > a.btn.btn-link:active,
.navbar .navbar-nav > a.btn.btn-link:active:focus {
  background-color: transparent;
  color: #403D39;
  text-decoration: none;
  box-shadow: none;
}
.btn:hover, .btn:focus,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus {
  opacity: 1;
  filter: alpha(opacity=100);
  outline: 0 !important;
}
.btn:active, .btn.active, .open > .btn.dropdown-toggle,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.open > .navbar .navbar-nav > a.btn.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.btn .badge,
.navbar .navbar-nav > a.btn .badge {
  margin: 0;
}
.btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon {
  height: 2.375rem;
  min-width: 2.375rem;
  width: 2.375rem;
  padding: 0;
  font-size: 0.9375rem;
  overflow: hidden;
  position: relative;
  line-height: normal;
}
.btn.btn-icon.btn-simple,
.navbar .navbar-nav > a.btn.btn-icon.btn-simple {
  padding: 0;
}
.btn.btn-icon.btn-sm,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm {
  height: 1.875rem;
  min-width: 1.875rem;
  width: 1.875rem;
}
.btn.btn-icon.btn-sm .fa,
.btn.btn-icon.btn-sm .far,
.btn.btn-icon.btn-sm .fas,
.btn.btn-icon.btn-sm .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .nc-icon {
  font-size: 0.6875rem;
}
.btn.btn-icon.btn-lg,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg {
  height: 3.6rem;
  min-width: 3.6rem;
  width: 3.6rem;
}
.btn.btn-icon.btn-lg .fa,
.btn.btn-icon.btn-lg .far,
.btn.btn-icon.btn-lg .fas,
.btn.btn-icon.btn-lg .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .nc-icon {
  font-size: 1.325rem;
}
.btn.btn-icon:not(.btn-footer) .nc-icon, .btn.btn-icon:not(.btn-footer) .fa, .btn.btn-icon:not(.btn-footer) .far, .btn.btn-icon:not(.btn-footer) .fas,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fa,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .far,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fas {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-12px, -12px);
  line-height: 1.5626rem;
  width: 24px;
}
.btn.btn-icon.btn-neutral,
.navbar .navbar-nav > a.btn.btn-icon.btn-neutral {
  font-size: 20px;
}
.btn:not(.btn-icon) .nc-icon,
.navbar .navbar-nav > a.btn:not(.btn-icon) .nc-icon {
  position: relative;
  top: 1px;
}

.btn-primary {
  background-color: #51cbce;
  color: #FFFFFF;
}
.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .btn-primary:active:focus, .btn-primary:active:hover, .btn-primary.active:focus, .btn-primary.active:hover, .show > .btn-primary.dropdown-toggle, .show > .btn-primary.dropdown-toggle:focus, .show > .btn-primary.dropdown-toggle:hover {
  background-color: #34b5b8 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn-primary:not([data-action]):hover {
  box-shadow: none;
}
.btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled.focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary:disabled, .btn-primary:disabled:hover, .btn-primary:disabled:focus, .btn-primary:disabled.focus, .btn-primary:disabled:active, .btn-primary:disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled].active, fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary:hover, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary.active {
  background-color: #51cbce;
  border-color: #51cbce;
}
.btn-primary.btn-simple {
  color: #51cbce;
  border-color: #51cbce;
}
.btn-primary.btn-simple:hover, .btn-primary.btn-simple:focus, .btn-primary.btn-simple:active {
  background-color: transparent;
  color: #34b5b8;
  border-color: #34b5b8;
  box-shadow: none;
}
.btn-primary.btn-link {
  color: #51cbce;
}
.btn-primary.btn-link:hover, .btn-primary.btn-link:focus, .btn-primary.btn-link:active, .btn-primary.btn-link:active:focus {
  background-color: transparent;
  color: #34b5b8;
  text-decoration: none;
  box-shadow: none;
}

.btn-success {
  background-color: #6bd098;
  color: #FFFFFF;
}
.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active, .btn-success:active:focus, .btn-success:active:hover, .btn-success.active:focus, .btn-success.active:hover, .show > .btn-success.dropdown-toggle, .show > .btn-success.dropdown-toggle:focus, .show > .btn-success.dropdown-toggle:hover {
  background-color: #44c47d !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn-success:not([data-action]):hover {
  box-shadow: none;
}
.btn-success.disabled, .btn-success.disabled:hover, .btn-success.disabled:focus, .btn-success.disabled.focus, .btn-success.disabled:active, .btn-success.disabled.active, .btn-success:disabled, .btn-success:disabled:hover, .btn-success:disabled:focus, .btn-success:disabled.focus, .btn-success:disabled:active, .btn-success:disabled.active, .btn-success[disabled], .btn-success[disabled]:hover, .btn-success[disabled]:focus, .btn-success[disabled].focus, .btn-success[disabled]:active, .btn-success[disabled].active, fieldset[disabled] .btn-success, fieldset[disabled] .btn-success:hover, fieldset[disabled] .btn-success:focus, fieldset[disabled] .btn-success.focus, fieldset[disabled] .btn-success:active, fieldset[disabled] .btn-success.active {
  background-color: #6bd098;
  border-color: #6bd098;
}
.btn-success.btn-simple {
  color: #6bd098;
  border-color: #6bd098;
}
.btn-success.btn-simple:hover, .btn-success.btn-simple:focus, .btn-success.btn-simple:active {
  background-color: transparent;
  color: #44c47d;
  border-color: #44c47d;
  box-shadow: none;
}
.btn-success.btn-link {
  color: #6bd098;
}
.btn-success.btn-link:hover, .btn-success.btn-link:focus, .btn-success.btn-link:active, .btn-success.btn-link:active:focus {
  background-color: transparent;
  color: #44c47d;
  text-decoration: none;
  box-shadow: none;
}

.btn-info {
  background-color: #2d3e75;
  color: #FFFFFF;
}
.btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active, .btn-info:active:focus, .btn-info:active:hover, .btn-info.active:focus, .btn-info.active:hover, .show > .btn-info.dropdown-toggle, .show > .btn-info.dropdown-toggle:focus, .show > .btn-info.dropdown-toggle:hover {
  background-color: #1f2a50 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn-info:not([data-action]):hover {
  box-shadow: none;
}
.btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled.focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info:disabled, .btn-info:disabled:hover, .btn-info:disabled:focus, .btn-info:disabled.focus, .btn-info:disabled:active, .btn-info:disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled].focus, .btn-info[disabled]:active, .btn-info[disabled].active, fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info.focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {
  background-color: #2d3e75;
  border-color: #2d3e75;
}
.btn-info.btn-simple {
  color: #2d3e75;
  border-color: #2d3e75;
}
.btn-info.btn-simple:hover, .btn-info.btn-simple:focus, .btn-info.btn-simple:active {
  background-color: transparent;
  color: #1f2a50;
  border-color: #1f2a50;
  box-shadow: none;
}
.btn-info.btn-link {
  color: #2d3e75;
}
.btn-info.btn-link:hover, .btn-info.btn-link:focus, .btn-info.btn-link:active, .btn-info.btn-link:active:focus {
  background-color: transparent;
  color: #1f2a50;
  text-decoration: none;
  box-shadow: none;
}

.btn-warning {
  background-color: #fbc658;
  color: #FFFFFF;
}
.btn-warning:hover, .btn-warning:focus, .btn-warning:active, .btn-warning.active, .btn-warning:active:focus, .btn-warning:active:hover, .btn-warning.active:focus, .btn-warning.active:hover, .show > .btn-warning.dropdown-toggle, .show > .btn-warning.dropdown-toggle:focus, .show > .btn-warning.dropdown-toggle:hover {
  background-color: #fab526 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn-warning:not([data-action]):hover {
  box-shadow: none;
}
.btn-warning.disabled, .btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled.focus, .btn-warning.disabled:active, .btn-warning.disabled.active, .btn-warning:disabled, .btn-warning:disabled:hover, .btn-warning:disabled:focus, .btn-warning:disabled.focus, .btn-warning:disabled:active, .btn-warning:disabled.active, .btn-warning[disabled], .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled].focus, .btn-warning[disabled]:active, .btn-warning[disabled].active, fieldset[disabled] .btn-warning, fieldset[disabled] .btn-warning:hover, fieldset[disabled] .btn-warning:focus, fieldset[disabled] .btn-warning.focus, fieldset[disabled] .btn-warning:active, fieldset[disabled] .btn-warning.active {
  background-color: #fbc658;
  border-color: #fbc658;
}
.btn-warning.btn-simple {
  color: #fbc658;
  border-color: #fbc658;
}
.btn-warning.btn-simple:hover, .btn-warning.btn-simple:focus, .btn-warning.btn-simple:active {
  background-color: transparent;
  color: #fab526;
  border-color: #fab526;
  box-shadow: none;
}
.btn-warning.btn-link {
  color: #fbc658;
}
.btn-warning.btn-link:hover, .btn-warning.btn-link:focus, .btn-warning.btn-link:active, .btn-warning.btn-link:active:focus {
  background-color: transparent;
  color: #fab526;
  text-decoration: none;
  box-shadow: none;
}

.btn-danger {
  background-color: #ef8157;
  color: #FFFFFF;
}
.btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active, .btn-danger:active:focus, .btn-danger:active:hover, .btn-danger.active:focus, .btn-danger.active:hover, .show > .btn-danger.dropdown-toggle, .show > .btn-danger.dropdown-toggle:focus, .show > .btn-danger.dropdown-toggle:hover {
  background-color: #eb6532 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn-danger:not([data-action]):hover {
  box-shadow: none;
}
.btn-danger.disabled, .btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled.focus, .btn-danger.disabled:active, .btn-danger.disabled.active, .btn-danger:disabled, .btn-danger:disabled:hover, .btn-danger:disabled:focus, .btn-danger:disabled.focus, .btn-danger:disabled:active, .btn-danger:disabled.active, .btn-danger[disabled], .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled].focus, .btn-danger[disabled]:active, .btn-danger[disabled].active, fieldset[disabled] .btn-danger, fieldset[disabled] .btn-danger:hover, fieldset[disabled] .btn-danger:focus, fieldset[disabled] .btn-danger.focus, fieldset[disabled] .btn-danger:active, fieldset[disabled] .btn-danger.active {
  background-color: #ef8157;
  border-color: #ef8157;
}
.btn-danger.btn-simple {
  color: #ef8157;
  border-color: #ef8157;
}
.btn-danger.btn-simple:hover, .btn-danger.btn-simple:focus, .btn-danger.btn-simple:active {
  background-color: transparent;
  color: #eb6532;
  border-color: #eb6532;
  box-shadow: none;
}
.btn-danger.btn-link {
  color: #ef8157;
}
.btn-danger.btn-link:hover, .btn-danger.btn-link:focus, .btn-danger.btn-link:active, .btn-danger.btn-link:active:focus {
  background-color: transparent;
  color: #eb6532;
  text-decoration: none;
  box-shadow: none;
}

.btn-outline-default {
  background: transparent;
  border: 2px solid #66615B !important;
  color: #66615B;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-default:hover, .btn-outline-default:focus, .btn-outline-default:active, .btn-outline-default:focus:active, .btn-outline-default.active, .open > .btn-outline-default.dropdown-toggle {
  background-color: #66615B !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #66615B !important;
}
.btn-outline-default:hover .caret, .btn-outline-default:focus .caret, .btn-outline-default:active .caret, .btn-outline-default:focus:active .caret, .btn-outline-default.active .caret, .open > .btn-outline-default.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-default .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-default.disabled, .btn-outline-default.disabled:hover, .btn-outline-default.disabled:focus, .btn-outline-default.disabled.focus, .btn-outline-default.disabled:active, .btn-outline-default.disabled.active, .btn-outline-default:disabled, .btn-outline-default:disabled:hover, .btn-outline-default:disabled:focus, .btn-outline-default:disabled.focus, .btn-outline-default:disabled:active, .btn-outline-default:disabled.active, .btn-outline-default[disabled], .btn-outline-default[disabled]:hover, .btn-outline-default[disabled]:focus, .btn-outline-default[disabled].focus, .btn-outline-default[disabled]:active, .btn-outline-default[disabled].active, fieldset[disabled] .btn-outline-default, fieldset[disabled] .btn-outline-default:hover, fieldset[disabled] .btn-outline-default:focus, fieldset[disabled] .btn-outline-default.focus, fieldset[disabled] .btn-outline-default:active, fieldset[disabled] .btn-outline-default.active {
  background-color: transparent !important;
  border-color: #66615B !important;
}

.btn-outline-primary {
  background: transparent;
  border: 2px solid #51cbce !important;
  color: #51cbce;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:active, .btn-outline-primary:focus:active, .btn-outline-primary.active, .open > .btn-outline-primary.dropdown-toggle {
  background-color: #51cbce !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #51cbce !important;
}
.btn-outline-primary:hover .caret, .btn-outline-primary:focus .caret, .btn-outline-primary:active .caret, .btn-outline-primary:focus:active .caret, .btn-outline-primary.active .caret, .open > .btn-outline-primary.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-primary .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-primary.disabled, .btn-outline-primary.disabled:hover, .btn-outline-primary.disabled:focus, .btn-outline-primary.disabled.focus, .btn-outline-primary.disabled:active, .btn-outline-primary.disabled.active, .btn-outline-primary:disabled, .btn-outline-primary:disabled:hover, .btn-outline-primary:disabled:focus, .btn-outline-primary:disabled.focus, .btn-outline-primary:disabled:active, .btn-outline-primary:disabled.active, .btn-outline-primary[disabled], .btn-outline-primary[disabled]:hover, .btn-outline-primary[disabled]:focus, .btn-outline-primary[disabled].focus, .btn-outline-primary[disabled]:active, .btn-outline-primary[disabled].active, fieldset[disabled] .btn-outline-primary, fieldset[disabled] .btn-outline-primary:hover, fieldset[disabled] .btn-outline-primary:focus, fieldset[disabled] .btn-outline-primary.focus, fieldset[disabled] .btn-outline-primary:active, fieldset[disabled] .btn-outline-primary.active {
  background-color: transparent !important;
  border-color: #51cbce !important;
}

.btn-outline-success {
  background: transparent;
  border: 2px solid #6bd098 !important;
  color: #6bd098;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-success:hover, .btn-outline-success:focus, .btn-outline-success:active, .btn-outline-success:focus:active, .btn-outline-success.active, .open > .btn-outline-success.dropdown-toggle {
  background-color: #6bd098 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #6bd098 !important;
}
.btn-outline-success:hover .caret, .btn-outline-success:focus .caret, .btn-outline-success:active .caret, .btn-outline-success:focus:active .caret, .btn-outline-success.active .caret, .open > .btn-outline-success.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-success .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-success.disabled, .btn-outline-success.disabled:hover, .btn-outline-success.disabled:focus, .btn-outline-success.disabled.focus, .btn-outline-success.disabled:active, .btn-outline-success.disabled.active, .btn-outline-success:disabled, .btn-outline-success:disabled:hover, .btn-outline-success:disabled:focus, .btn-outline-success:disabled.focus, .btn-outline-success:disabled:active, .btn-outline-success:disabled.active, .btn-outline-success[disabled], .btn-outline-success[disabled]:hover, .btn-outline-success[disabled]:focus, .btn-outline-success[disabled].focus, .btn-outline-success[disabled]:active, .btn-outline-success[disabled].active, fieldset[disabled] .btn-outline-success, fieldset[disabled] .btn-outline-success:hover, fieldset[disabled] .btn-outline-success:focus, fieldset[disabled] .btn-outline-success.focus, fieldset[disabled] .btn-outline-success:active, fieldset[disabled] .btn-outline-success.active {
  background-color: transparent !important;
  border-color: #6bd098 !important;
}

.btn-outline-info {
  background: transparent;
  border: 2px solid #2d3e75 !important;
  color: #2d3e75;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-info:hover, .btn-outline-info:focus, .btn-outline-info:active, .btn-outline-info:focus:active, .btn-outline-info.active, .open > .btn-outline-info.dropdown-toggle {
  background-color: #2d3e75 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #2d3e75 !important;
}
.btn-outline-info:hover .caret, .btn-outline-info:focus .caret, .btn-outline-info:active .caret, .btn-outline-info:focus:active .caret, .btn-outline-info.active .caret, .open > .btn-outline-info.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-info .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-info.disabled, .btn-outline-info.disabled:hover, .btn-outline-info.disabled:focus, .btn-outline-info.disabled.focus, .btn-outline-info.disabled:active, .btn-outline-info.disabled.active, .btn-outline-info:disabled, .btn-outline-info:disabled:hover, .btn-outline-info:disabled:focus, .btn-outline-info:disabled.focus, .btn-outline-info:disabled:active, .btn-outline-info:disabled.active, .btn-outline-info[disabled], .btn-outline-info[disabled]:hover, .btn-outline-info[disabled]:focus, .btn-outline-info[disabled].focus, .btn-outline-info[disabled]:active, .btn-outline-info[disabled].active, fieldset[disabled] .btn-outline-info, fieldset[disabled] .btn-outline-info:hover, fieldset[disabled] .btn-outline-info:focus, fieldset[disabled] .btn-outline-info.focus, fieldset[disabled] .btn-outline-info:active, fieldset[disabled] .btn-outline-info.active {
  background-color: transparent !important;
  border-color: #2d3e75 !important;
}

.btn-outline-warning {
  background: transparent;
  border: 2px solid #fbc658 !important;
  color: #fbc658;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-warning:hover, .btn-outline-warning:focus, .btn-outline-warning:active, .btn-outline-warning:focus:active, .btn-outline-warning.active, .open > .btn-outline-warning.dropdown-toggle {
  background-color: #fbc658 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #fbc658 !important;
}
.btn-outline-warning:hover .caret, .btn-outline-warning:focus .caret, .btn-outline-warning:active .caret, .btn-outline-warning:focus:active .caret, .btn-outline-warning.active .caret, .open > .btn-outline-warning.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-warning .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-warning.disabled, .btn-outline-warning.disabled:hover, .btn-outline-warning.disabled:focus, .btn-outline-warning.disabled.focus, .btn-outline-warning.disabled:active, .btn-outline-warning.disabled.active, .btn-outline-warning:disabled, .btn-outline-warning:disabled:hover, .btn-outline-warning:disabled:focus, .btn-outline-warning:disabled.focus, .btn-outline-warning:disabled:active, .btn-outline-warning:disabled.active, .btn-outline-warning[disabled], .btn-outline-warning[disabled]:hover, .btn-outline-warning[disabled]:focus, .btn-outline-warning[disabled].focus, .btn-outline-warning[disabled]:active, .btn-outline-warning[disabled].active, fieldset[disabled] .btn-outline-warning, fieldset[disabled] .btn-outline-warning:hover, fieldset[disabled] .btn-outline-warning:focus, fieldset[disabled] .btn-outline-warning.focus, fieldset[disabled] .btn-outline-warning:active, fieldset[disabled] .btn-outline-warning.active {
  background-color: transparent !important;
  border-color: #fbc658 !important;
}

.btn-outline-danger {
  background: transparent;
  border: 2px solid #ef8157 !important;
  color: #ef8157;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-danger:hover, .btn-outline-danger:focus, .btn-outline-danger:active, .btn-outline-danger:focus:active, .btn-outline-danger.active, .open > .btn-outline-danger.dropdown-toggle {
  background-color: #ef8157 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #ef8157 !important;
}
.btn-outline-danger:hover .caret, .btn-outline-danger:focus .caret, .btn-outline-danger:active .caret, .btn-outline-danger:focus:active .caret, .btn-outline-danger.active .caret, .open > .btn-outline-danger.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-danger .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-danger.disabled, .btn-outline-danger.disabled:hover, .btn-outline-danger.disabled:focus, .btn-outline-danger.disabled.focus, .btn-outline-danger.disabled:active, .btn-outline-danger.disabled.active, .btn-outline-danger:disabled, .btn-outline-danger:disabled:hover, .btn-outline-danger:disabled:focus, .btn-outline-danger:disabled.focus, .btn-outline-danger:disabled:active, .btn-outline-danger:disabled.active, .btn-outline-danger[disabled], .btn-outline-danger[disabled]:hover, .btn-outline-danger[disabled]:focus, .btn-outline-danger[disabled].focus, .btn-outline-danger[disabled]:active, .btn-outline-danger[disabled].active, fieldset[disabled] .btn-outline-danger, fieldset[disabled] .btn-outline-danger:hover, fieldset[disabled] .btn-outline-danger:focus, fieldset[disabled] .btn-outline-danger.focus, fieldset[disabled] .btn-outline-danger:active, fieldset[disabled] .btn-outline-danger.active {
  background-color: transparent !important;
  border-color: #ef8157 !important;
}

.btn-outline-neutral {
  background: transparent;
  border: 2px solid #FFFFFF !important;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-neutral:hover, .btn-outline-neutral:focus, .btn-outline-neutral:active, .btn-outline-neutral:focus:active, .btn-outline-neutral.active, .open > .btn-outline-neutral.dropdown-toggle {
  background-color: #FFFFFF !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #FFFFFF !important;
}
.btn-outline-neutral:hover .caret, .btn-outline-neutral:focus .caret, .btn-outline-neutral:active .caret, .btn-outline-neutral:focus:active .caret, .btn-outline-neutral.active .caret, .open > .btn-outline-neutral.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-neutral .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-neutral.disabled, .btn-outline-neutral.disabled:hover, .btn-outline-neutral.disabled:focus, .btn-outline-neutral.disabled.focus, .btn-outline-neutral.disabled:active, .btn-outline-neutral.disabled.active, .btn-outline-neutral:disabled, .btn-outline-neutral:disabled:hover, .btn-outline-neutral:disabled:focus, .btn-outline-neutral:disabled.focus, .btn-outline-neutral:disabled:active, .btn-outline-neutral:disabled.active, .btn-outline-neutral[disabled], .btn-outline-neutral[disabled]:hover, .btn-outline-neutral[disabled]:focus, .btn-outline-neutral[disabled].focus, .btn-outline-neutral[disabled]:active, .btn-outline-neutral[disabled].active, fieldset[disabled] .btn-outline-neutral, fieldset[disabled] .btn-outline-neutral:hover, fieldset[disabled] .btn-outline-neutral:focus, fieldset[disabled] .btn-outline-neutral.focus, fieldset[disabled] .btn-outline-neutral:active, fieldset[disabled] .btn-outline-neutral.active {
  background-color: transparent !important;
  border-color: #FFFFFF !important;
}
.btn-outline-neutral:hover, .btn-outline-neutral:focus {
  color: #403D39;
  background-color: #FFFFFF;
}

.btn-neutral {
  background-color: #FFFFFF;
  color: #51cbce;
  color: #66615B;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:active, .btn-neutral.active, .btn-neutral:active:focus, .btn-neutral:active:hover, .btn-neutral.active:focus, .btn-neutral.active:hover, .show > .btn-neutral.dropdown-toggle, .show > .btn-neutral.dropdown-toggle:focus, .show > .btn-neutral.dropdown-toggle:hover {
  background-color: #FFFFFF !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn-neutral:not([data-action]):hover {
  box-shadow: none;
}
.btn-neutral.disabled, .btn-neutral.disabled:hover, .btn-neutral.disabled:focus, .btn-neutral.disabled.focus, .btn-neutral.disabled:active, .btn-neutral.disabled.active, .btn-neutral:disabled, .btn-neutral:disabled:hover, .btn-neutral:disabled:focus, .btn-neutral:disabled.focus, .btn-neutral:disabled:active, .btn-neutral:disabled.active, .btn-neutral[disabled], .btn-neutral[disabled]:hover, .btn-neutral[disabled]:focus, .btn-neutral[disabled].focus, .btn-neutral[disabled]:active, .btn-neutral[disabled].active, fieldset[disabled] .btn-neutral, fieldset[disabled] .btn-neutral:hover, fieldset[disabled] .btn-neutral:focus, fieldset[disabled] .btn-neutral.focus, fieldset[disabled] .btn-neutral:active, fieldset[disabled] .btn-neutral.active {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
}
.btn-neutral.btn-danger {
  color: #ef8157;
}
.btn-neutral.btn-danger:hover, .btn-neutral.btn-danger:focus, .btn-neutral.btn-danger:active, .btn-neutral.btn-danger:active:focus {
  color: #eb6532 !important;
}
.btn-neutral.btn-info {
  color: #2d3e75 !important;
}
.btn-neutral.btn-info:hover, .btn-neutral.btn-info:focus, .btn-neutral.btn-info:active, .btn-neutral.btn-info:active:focus {
  color: #1f2a50 !important;
}
.btn-neutral.btn-warning {
  color: #fbc658 !important;
}
.btn-neutral.btn-warning:hover, .btn-neutral.btn-warning:focus, .btn-neutral.btn-warning:active, .btn-neutral.btn-warning:active:focus {
  color: #fab526 !important;
}
.btn-neutral.btn-success {
  color: #6bd098 !important;
}
.btn-neutral.btn-success:hover, .btn-neutral.btn-success:focus, .btn-neutral.btn-success:active, .btn-neutral.btn-success:active:focus {
  color: #44c47d !important;
}
.btn-neutral.btn-default {
  color: #66615B !important;
}
.btn-neutral.btn-default:hover, .btn-neutral.btn-default:focus, .btn-neutral.btn-default:active, .btn-neutral.btn-default:active:focus {
  color: #403D39 !important;
}
.btn-neutral.active, .btn-neutral:active, .btn-neutral:active:focus, .btn-neutral:active:hover, .btn-neutral.active:focus, .btn-neutral.active:hover, .show > .btn-neutral.dropdown-toggle, .show > .btn-neutral.dropdown-toggle:focus, .show > .btn-neutral.dropdown-toggle:hover {
  background-color: #FFFFFF !important;
  color: #34b5b8 !important;
  box-shadow: none !important;
}
.btn-neutral:hover, .btn-neutral:focus {
  color: #34b5b8 !important;
}
.btn-neutral:hover:not(.nav-link), .btn-neutral:focus:not(.nav-link) {
  box-shadow: none;
}
.btn-neutral.btn-simple {
  color: #FFFFFF;
  border-color: #FFFFFF;
}
.btn-neutral.btn-simple:hover, .btn-neutral.btn-simple:focus, .btn-neutral.btn-simple:active {
  background-color: transparent;
  color: #FFFFFF;
  border-color: #FFFFFF;
  box-shadow: none;
}
.btn-neutral.btn-link {
  color: #FFFFFF;
}
.btn-neutral.btn-link:hover, .btn-neutral.btn-link:focus, .btn-neutral.btn-link:active, .btn-neutral.btn-link:active:focus {
  background-color: transparent;
  color: #FFFFFF;
  text-decoration: none;
  box-shadow: none;
}
.btn-neutral:hover, .btn-neutral:focus {
  color: #403D39;
}
.btn-neutral.btn-border:hover, .btn-neutral.btn-border:focus {
  color: #66615B;
}
.btn-neutral.btn-border:active, .btn-neutral.btn-border.active, .open > .btn-neutral.btn-border.dropdown-toggle {
  background-color: #FFFFFF;
  color: #66615B;
}
.btn-neutral.btn-link:active, .btn-neutral.btn-link.active {
  background-color: transparent;
}

.btn:disabled, .btn[disabled], .btn.disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
}

.btn-simple {
  border: 1px solid;
  border-color: #66615B;
  padding: 10px 22px;
  background-color: transparent;
}

.btn-simple.disabled, .btn-simple.disabled:hover, .btn-simple.disabled:focus, .btn-simple.disabled.focus, .btn-simple.disabled:active, .btn-simple.disabled.active, .btn-simple:disabled, .btn-simple:disabled:hover, .btn-simple:disabled:focus, .btn-simple:disabled.focus, .btn-simple:disabled:active, .btn-simple:disabled.active, .btn-simple[disabled], .btn-simple[disabled]:hover, .btn-simple[disabled]:focus, .btn-simple[disabled].focus, .btn-simple[disabled]:active, .btn-simple[disabled].active, fieldset[disabled] .btn-simple, fieldset[disabled] .btn-simple:hover, fieldset[disabled] .btn-simple:focus, fieldset[disabled] .btn-simple.focus, fieldset[disabled] .btn-simple:active, fieldset[disabled] .btn-simple.active,
.btn-link.disabled,
.btn-link.disabled:hover,
.btn-link.disabled:focus,
.btn-link.disabled.focus,
.btn-link.disabled:active,
.btn-link.disabled.active,
.btn-link:disabled,
.btn-link:disabled:hover,
.btn-link:disabled:focus,
.btn-link:disabled.focus,
.btn-link:disabled:active,
.btn-link:disabled.active,
.btn-link[disabled],
.btn-link[disabled]:hover,
.btn-link[disabled]:focus,
.btn-link[disabled].focus,
.btn-link[disabled]:active,
.btn-link[disabled].active,
fieldset[disabled] .btn-link,
fieldset[disabled] .btn-link:hover,
fieldset[disabled] .btn-link:focus,
fieldset[disabled] .btn-link.focus,
fieldset[disabled] .btn-link:active,
fieldset[disabled] .btn-link.active {
  background-color: transparent;
}

.btn-link {
  border: 0;
  padding: 0.5rem 0.7rem;
  background-color: transparent;
}

.btn-lg {
  font-size: 1rem;
  border-radius: 6px;
  padding: 15px 48px;
}
.btn-lg.btn-simple {
  padding: 14px 47px;
}

.btn-sm {
  font-size: 0.8571em;
  border-radius: 3px;
  padding: 5px 15px;
}
.btn-sm.btn-simple {
  padding: 4px 14px;
}

.btn-wd {
  min-width: 140px;
}

.btn-group.select {
  width: 100%;
}

.btn-group.select .btn {
  text-align: left;
}

.btn-group.select .caret {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 8px;
}

.btn-group .btn + .btn {
  margin-left: -3px;
}
.btn-group .btn:focus {
  background-color: #2d3e75 !important;
}

.btn-round {
  border-width: 1px;
  border-radius: 30px;
  padding-right: 23px;
  padding-left: 23px;
}
.btn-round.btn-simple {
  padding: 10px 22px;
}

.no-caret.dropdown-toggle::after {
  display: none;
}

::-moz-placeholder {
  color: #9A9A9A;
}

:-ms-input-placeholder {
  color: #9A9A9A;
}

::-webkit-input-placeholder {
  color: #9A9A9A;
}

.form-control {
  background-color: #FFFFFF;
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  color: #66615b;
  line-height: normal;
  font-size: 14px;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
  box-shadow: none;
}
.form-control:focus {
  border: 1px solid #9A9A9A;
  box-shadow: none;
  outline: 0 !important;
  color: #66615B;
}
.form-control:focus + .input-group-append .input-group-text, .form-control:focus ~ .input-group-append .input-group-text, .form-control:focus + .input-group-prepend .input-group-text, .form-control:focus ~ .input-group-prepend .input-group-text {
  border: 1px solid #ccc;
  border-left: none;
  background-color: transparent;
}
.has-success .form-control, .has-error .form-control, .has-success .form-control:focus, .has-error .form-control:focus {
  box-shadow: none;
}
.has-success .form-control {
  border: 1px solid #ccc;
  color: #66615b;
}
.has-success .form-control.form-control-success {
  padding-right: 2.5em !important;
}
.has-success .form-control:focus {
  border: 1px solid #6bd098;
  color: #6bd098;
}
.has-danger .form-control {
  background-color: #FFC0A4;
  border: 1px solid #ef8157;
  color: #ef8157;
}
.has-danger .form-control.form-control-danger {
  padding-right: 2.5em !important;
}
.has-danger .form-control:focus {
  background-color: #FFFFFF;
  border: 1px solid #ef8157;
}
.form-control + .form-control-feedback {
  border-radius: 6px;
  font-size: 14px;
  margin-top: -7px;
  position: absolute;
  right: 10px;
  top: 50%;
  vertical-align: middle;
}
.open .form-control {
  border-radius: 6px 6px 0 0;
  border-bottom-color: transparent;
}
.form-control + .input-group-append .input-group-text, .form-control + .input-group-prepend .input-group-text {
  background-color: #FFFFFF;
}

.form-group.no-border.form-control-lg .input-group-append .input-group-text,
.input-group.no-border.form-control-lg .input-group-append .input-group-text {
  padding: 15px 0 15px 11px;
}
.form-group.no-border.form-control-lg .form-control,
.input-group.no-border.form-control-lg .form-control {
  padding: 15px 11px;
}
.form-group.no-border.form-control-lg .form-control + .input-group-prepend .input-group-text, .form-group.no-border.form-control-lg .form-control + .input-group-append .input-group-text,
.input-group.no-border.form-control-lg .form-control + .input-group-prepend .input-group-text,
.input-group.no-border.form-control-lg .form-control + .input-group-append .input-group-text {
  padding: 15px 11px 15px 0;
}

.form-group.form-control-lg .form-control,
.input-group.form-control-lg .form-control {
  padding: 14px 10px;
}
.form-group.form-control-lg .form-control + .input-group-prepend .input-group-text, .form-group.form-control-lg .form-control + .input-group-append .input-group-text,
.input-group.form-control-lg .form-control + .input-group-prepend .input-group-text,
.input-group.form-control-lg .form-control + .input-group-append .input-group-text {
  padding: 14px 10px 14px 0;
}
.form-group.form-control-lg .input-group-prepend .input-group-text,
.form-group.form-control-lg .input-group-append .input-group-text,
.input-group.form-control-lg .input-group-prepend .input-group-text,
.input-group.form-control-lg .input-group-append .input-group-text {
  padding: 14px 0 15px 10px;
}
.form-group.form-control-lg .input-group-prepend .input-group-text + .form-control,
.form-group.form-control-lg .input-group-append .input-group-text + .form-control,
.input-group.form-control-lg .input-group-prepend .input-group-text + .form-control,
.input-group.form-control-lg .input-group-append .input-group-text + .form-control {
  padding: 15px 10px 15px 8px;
}

.form-group.no-border .form-control,
.input-group.no-border .form-control {
  padding: 11px 11px;
}
.form-group.no-border .form-control + .input-group-prepend .input-group-text, .form-group.no-border .form-control + .input-group-append .input-group-text,
.input-group.no-border .form-control + .input-group-prepend .input-group-text,
.input-group.no-border .form-control + .input-group-append .input-group-text {
  padding: 11px 11px 11px 0;
}
.form-group.no-border .input-group-prepend .input-group-text,
.form-group.no-border .input-group-append .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-append .input-group-text {
  padding: 11px 0 11px 11px;
}

.form-group .form-control,
.input-group .form-control {
  padding: 10px 10px 10px 10px;
}
.form-group .form-control + .input-group-prepend .input-group-text, .form-group .form-control + .input-group-append .input-group-text,
.input-group .form-control + .input-group-prepend .input-group-text,
.input-group .form-control + .input-group-append .input-group-text {
  padding: 10px 10px 10px 0;
}
.form-group .input-group-prepend .input-group-text,
.form-group .input-group-append .input-group-text,
.input-group .input-group-prepend .input-group-text,
.input-group .input-group-append .input-group-text {
  padding: 10px 0 10px 10px;
}
.form-group .input-group-prepend .input-group-text + .form-control, .form-group .input-group-prepend .input-group-text ~ .form-control,
.form-group .input-group-append .input-group-text + .form-control,
.form-group .input-group-append .input-group-text ~ .form-control,
.input-group .input-group-prepend .input-group-text + .form-control,
.input-group .input-group-prepend .input-group-text ~ .form-control,
.input-group .input-group-append .input-group-text + .form-control,
.input-group .input-group-append .input-group-text ~ .form-control {
  padding: 10px 11px 11px 8px;
}

.input-group.has-success .input-group-prepend .input-group-text,
.input-group.has-success .input-group-append .input-group-text {
  border: 1px solid #ccc;
  color: #66615b;
  background-color: #FFFFFF;
  border-right: none;
}

.form-group.no-border .form-control,
.form-group.no-border .form-control + .input-group-prepend .input-group-text,
.form-group.no-border .form-control + .input-group-append .input-group-text,
.input-group.no-border .form-control,
.input-group.no-border .form-control + .input-group-prepend .input-group-text,
.input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
  border: medium none;
}
.form-group.no-border .form-control:focus, .form-group.no-border .form-control:active, .form-group.no-border .form-control:active,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.form-group.no-border .form-control + .input-group-append .input-group-text:active,
.form-group.no-border .form-control + .input-group-append .input-group-text:active,
.input-group.no-border .form-control:focus,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.input-group.no-border .form-control + .input-group-append .input-group-text:active,
.input-group.no-border .form-control + .input-group-append .input-group-text:active {
  border: medium none;
  background-color: rgba(222, 222, 222, 0.5);
}
.form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}
.form-group.no-border .input-group-prepend .input-group-text,
.form-group.no-border .input-group-append .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
  border: none;
}

.has-error .form-control-feedback, .has-error .control-label {
  color: #ef8157;
}

.has-success .form-control-feedback, .has-success .control-label {
  color: #6bd098;
}

.input-group.has-danger .input-group-prepend {
  border-radius: 4px;
}
.input-group.has-danger .input-group-prepend .input-group-text {
  border: 1px solid #ef8157;
  border-right: none;
}
.input-group.has-danger .error {
  display: block;
  width: 100%;
  color: #ef8157;
  margin-top: 3px;
}

.input-group.has-success .input-group-prepend {
  border-radius: 4px;
}
.input-group.has-success .input-group-prepend .input-group-text {
  border-right: none;
}

.input-group-focus .input-group-prepend .input-group-text,
.input-group-focus .input-group-append .input-group-text {
  background-color: #FFFFFF;
  border-color: #9A9A9A;
}
.input-group-focus.no-border .input-group-prepend .input-group-text,
.input-group-focus.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}
.input-group-focus.has-danger .input-group-append .input-group-text,
.input-group-focus.has-danger .input-group-prepend .input-group-text {
  background-color: #FFC0A4;
}
.input-group-focus.has-success .input-group-append .input-group-text,
.input-group-focus.has-success .input-group-prepend .input-group-text {
  background-color: #ABF3CB;
  border: 1px solid #6bd098;
  border-right: none;
}

.input-group-append .input-group-text,
.input-group-prepend .input-group-text {
  background-color: transparent;
  border: 1px solid #E3E3E3;
  color: #66615B;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
}
.input-group-append .input-group-text i,
.input-group-prepend .input-group-text i {
  opacity: 0.5;
}
.has-danger .input-group-append .input-group-text,
.has-danger .input-group-prepend .input-group-text {
  background-color: #FFC0A4;
}
.has-success .input-group-append .input-group-text,
.has-success .input-group-prepend .input-group-text {
  background-color: #ABF3CB;
}
.has-danger.input-group-focus .input-group-append .input-group-text,
.has-danger.input-group-focus .input-group-prepend .input-group-text {
  background-color: #FFFFFF;
  color: #ef8157;
}
.has-success.input-group-focus .input-group-append .input-group-text,
.has-success.input-group-focus .input-group-prepend .input-group-text {
  background-color: #FFFFFF;
  color: #6bd098;
}
.has-danger .form-control:focus + .input-group-append .input-group-text,
.has-danger .form-control:focus + .input-group-prepend .input-group-text {
  color: #ef8157;
}
.has-success .form-control:focus + .input-group-append .input-group-text,
.has-success .form-control:focus + .input-group-prepend .input-group-text {
  color: #6bd098;
}
.input-group-append .input-group-text + .form-control, .input-group-append .input-group-text ~ .form-control,
.input-group-prepend .input-group-text + .form-control,
.input-group-prepend .input-group-text ~ .form-control {
  padding: -0.5rem 0.7rem;
  padding-left: 18px;
}
.input-group-append .input-group-text i,
.input-group-prepend .input-group-text i {
  width: 17px;
}

.input-group-append,
.input-group-prepend {
  margin: 0;
}

.input-group-append .input-group-text {
  border-left: none;
}

.input-group-prepend .input-group-text {
  border-right: none;
}

.input-group,
.form-group {
  margin-bottom: 10px;
  position: relative;
}
.input-group .form-control-static,
.form-group .form-control-static {
  margin-top: 9px;
}
.input-group.has-danger .error,
.form-group.has-danger .error {
  color: #ef8157;
}

.input-group[disabled] .input-group-prepend .input-group-text,
.input-group[disabled] .input-group-append .input-group-text {
  background-color: #E3E3E3;
}

.input-group .form-control:not(:first-child):not(:last-child), .input-group-btn:not(:first-child):not(:last-child) {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0 none;
}

.input-group .form-control:first-child,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-right: 0 none;
}

.input-group .form-control:last-child,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child) {
  border-left: 0 none;
}

.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
  background-color: #E3E3E3;
  color: #66615B;
  cursor: not-allowed;
}

.input-group-btn .btn {
  border-width: 1px;
  padding: 11px 0.7rem;
}

.input-group-btn .btn-default:not(.btn-fill) {
  border-color: #DDDDDD;
}

.input-group-btn:last-child > .btn {
  margin-left: 0;
}

textarea.form-control {
  max-width: 100%;
  max-height: 80px;
  padding: 10px 10px 0 0;
  resize: none;
  border: none;
  border: 1px solid #E3E3E3;
  border-radius: 4px;
  line-height: 2;
}

.has-success.form-group .form-control, .has-success.form-group.no-border .form-control,
.has-danger.form-group .form-control,
.has-danger.form-group.no-border .form-control {
  padding-right: 32px;
}

.form.form-newsletter .form-group {
  float: left;
  width: 78%;
  margin-right: 2%;
  margin-top: 9px;
}

.input-group .input-group-btn {
  padding: 0 12px;
}

.form-group input[type=file] {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.form-text {
  font-size: 0.8571em;
}

.form-control-lg {
  padding: 0;
  font-size: inherit;
  line-height: 0;
  border-radius: 0;
}

.form-horizontal .col-form-label,
.form-horizontal .label-on-right {
  padding: 10px 5px 0 15px;
  text-align: right;
  max-width: 180px;
}
.form-horizontal .checkbox-radios {
  margin-bottom: 15px;
}
.form-horizontal .checkbox-radios .form-check:first-child {
  margin-top: 8px;
}
.form-horizontal .label-on-right {
  text-align: left;
  padding: 10px 15px 0 5px;
}
.form-horizontal .form-check-inline {
  margin-top: 6px;
}

button,
input,
optgroup,
select,
textarea {
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 400;
}

a {
  color: #51cbce;
}
a:hover, a:focus {
  color: #51cbce;
}

h1, .h1 {
  font-size: 3.5em;
  line-height: 1.15;
  margin-bottom: 30px;
}
h1 small, .h1 small {
  font-weight: 700;
  text-transform: uppercase;
  opacity: 0.8;
}

h2, .h2 {
  font-size: 2.5em;
  margin-bottom: 30px;
}

h3, .h3 {
  font-size: 2em;
  margin-bottom: 30px;
  line-height: 1.4em;
}

h4, .h4 {
  font-size: 1.714em;
  line-height: 1.45em;
  margin-top: 30px;
  margin-bottom: 15px;
}
h4 + .category, h4.title + .category, .h4 + .category, .h4.title + .category {
  margin-top: -10px;
}

h5, .h5 {
  font-size: 1.57em;
  line-height: 1.4em;
  margin-bottom: 15px;
}

h6, .h6 {
  font-size: 1em;
  font-weight: 700;
  text-transform: uppercase;
}

p.description {
  font-size: 1.14em;
}

.title {
  font-weight: 700;
}
.title.title-up {
  text-transform: uppercase;
}
.title.title-up a {
  color: #2c2c2c;
  text-decoration: none;
}
.title + .category {
  margin-top: -10px;
}

.description,
.card-description,
.footer-big p,
.card .footer .stats {
  color: #9A9A9A;
  font-weight: 300;
}

.category,
.card-category {
  text-transform: capitalize;
  font-weight: 400;
  color: #9A9A9A;
  font-size: 0.7142em;
}

.card-category {
  font-size: 1em;
}

.text-primary,
a.text-primary:focus, a.text-primary:hover {
  color: #51cbce !important;
}

.text-info,
a.text-info:focus, a.text-info:hover {
  color: #2d3e75 !important;
}

.text-success,
a.text-success:focus, a.text-success:hover {
  color: #6bd098 !important;
}

.text-warning,
a.text-warning:focus, a.text-warning:hover {
  color: #fbc658 !important;
}

.text-danger,
a.text-danger:focus, a.text-danger:hover {
  color: #ef8157 !important;
}

.text-gray,
a.text-gray:focus, a.text-gray:hover {
  color: #E3E3E3 !important;
}

.blockquote {
  border-left: none;
  border: 1px solid #66615B;
  padding: 20px;
  font-size: 1.1em;
  line-height: 1.8;
}
.blockquote small {
  color: #66615B;
  font-size: 0.8571em;
  text-transform: uppercase;
}
.blockquote.blockquote-primary {
  border-color: #51cbce;
  color: #51cbce;
}
.blockquote.blockquote-primary small {
  color: #51cbce;
}
.blockquote.blockquote-danger {
  border-color: #ef8157;
  color: #ef8157;
}
.blockquote.blockquote-danger small {
  color: #ef8157;
}
.blockquote.blockquote-white {
  border-color: rgba(255, 255, 255, 0.8);
  color: #FFFFFF;
}
.blockquote.blockquote-white small {
  color: rgba(255, 255, 255, 0.8);
}

body {
  color: #2c2c2c;
  font-size: 14px;
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

.main {
  position: relative;
  background: #FFFFFF;
}

/* Animations */
.nav-pills .nav-link,
.navbar,
.nav-tabs .nav-link,
.sidebar .nav a,
.sidebar .nav a i,
.animation-transition-general,
.sidebar .logo a.logo-mini,
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-normal,
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize,
.tag,
.tag [data-role=remove],
.animation-transition-general,
.off-canvas-sidebar .logo a.logo-normal {
  transition: all 300ms ease 0s;
}

.dropdown-toggle:after,
.bootstrap-switch-label:before,
.caret {
  transition: all 150ms ease 0s;
}

.dropdown-toggle[aria-expanded=true]:after,
a[data-toggle=collapse][aria-expanded=true] .caret,
.card-collapse .card a[data-toggle=collapse][aria-expanded=true] i,
.card-collapse .card a[data-toggle=collapse].expanded i {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.button-bar {
  display: block;
  position: relative;
  width: 22px;
  height: 1px;
  border-radius: 1px;
  background: #FFFFFF;
}
.button-bar + .button-bar {
  margin-top: 7px;
}
.button-bar:nth-child(2) {
  width: 17px;
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\\9 ;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.offline-doc .navbar.navbar-transparent {
  padding-top: 25px;
  border-bottom: none;
}
.offline-doc .navbar.navbar-transparent .navbar-minimize {
  display: none;
}
.offline-doc .navbar.navbar-transparent .navbar-brand,
.offline-doc .navbar.navbar-transparent .collapse .navbar-nav .nav-link {
  color: #FFFFFF !important;
}
.offline-doc .footer {
  z-index: 3 !important;
}
.offline-doc .page-header .container {
  z-index: 3;
}
.offline-doc .page-header:after {
  background-color: rgba(0, 0, 0, 0.5);
  content: "";
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
}

.fixed-plugin .dropdown-menu li {
  padding: 2px !important;
}

.badge.badge-default {
  border-color: #66615B;
  background-color: #66615B;
}
.badge.badge-primary {
  border-color: #51cbce;
  background-color: #51cbce;
}
.badge.badge-info {
  border-color: #2d3e75;
  background-color: #2d3e75;
}
.badge.badge-success {
  border-color: #6bd098;
  background-color: #6bd098;
}
.badge.badge-warning {
  border-color: #fbc658;
  background-color: #fbc658;
}
.badge.badge-danger {
  border-color: #ef8157;
  background-color: #ef8157;
}
.badge.badge-neutral {
  border-color: #FFFFFF;
  background-color: #FFFFFF;
  color: inherit;
}

.card-user form .form-group {
  margin-bottom: 20px;
}

.from-check,
.form-check-radio {
  margin-bottom: 12px;
  position: relative;
}

.form-check {
  padding-left: 0;
  margin-bottom: 0.5rem;
}
.form-check .form-check-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 35px;
  line-height: 26px;
  margin-bottom: 0;
}
.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
  content: " ";
  display: inline-block;
  position: absolute;
  width: 24px;
  height: 24px;
  left: 0;
  cursor: pointer;
  border-radius: 6px;
  top: 0;
  background-color: #AAA7A4;
  transition: opacity 0.3s linear;
}
.form-check .form-check-sign::after {
  font-family: "FontAwesome";
  content: "\\f00c";
  top: -1px;
  text-align: center;
  font-size: 15px;
  opacity: 0;
  color: #FFF;
  border: 0;
  background-color: inherit;
}
.form-check.disabled .form-check-label {
  color: #9A9A9A;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check input[type=checkbox],
.form-check-radio input[type=radio] {
  opacity: 0;
  position: absolute;
  visibility: hidden;
}

.form-check input[type=checkbox]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-control input[type=checkbox]:disabled + .form-check-sign::before,
.checkbox input[type=checkbox]:disabled + .form-check-sign::after {
  cursor: not-allowed;
}

.form-check .form-check-label input[type=checkbox]:disabled + .form-check-sign,
.form-check-radio input[type=radio]:disabled + .form-check-sign {
  pointer-events: none !important;
}

.form-check-radio {
  margin-left: -3px;
}
.form-check-radio .form-check-label {
  padding-left: 2rem;
}
.form-check-radio.disabled .form-check-label {
  color: #9A9A9A;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check-radio .form-check-sign::before {
  font-family: "FontAwesome";
  content: "\\f10c";
  font-size: 22px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  position: absolute;
  opacity: 0.5;
  left: 5px;
  top: -5px;
}

.form-check-label input[type=checkbox]:checked + .form-check-sign:before {
  background-color: #66615B;
}

.form-check-radio input[type=radio] + .form-check-sign:after,
.form-check-radio input[type=radio] {
  opacity: 0;
  transition: opacity 0.3s linear;
  content: " ";
  display: block;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  font-family: "FontAwesome";
  content: "\\f192";
  top: -5px;
  position: absolute;
  left: 5px;
  opacity: 1;
  font-size: 22px;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign::before,
.form-check-radio input[type=radio]:disabled + .form-check-sign::after {
  color: #9A9A9A;
}

.navbar {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  min-height: 53px;
  margin-bottom: 20px;
}
.navbar a {
  vertical-align: middle;
}
.navbar a:not(.btn):not(.dropdown-item) {
  color: #FFFFFF;
}
.navbar a.dropdown-item {
  color: #66615B;
}
.navbar.bg-white .input-group .form-control,
.navbar.bg-white .input-group.no-border .form-control {
  color: #66615B;
}
.navbar.bg-white .input-group .form-control ::-moz-placeholder,
.navbar.bg-white .input-group.no-border .form-control ::-moz-placeholder {
  color: #66615B;
}
.navbar.bg-white .input-group .form-control :-ms-input-placeholder,
.navbar.bg-white .input-group.no-border .form-control :-ms-input-placeholder {
  color: #66615B;
}
.navbar.bg-white .input-group .form-control ::-webkit-input-placeholder,
.navbar.bg-white .input-group.no-border .form-control ::-webkit-input-placeholder {
  color: #66615B;
}
.navbar.bg-white .input-group-prepend .input-group-text i,
.navbar.bg-white .input-group-append .input-group-text i {
  color: #66615B;
  opacity: 0.5;
}
.navbar .form-group,
.navbar .input-group {
  margin: 0;
  margin-left: -3px;
  margin-right: 5px;
}
.navbar .form-group .form-group-addon,
.navbar .form-group .input-group-prepend .input-group-text,
.navbar .form-group .input-group-append .input-group-text,
.navbar .input-group .form-group-addon,
.navbar .input-group .input-group-prepend .input-group-text,
.navbar .input-group .input-group-append .input-group-text {
  color: #66615B;
}
.navbar .form-group .form-group-addon i,
.navbar .form-group .input-group-prepend .input-group-text i,
.navbar .form-group .input-group-append .input-group-text i,
.navbar .input-group .form-group-addon i,
.navbar .input-group .input-group-prepend .input-group-text i,
.navbar .input-group .input-group-append .input-group-text i {
  opacity: 1;
}
.navbar .form-group.no-border .form-control,
.navbar .input-group.no-border .form-control {
  color: #66615B;
}
.navbar .form-group.no-border .form-control ::-moz-placeholder,
.navbar .input-group.no-border .form-control ::-moz-placeholder {
  color: #66615B;
}
.navbar .form-group.no-border .form-control :-ms-input-placeholder,
.navbar .input-group.no-border .form-control :-ms-input-placeholder {
  color: #66615B;
}
.navbar .form-group.no-border .form-control ::-webkit-input-placeholder,
.navbar .input-group.no-border .form-control ::-webkit-input-placeholder {
  color: #66615B;
}
.navbar p {
  display: inline-block;
  margin: 0;
  line-height: 1.8em;
  font-size: 1em;
  font-weight: 400;
}
.navbar.navbar-absolute {
  position: absolute;
  width: 100%;
  padding-top: 10px;
  z-index: 1029;
}
.documentation .navbar.fixed-top {
  left: 0;
  width: auto;
  width: initial;
}
.navbar .navbar-wrapper {
  display: inline-flex;
  align-items: center;
}
.navbar .navbar-wrapper .navbar-minimize {
  padding-right: 10px;
}
.navbar .navbar-wrapper .navbar-minimize .btn {
  margin: 0;
}
.navbar .navbar-wrapper .navbar-toggle .navbar-toggler {
  padding-left: 0;
}
.navbar .navbar-wrapper .navbar-toggle:hover .navbar-toggler-bar.bar2 {
  width: 22px;
}
.navbar .navbar-nav.navbar-logo {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 49px;
  top: -4px;
}
.navbar .navbar-nav .nav-link.btn {
  padding: 11px 22px;
}
.navbar .navbar-nav .nav-link.btn.btn-lg {
  padding: 15px 48px;
}
.navbar .navbar-nav .nav-link.btn.btn-sm {
  padding: 5px 15px;
}
.navbar .navbar-nav .nav-link {
  text-transform: uppercase;
  font-size: 0.7142em;
  padding: 0.5rem 0.7rem;
  line-height: 1.625rem;
  margin-right: 3px;
}
.navbar .navbar-nav .nav-link i.fa + p,
.navbar .navbar-nav .nav-link i.nc-icon + p {
  margin-left: 3px;
}
.navbar .navbar-nav .nav-link i.fa,
.navbar .navbar-nav .nav-link i.nc-icon {
  font-size: 18px;
  position: relative;
  top: 3px;
  text-align: center;
  width: 21px;
}
.navbar .navbar-nav .nav-link i.nc-icon {
  top: 4px;
  font-size: 16px;
}
.navbar .navbar-nav .nav-link.profile-photo .profile-photo-small {
  width: 27px;
  height: 27px;
}
.navbar .navbar-nav .nav-link.disabled {
  opacity: 0.5;
  color: #FFFFFF;
}
.navbar .navbar-nav .nav-item.active .nav-link:not(.btn),
.navbar .navbar-nav .nav-item .nav-link:not(.btn):focus,
.navbar .navbar-nav .nav-item .nav-link:not(.btn):hover,
.navbar .navbar-nav .nav-item .nav-link:not(.btn):active {
  border-radius: 3px;
  color: #66615B;
}
.navbar .logo-container {
  width: 27px;
  height: 27px;
  overflow: hidden;
  margin: 0 auto;
  border-radius: 50%;
  border: 1px solid transparent;
}
.navbar .navbar-brand {
  text-transform: capitalize;
  font-size: 20px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  line-height: 1.625rem;
}
.navbar .navbar-toggler {
  width: 37px;
  height: 27px;
  vertical-align: middle;
  outline: 0;
  cursor: pointer;
}
.navbar .navbar-toggler .navbar-toggler-bar.navbar-kebab {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  margin: 0 auto;
}
.navbar .button-dropdown .navbar-toggler-bar:nth-child(2) {
  width: 17px;
}
.navbar.navbar-transparent {
  background-color: transparent !important;
  box-shadow: none;
  border-bottom: 1px solid #ddd;
}
.navbar.navbar-transparent a:not(.dropdown-item):not(.btn) {
  color: #66615B;
}
.navbar.navbar-transparent a:not(.dropdown-item):not(.btn).disabled {
  opacity: 0.5;
  color: #66615B;
}
.navbar.navbar-transparent .button-bar {
  background: #66615B;
}
.navbar.navbar-transparent .nav-item .nav-link:not(.btn) {
  color: #66615B;
}
.navbar.navbar-transparent .nav-item.active .nav-link:not(.btn),
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):focus,
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):hover,
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):focus:hover,
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):active {
  color: #51cbce;
}
.navbar.bg-white a:not(.dropdown-item):not(.btn) {
  color: #66615B;
}
.navbar.bg-white a:not(.dropdown-item):not(.btn).disabled {
  opacity: 0.5;
  color: #66615B;
}
.navbar.bg-white .button-bar {
  background: #66615B;
}
.navbar.bg-white .nav-item.active .nav-link:not(.btn),
.navbar.bg-white .nav-item .nav-link:not(.btn):focus,
.navbar.bg-white .nav-item .nav-link:not(.btn):hover,
.navbar.bg-white .nav-item .nav-link:not(.btn):active {
  color: #2d3e75;
}
.navbar.bg-white .logo-container {
  border: 1px solid #66615B;
}
.navbar .navbar-collapse .nav-item a {
  font-size: 14px;
}

.bg-default {
  background-color: #66615B !important;
}

.bg-primary {
  background-color: #51cbce !important;
}

.bg-info {
  background-color: #2d3e75 !important;
}

.bg-success {
  background-color: #6bd098 !important;
}

.bg-danger {
  background-color: #ef8157 !important;
}

.bg-warning {
  background-color: #fbc658 !important;
}

.bg-white {
  background-color: #FFFFFF !important;
}

.page-header {
  min-height: 100vh;
  max-height: 1000px;
  padding: 0;
  color: #FFFFFF;
  position: relative;
}
.page-header .page-header-image {
  position: absolute;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.page-header .content-center {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #FFFFFF;
  padding: 0 15px;
  width: 100%;
  max-width: 880px;
}
.page-header footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.page-header .container {
  height: 100%;
  z-index: 1;
}
.page-header .category,
.page-header .description {
  color: rgba(255, 255, 255, 0.8);
}
.page-header.page-header-small {
  min-height: 60vh;
  max-height: 440px;
}
.page-header.page-header-mini {
  min-height: 40vh;
  max-height: 340px;
}
.page-header .title {
  margin-bottom: 15px;
}
.page-header .title + h4 {
  margin-top: 10px;
}
.page-header:after, .page-header:before {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
}
.page-header:before {
  background-color: rgba(0, 0, 0, 0.3);
}
.page-header[filter-color=orange] {
  background: rgba(44, 44, 44, 0.2); /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
  background: linear-gradient(0deg, rgba(44, 44, 44, 0.2), rgba(224, 23, 3, 0.6)); /* Standard syntax */
}

.dropdown .dropdown-menu,
.dropup .dropdown-menu,
.bootstrap-select .dropdown-menu {
  display: block;
  opacity: 0;
  filter: alpha(opacity=0);
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);
  visibility: hidden;
  position: absolute;
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;
}
.dropdown .dropdown-menu[x-placement=top-start],
.dropup .dropdown-menu[x-placement=top-start],
.bootstrap-select .dropdown-menu[x-placement=top-start] {
  transform: translate3d(-20px, 0px, 0) !important;
}
.dropdown .dropdown-menu[x-placement=bottom-start],
.dropup .dropdown-menu[x-placement=bottom-start],
.bootstrap-select .dropdown-menu[x-placement=bottom-start] {
  transform: translate3d(-20px, 0px, 0) !important;
}
.dropdown.show .dropdown-menu,
.dropup.show .dropdown-menu,
.bootstrap-select.show .dropdown-menu {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
}
.dropdown.show .dropdown-menu[x-placement=top-start],
.dropup.show .dropdown-menu[x-placement=top-start],
.bootstrap-select.show .dropdown-menu[x-placement=top-start] {
  transform: translate3d(-20px, -50px, 0) !important;
  top: auto !important;
  bottom: 0 !important;
}
.dropdown.show .dropdown-menu[x-placement=bottom-start],
.dropup.show .dropdown-menu[x-placement=bottom-start],
.bootstrap-select.show .dropdown-menu[x-placement=bottom-start] {
  transform: translate3d(-20px, 50px, 0) !important;
  bottom: auto !important;
  top: 0 !important;
}

.dropup .dropdown-menu,
.dropdown-btn .dropdown-menu {
  transform: translate3d(-20px, 0px, 0) !important;
  top: auto !important;
  bottom: 0 !important;
}

.dropup.show .dropdown-menu,
.dropdown-btn.show .dropdown-menu {
  opacity: 1;
  visibility: visible;
}
.dropup.show .dropdown-menu .dropdown-menu.inner,
.dropdown-btn.show .dropdown-menu .dropdown-menu.inner {
  transform: translate3d(0, 0px, 0) !important;
}

.bootstrap-select.show .dropdown-menu.show[x-placement=top-start] {
  transform: translate3d(-20px, -60px, 0) !important;
  top: auto !important;
  bottom: 0 !important;
}
.bootstrap-select.show .dropdown-menu.show li:last-child a:hover {
  border-radius: 0 0 12px 12px;
}

.bootstrap-select.dropup.show:before {
  top: -1px !important;
}
.bootstrap-select.dropup.show:after {
  top: -2px !important;
}

.dropdown-menu {
  background-color: #FFFFFF;
  border: 0 none;
  border-radius: 12px;
  margin-top: 10px;
  padding: 0px;
}
.dropdown-menu .divider {
  background-color: #F1EAE0;
  margin: 0px;
}
.dropdown-menu .dropdown-header {
  color: #9A9A9A;
  font-size: 0.8571em;
  padding: 10px 15px;
}
.dropdown-menu .no-notification {
  color: #9A9A9A;
  font-size: 1.2em;
  padding: 30px 30px;
  text-align: center;
}
.dropdown-menu .dropdown-item {
  color: #66615b;
  font-size: 14px;
  padding: 10px 45px 10px 15px;
  clear: both;
  white-space: nowrap;
  width: 100%;
  display: block;
}
.dropdown-menu .dropdown-item img {
  margin-top: -3px;
}
.dropdown-menu .dropdown-item:focus {
  outline: 0 !important;
}
.btn-group.select .dropdown-menu {
  min-width: 100%;
}
.dropdown-menu .dropdown-item:first-child {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.dropdown-menu .dropdown-item:last-child {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.select .dropdown-menu .dropdown-item:first-child {
  border-radius: 0;
  border-bottom: 0 none;
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  color: #FFFFFF !important;
  opacity: 1;
  text-decoration: none;
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  background-color: #66615B;
}
.dropdown-menu.dropdown-primary .dropdown-item:hover, .dropdown-menu.dropdown-primary .dropdown-item:focus {
  background-color: #6dd3d6;
}
.dropdown-menu.dropdown-info .dropdown-item:hover, .dropdown-menu.dropdown-info .dropdown-item:focus {
  background-color: #374c8f;
}
.dropdown-menu.dropdown-success .dropdown-item:hover, .dropdown-menu.dropdown-success .dropdown-item:focus {
  background-color: #86d9ab;
}
.dropdown-menu.dropdown-warning .dropdown-item:hover, .dropdown-menu.dropdown-warning .dropdown-item:focus {
  background-color: #fcd27b;
}
.dropdown-menu.dropdown-danger .dropdown-item:hover, .dropdown-menu.dropdown-danger .dropdown-item:focus {
  background-color: #f29978;
}

.dropdown-divider {
  margin: 0 !important;
}

.btn-group.select.open {
  overflow: visible;
}

.dropdown-menu-right {
  right: -2px;
  left: auto;
}

.navbar-nav .dropdown-menu:before,
.dropdown .dropdown-menu[x-placement=bottom-start]:before,
.dropdown .dropdown-menu[x-placement=bottom-end]:before,
.card.card-just-text .dropdown .dropdown-menu:before,
.card-just-text .dropdown .dropdown-menu:before,
.dropdown-btn .dropdown-menu:before {
  border-bottom: 11px solid #F1EAE0;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -12px;
}

.navbar-nav .dropdown-menu:after,
.dropdown .dropdown-menu[x-placement=bottom-start]:after,
.dropdown .dropdown-menu[x-placement=bottom-end]:after,
.card.card-just-text .dropdown .dropdown-menu:after,
.card-just-text .dropdown .dropdown-menu:after,
.dropdown-btn .dropdown-menu:after {
  border-bottom: 11px solid #FFFFFF;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -11px;
}

.dropdown .dropdown-menu.dropdown-notification[x-placement=top-start]:before,
.dropdown .dropdown-menu.dropdown-notification[x-placement=bottom-start]:before {
  left: 30px !important;
  right: auto;
}

.dropdown .dropdown-menu.dropdown-notification[x-placement=top-start]:after,
.dropdown .dropdown-menu.dropdown-notification[x-placement=bottom-start]:after {
  left: 30px !important;
  right: auto;
}

@media screen and (min-width: 768px) {
  .navbar-form {
    margin-top: 21px;
    margin-bottom: 21px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .navbar-search-form {
    display: none;
  }
  .navbar-nav .dropdown-item .dropdown-menu,
  .dropdown .dropdown-menu,
  .dropdown-btn .dropdown-menu {
    transform: translate3d(0px, -40px, 0px);
    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;
  }
  .navbar-nav .dropdown-item.show .dropdown-menu,
  .dropdown.show .dropdown-menu,
  .dropdown-btn.show .dropdown-menu {
    transform: translate3d(0px, 0px, 0px);
    visibility: visible !important;
  }
  .bootstrap-select .dropdown-menu {
    transition: all 150ms linear;
  }
  .bootstrap-datetimepicker-widget {
    visibility: visible !important;
  }
  .bootstrap-select .show .dropdown-menu {
    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;
    transform: translate3d(0px, 0px, 0px);
  }
  .navbar-nav.navbar-right li .dropdown-menu:before,
  .navbar-nav.navbar-right li .dropdown-menu:after {
    left: auto;
    right: 12px;
  }
  .footer:not(.footer-big) nav ul li:first-child {
    margin-left: 0;
  }
  body > .navbar-collapse.collapse {
    display: none !important;
  }
}
.dropdown-sharing .dropup-item {
  color: #66615b;
  font-size: 14px;
}
.dropdown-sharing .dropup-item .social-line {
  line-height: 28px;
  padding: 10px 20px 5px 20px !important;
}
.dropdown-sharing .dropup-item .social-line [class*=icon-] {
  font-size: 20px;
}
.dropdown-sharing .dropup-item:last-child {
  margin: 0 13px;
  display: block;
}
.dropdown-sharing .dropup-item .btn {
  margin: 10px;
}
.dropdown-sharing .dropup-item:hover .social-line,
.dropdown-sharing .dropup-item:hover .action-line,
.dropdown-sharing .dropup-item:focus .social-line,
.dropdown-sharing .dropup-item:focus .action-line {
  background-color: #FFFFFF;
  color: #66615b;
  opacity: 1;
  text-decoration: none;
}

.show .dropdown-sharing,
.show .dropdown-actions {
  margin-bottom: 1px;
}

.dropdown-actions .dropdown-item {
  margin: -15px 35px;
}
.dropdown-actions .dropdown-item .action-line {
  padding: 5px 10px;
  line-height: 24px;
  font-weight: bold;
}
.dropdown-actions .dropdown-item .action-line [class*=icon-] {
  font-size: 24px;
}
.dropdown-actions .dropdown-item .action-line .col-sm-9 {
  line-height: 34px;
}
.dropdown-actions .dropdown-item .link-danger {
  color: #ef8157;
}
.dropdown-actions .dropdown-item .link-danger:hover, .dropdown-actions .dropdown-item .link-danger:active, .dropdown-actions .dropdown-item .link-danger:focus {
  color: #ef8157;
}
.dropdown-actions li:hover a,
.dropdown-actions li:focus a {
  color: #66615b;
  opacity: 1;
  text-decoration: none;
}
.dropdown-actions .action-line .icon-simple {
  margin-left: -15px;
}

.dropdown .dropdown-menu[x-placement=top-start]:before,
.dropdown .dropdown-menu[x-placement=top-end]:before,
.dropup .dropdown-menu:before {
  border-top: 11px solid #DCD9D1;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  bottom: -12px;
}

.dropdown .dropdown-menu[x-placement=top-start]:after,
.dropdown .dropdown-menu[x-placement=top-end]:after,
.dropup .dropdown-menu:after {
  border-top: 11px solid #FFF;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  bottom: -11px;
}

.dropup .dropdown-toggle:after,
.dropdown .dropdown-toggle:after {
  margin-left: 0;
}

.dropdown-notification .dropdown-notification-list .notification-item {
  border-bottom: 1px solid #F1EAE0;
  font-size: 16px;
  color: #66615b;
}
.dropdown-notification .dropdown-notification-list .notification-item .notification-text {
  padding-left: 40px;
  position: relative;
  min-width: 330px;
  min-height: 70px;
  white-space: normal;
}
.dropdown-notification .dropdown-notification-list .notification-item .notification-text .label {
  display: block;
  position: absolute;
  top: 50%;
  margin-top: -12px;
  left: 7px;
}
.dropdown-notification .dropdown-notification-list .notification-item .notification-text .message {
  font-size: 0.9em;
  line-height: 0.7;
  margin-left: 10px;
}
.dropdown-notification .dropdown-notification-list .notification-item .notification-text .time {
  color: #9A9A9A;
  font-size: 0.7em;
  margin-left: 10px;
}
.dropdown-notification .dropdown-notification-list .notification-item .read-notification {
  font-size: 12px;
  opacity: 0;
  position: absolute;
  right: 5px;
  top: 50%;
  margin-top: -12px;
}
.dropdown-notification .dropdown-notification-list .notification-item:hover {
  text-decoration: none;
}
.dropdown-notification .dropdown-notification-list .notification-item:hover .notification-text {
  color: #66615b;
  background-color: #F0EFEB !important;
}
.dropdown-notification .dropdown-notification-list .notification-item:hover .read-notification {
  opacity: 1 !important;
}
.dropdown-notification .dropdown-footer {
  background-color: #E8E7E3;
  border-radius: 0 0 8px 8px;
}
.dropdown-notification .dropdown-footer .dropdown-footer-menu {
  list-style: outside none none;
  padding: 0px 5px;
}
.dropdown-notification .dropdown-footer .dropdown-footer-menu li {
  display: inline-block;
  text-align: left;
  padding: 0 10px;
}
.dropdown-notification .dropdown-footer .dropdown-footer-menu li a {
  color: #9C9B99;
  font-size: 0.9em;
  line-height: 35px;
}

.alert {
  border: 0;
  border-radius: 3px;
  color: #FFFFFF;
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
  position: relative;
}
.alert.alert-success {
  background-color: #7ed6a5;
}
.alert.alert-danger {
  background-color: #f1926e;
}
.alert.alert-warning {
  background-color: #fccf71;
}
.alert.alert-info {
  background-color: #344887;
}
.alert.alert-primary {
  background-color: #65d1d4;
}
.alert .close {
  color: #FFFFFF;
  opacity: 0.9;
  text-shadow: none;
  line-height: 0;
  outline: 0;
}
.alert .close i.fa,
.alert .close i.nc-icon {
  font-size: 14px !important;
}
.alert .close:hover, .alert .close:focus {
  opacity: 1;
}
.alert span[data-notify=icon] {
  font-size: 27px;
  display: block;
  left: 19px;
  position: absolute;
  top: 50%;
  margin-top: -11px;
}
.alert button.close {
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -13px;
  width: 25px;
  height: 25px;
  padding: 3px;
}
.alert .close ~ span {
  display: block;
  max-width: 89%;
}
.alert.alert-with-icon {
  padding-left: 65px;
}

img {
  max-width: 100%;
  border-radius: 3px;
}

.img-raised {
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}

/*--------------------------------

nucleo-icons Web Font - built using nucleoapp.com
License - nucleoapp.com/license/

-------------------------------- */
@font-face {
  font-family: "nucleo-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
/*------------------------
	base class definition
-------------------------*/
.nc-icon {
  display: inline-block;
  font: normal normal normal 14px/1 "nucleo-icons";
  font-size: inherit;
  speak: none;
  text-transform: none;
  /* Better Font Rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/*------------------------
  change icon size
-------------------------*/
.nc-icon.lg {
  font-size: 1.33333333em;
  vertical-align: -16%;
}

.nc-icon.x2 {
  font-size: 2em;
}

.nc-icon.x3 {
  font-size: 3em;
}

/*----------------------------------
  add a square/circle background
-----------------------------------*/
.nc-icon.square,
.nc-icon.circle {
  padding: 0.33333333em;
  vertical-align: -16%;
  background-color: #eee;
}

.nc-icon.circle {
  border-radius: 50%;
}

/*------------------------
  list icons
-------------------------*/
.nc-icon-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}

.nc-icon-ul > li {
  position: relative;
}

.nc-icon-ul > li > .nc-icon {
  position: absolute;
  left: -1.57142857em;
  top: 0.14285714em;
  text-align: center;
}

.nc-icon-ul > li > .nc-icon.lg {
  top: 0;
  left: -1.35714286em;
}

.nc-icon-ul > li > .nc-icon.circle,
.nc-icon-ul > li > .nc-icon.square {
  top: -0.19047619em;
  left: -1.9047619em;
}

/*------------------------
  spinning icons
-------------------------*/
.nc-icon.spin {
  animation: nc-icon-spin 2s infinite linear;
}
@keyframes nc-icon-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*------------------------
  rotated/flipped icons
-------------------------*/
.nc-icon.rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  transform: rotate(90deg);
}

.nc-icon.rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.nc-icon.rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  transform: rotate(270deg);
}

.nc-icon.flip-y {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);
  transform: scale(-1, 1);
}

.nc-icon.flip-x {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: scale(1, -1);
}

/*------------------------
	font icons
-------------------------*/
.nc-air-baloon::before {
  content: "\\ea01";
}

.nc-album-2::before {
  content: "\\ea02";
}

.nc-alert-circle-i::before {
  content: "\\ea04";
}

.nc-align-center::before {
  content: "\\ea03";
}

.nc-align-left-2::before {
  content: "\\ea05";
}

.nc-ambulance::before {
  content: "\\ea06";
}

.nc-app::before {
  content: "\\ea07";
}

.nc-atom::before {
  content: "\\ea08";
}

.nc-badge::before {
  content: "\\ea09";
}

.nc-bag-16::before {
  content: "\\ea0a";
}

.nc-bank::before {
  content: "\\ea0b";
}

.nc-basket::before {
  content: "\\ea0c";
}

.nc-bell-55::before {
  content: "\\ea0d";
}

.nc-bold::before {
  content: "\\ea0e";
}

.nc-book-bookmark::before {
  content: "\\ea0f";
}

.nc-bookmark-2::before {
  content: "\\ea10";
}

.nc-box-2::before {
  content: "\\ea11";
}

.nc-box::before {
  content: "\\ea12";
}

.nc-briefcase-24::before {
  content: "\\ea13";
}

.nc-bulb-63::before {
  content: "\\ea14";
}

.nc-bullet-list-67::before {
  content: "\\ea15";
}

.nc-bus-front-12::before {
  content: "\\ea16";
}

.nc-button-pause::before {
  content: "\\ea17";
}

.nc-button-play::before {
  content: "\\ea18";
}

.nc-button-power::before {
  content: "\\ea19";
}

.nc-calendar-60::before {
  content: "\\ea1a";
}

.nc-camera-compact::before {
  content: "\\ea1b";
}

.nc-caps-small::before {
  content: "\\ea1c";
}

.nc-cart-simple::before {
  content: "\\ea1d";
}

.nc-chart-bar-32::before {
  content: "\\ea1e";
}

.nc-chart-pie-36::before {
  content: "\\ea1f";
}

.nc-chat-33::before {
  content: "\\ea20";
}

.nc-check-2::before {
  content: "\\ea21";
}

.nc-circle-10::before {
  content: "\\ea22";
}

.nc-cloud-download-93::before {
  content: "\\ea23";
}

.nc-cloud-upload-94::before {
  content: "\\ea24";
}

.nc-compass-05::before {
  content: "\\ea25";
}

.nc-controller-modern::before {
  content: "\\ea26";
}

.nc-credit-card::before {
  content: "\\ea27";
}

.nc-delivery-fast::before {
  content: "\\ea28";
}

.nc-diamond::before {
  content: "\\ea29";
}

.nc-email-85::before {
  content: "\\ea2a";
}

.nc-favourite-28::before {
  content: "\\ea2b";
}

.nc-glasses-2::before {
  content: "\\ea2c";
}

.nc-globe-2::before {
  content: "\\ea2d";
}

.nc-globe::before {
  content: "\\ea2e";
}

.nc-hat-3::before {
  content: "\\ea2f";
}

.nc-headphones::before {
  content: "\\ea30";
}

.nc-html5::before {
  content: "\\ea31";
}

.nc-image::before {
  content: "\\ea32";
}

.nc-istanbul::before {
  content: "\\ea33";
}

.nc-key-25::before {
  content: "\\ea34";
}

.nc-laptop::before {
  content: "\\ea35";
}

.nc-layout-11::before {
  content: "\\ea36";
}

.nc-lock-circle-open::before {
  content: "\\ea37";
}

.nc-map-big::before {
  content: "\\ea38";
}

.nc-minimal-down::before {
  content: "\\ea39";
}

.nc-minimal-left::before {
  content: "\\ea3a";
}

.nc-minimal-right::before {
  content: "\\ea3b";
}

.nc-minimal-up::before {
  content: "\\ea3c";
}

.nc-mobile::before {
  content: "\\ea3d";
}

.nc-money-coins::before {
  content: "\\ea3e";
}

.nc-note-03::before {
  content: "\\ea3f";
}

.nc-palette::before {
  content: "\\ea40";
}

.nc-paper::before {
  content: "\\ea41";
}

.nc-pin-3::before {
  content: "\\ea42";
}

.nc-planet::before {
  content: "\\ea43";
}

.nc-refresh-69::before {
  content: "\\ea44";
}

.nc-ruler-pencil::before {
  content: "\\ea45";
}

.nc-satisfied::before {
  content: "\\ea46";
}

.nc-scissors::before {
  content: "\\ea47";
}

.nc-send::before {
  content: "\\ea48";
}

.nc-settings-gear-65::before {
  content: "\\ea49";
}

.nc-settings::before {
  content: "\\ea4a";
}

.nc-share-66::before {
  content: "\\ea4b";
}

.nc-shop::before {
  content: "\\ea4c";
}

.nc-simple-add::before {
  content: "\\ea4d";
}

.nc-simple-delete::before {
  content: "\\ea4e";
}

.nc-simple-remove::before {
  content: "\\ea4f";
}

.nc-single-02::before {
  content: "\\ea50";
}

.nc-single-copy-04::before {
  content: "\\ea51";
}

.nc-sound-wave::before {
  content: "\\ea52";
}

.nc-spaceship::before {
  content: "\\ea53";
}

.nc-sun-fog-29::before {
  content: "\\ea54";
}

.nc-support-17::before {
  content: "\\ea55";
}

.nc-tablet-2::before {
  content: "\\ea56";
}

.nc-tag-content::before {
  content: "\\ea57";
}

.nc-tap-01::before {
  content: "\\ea58";
}

.nc-tie-bow::before {
  content: "\\ea59";
}

.nc-tile-56::before {
  content: "\\ea5a";
}

.nc-time-alarm::before {
  content: "\\ea5b";
}

.nc-touch-id::before {
  content: "\\ea5c";
}

.nc-trophy::before {
  content: "\\ea5d";
}

.nc-tv-2::before {
  content: "\\ea5e";
}

.nc-umbrella-13::before {
  content: "\\ea5f";
}

.nc-user-run::before {
  content: "\\ea60";
}

.nc-vector::before {
  content: "\\ea61";
}

.nc-watch-time::before {
  content: "\\ea62";
}

.nc-world-2::before {
  content: "\\ea63";
}

.nc-zoom-split::before {
  content: "\\ea64";
}

/* all icon font classes list here */
.table .img-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
}
.table .img-row {
  max-width: 60px;
  width: 60px;
}
.table .form-check {
  margin: 0;
}
.table .form-check label .form-check-sign::before, .table .form-check label .form-check-sign::after {
  top: -17px;
  left: 4px;
}
.table .btn {
  margin: 0;
}
.table small, .table .small {
  font-weight: 300;
}
.card-tasks .card-body .table {
  margin-bottom: 0;
}
.card-tasks .card-body .table > thead > tr > th,
.card-tasks .card-body .table > tbody > tr > th,
.card-tasks .card-body .table > tfoot > tr > th,
.card-tasks .card-body .table > thead > tr > td,
.card-tasks .card-body .table > tbody > tr > td,
.card-tasks .card-body .table > tfoot > tr > td {
  padding-top: 0;
  padding-bottom: 0;
}
.table > thead > tr > th {
  font-size: 14px;
  font-weight: 700;
  padding-bottom: 0;
  text-transform: uppercase;
  border: 0;
}
.table .radio,
.table .checkbox {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  width: 15px;
}
.table .radio .icons,
.table .checkbox .icons {
  position: relative;
}
.table .radio label:after, .table .radio label:before,
.table .checkbox label:after,
.table .checkbox label:before {
  top: -17px;
  left: -3px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 12px 7px;
  vertical-align: middle;
}
.table .th-description {
  max-width: 150px;
}
.table .td-price {
  font-size: 26px;
  font-weight: 300;
  margin-top: 5px;
  position: relative;
  top: 4px;
  text-align: right;
}
.table .td-total {
  font-weight: 700;
  font-size: 1.57em;
  padding-top: 20px;
  text-align: right;
}
.table .td-actions .btn {
  margin: 0px;
}
.table > tbody > tr {
  position: relative;
}

.table-shopping > thead > tr > th {
  font-size: 1em;
  text-transform: uppercase;
}
.table-shopping > tbody > tr > td {
  font-size: 1em;
}
.table-shopping > tbody > tr > td b {
  display: block;
  margin-bottom: 5px;
}
.table-shopping .td-name {
  font-weight: 400;
  font-size: 1.5em;
}
.table-shopping .td-name small {
  color: #9A9A9A;
  font-size: 0.75em;
  font-weight: 300;
}
.table-shopping .td-number {
  font-weight: 300;
  font-size: 1.714em;
}
.table-shopping .td-name {
  min-width: 200px;
}
.table-shopping .td-number {
  text-align: right;
  min-width: 170px;
}
.table-shopping .td-number small {
  margin-right: 3px;
}
.table-shopping .img-container {
  width: 120px;
  max-height: 160px;
  overflow: hidden;
  display: block;
}
.table-shopping .img-container img {
  width: 100%;
}

.table-responsive {
  overflow: scroll;
  padding-bottom: 10px;
}

#tables .table-responsive {
  margin-bottom: 30px;
}

.table-hover > tbody > tr:hover {
  background-color: #f5f5f5;
}

.wrapper {
  position: relative;
  top: 0;
  height: 100vh;
}
.wrapper.wrapper-full-page {
  min-height: 100vh;
  height: auto;
}

.sidebar,
.off-canvas-sidebar {
  position: fixed;
  top: 0;
  height: 100vh;
  bottom: 0;
  width: 260px;
  left: 0;
  z-index: 1030;
  border-right: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.sidebar .sidebar-wrapper,
.off-canvas-sidebar .sidebar-wrapper {
  position: relative;
  flex: 1 1;
  overflow: auto;
  width: 260px;
  z-index: 4;
  overflow-y: auto;
}
.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,
.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {
  display: none !important;
}
.sidebar .sidebar-wrapper .navbar-form,
.off-canvas-sidebar .sidebar-wrapper .navbar-form {
  border: none;
}
.sidebar .sidebar-footer,
.off-canvas-sidebar .sidebar-footer {
  flex-shrink: 0;
  padding: 3px;
  background-color: transparent;
  z-index: 4;
}
.sidebar .sidebar-footer .footer-content,
.off-canvas-sidebar .sidebar-footer .footer-content {
  display: flex;
  align-items: center;
  gap: 10px;
}
.sidebar .sidebar-footer .eu-flag,
.off-canvas-sidebar .sidebar-footer .eu-flag {
  width: 5rem;
  flex-shrink: 0;
  margin-top: 2px;
}
.sidebar .sidebar-footer .funding-statement,
.off-canvas-sidebar .sidebar-footer .funding-statement {
  font-size: 10px;
  line-height: 1.3;
  margin: 0;
  color: inherit;
  font-weight: 400;
}
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize {
  position: absolute;
  right: 20px;
  top: 2px;
  opacity: 1;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar .nav,
.off-canvas-sidebar .nav {
  margin-top: 20px;
  display: block;
}
.sidebar .nav .caret,
.off-canvas-sidebar .nav .caret {
  top: 14px;
  position: absolute;
  right: 10px;
}
.sidebar .nav li > a + div .nav li > a,
.off-canvas-sidebar .nav li > a + div .nav li > a {
  margin-top: 7px;
}
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
  margin: 10px 15px 0;
  color: #FFFFFF;
  display: block;
  text-decoration: none;
  position: relative;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 12px;
  padding: 10px 8px;
  line-height: 30px;
  opacity: 0.7;
}
.sidebar .nav li .nav > li > a,
.off-canvas-sidebar .nav li .nav > li > a {
  padding: 5px 8px;
}
.sidebar .nav li.active > a, .sidebar .nav li.active > a > i,
.off-canvas-sidebar .nav li.active > a,
.off-canvas-sidebar .nav li.active > a > i {
  opacity: 1;
}
.sidebar .nav li:hover:not(.active) > a, .sidebar .nav li:focus:not(.active) > a,
.off-canvas-sidebar .nav li:hover:not(.active) > a,
.off-canvas-sidebar .nav li:focus:not(.active) > a {
  opacity: 1;
}
.sidebar .nav i,
.off-canvas-sidebar .nav i {
  font-size: 24px;
  float: left;
  margin-right: 12px;
  line-height: 30px;
  width: 34px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  position: relative;
}
.sidebar .nav p,
.off-canvas-sidebar .nav p {
  margin-bottom: 0;
}
.sidebar .nav .collapse .nav,
.sidebar .nav .collapsing .nav,
.off-canvas-sidebar .nav .collapse .nav,
.off-canvas-sidebar .nav .collapsing .nav {
  margin-top: 0;
}
.sidebar .sidebar-background,
.off-canvas-sidebar .sidebar-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.sidebar .sidebar-background:after,
.off-canvas-sidebar .sidebar-background:after {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  content: "";
  display: block;
  background: #FFFFFF;
  opacity: 1;
}
.sidebar .logo,
.off-canvas-sidebar .logo {
  position: relative;
  padding: 7px 0.7rem;
  z-index: 4;
}
.sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-mini {
  opacity: 1;
  float: left;
  width: 34px;
  text-align: center;
  margin-left: 10px;
  margin-right: 12px;
}
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-normal {
  display: block;
  opacity: 1;
  padding: 11px 0 8px;
  transform: translate3d(0px, 0, 0);
}
.sidebar .logo:after,
.off-canvas-sidebar .logo:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background-color: rgba(255, 255, 255, 0.5);
}
.sidebar .logo p,
.off-canvas-sidebar .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #FFFFFF;
  line-height: 20px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.sidebar .logo .simple-text,
.off-canvas-sidebar .logo .simple-text {
  text-transform: uppercase;
  padding: 0.5rem 0;
  display: block;
  white-space: nowrap;
  font-size: 1rem;
  color: #FFFFFF;
  text-decoration: none;
  font-weight: 400;
  line-height: 30px;
  overflow: hidden;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar:before, .sidebar:after,
.off-canvas-sidebar:before,
.off-canvas-sidebar:after {
  display: block;
  content: "";
  opacity: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.sidebar:after,
.off-canvas-sidebar:after {
  background: #66615B;
  background: linear-gradient(#66615B 0%, #000 80%);
  z-index: 3;
}
.sidebar[data-color=white]:after,
.off-canvas-sidebar[data-color=white]:after {
  background: #FFFFFF;
}
.sidebar[data-color=white] .nav li a,
.sidebar[data-color=white] .nav li a i,
.sidebar[data-color=white] .nav li a[data-toggle=collapse],
.sidebar[data-color=white] .nav li a[data-toggle=collapse] i,
.sidebar[data-color=white] .nav li a[data-toggle=collapse] ~ div > ul > li .sidebar-mini-icon,
.sidebar[data-color=white] .nav li a[data-toggle=collapse] ~ div > ul > li > a,
.off-canvas-sidebar[data-color=white] .nav li a,
.off-canvas-sidebar[data-color=white] .nav li a i,
.off-canvas-sidebar[data-color=white] .nav li a[data-toggle=collapse],
.off-canvas-sidebar[data-color=white] .nav li a[data-toggle=collapse] i,
.off-canvas-sidebar[data-color=white] .nav li a[data-toggle=collapse] ~ div > ul > li .sidebar-mini-icon,
.off-canvas-sidebar[data-color=white] .nav li a[data-toggle=collapse] ~ div > ul > li > a {
  color: #66615B;
  opacity: 0.7;
}
.sidebar[data-color=white] .nav li:hover:not(.active) > a, .sidebar[data-color=white] .nav li:focus:not(.active) > a,
.off-canvas-sidebar[data-color=white] .nav li:hover:not(.active) > a,
.off-canvas-sidebar[data-color=white] .nav li:focus:not(.active) > a {
  opacity: 1;
}
.sidebar[data-color=white] .logo .simple-text,
.off-canvas-sidebar[data-color=white] .logo .simple-text {
  color: #66615B;
}
.sidebar[data-color=white] .logo:after,
.off-canvas-sidebar[data-color=white] .logo:after {
  background-color: #66615B;
  opacity: 0.4;
}
.sidebar[data-color=white] .user .info a span,
.sidebar[data-color=white] .user .nav .sidebar-mini-icon,
.sidebar[data-color=white] .user .nav .sidebar-normal,
.off-canvas-sidebar[data-color=white] .user .info a span,
.off-canvas-sidebar[data-color=white] .user .nav .sidebar-mini-icon,
.off-canvas-sidebar[data-color=white] .user .nav .sidebar-normal {
  color: #66615B !important;
}
.sidebar[data-color=white] .user:after,
.off-canvas-sidebar[data-color=white] .user:after {
  background-color: #66615B;
  opacity: 0.4;
}
.sidebar[data-color=black]:after,
.off-canvas-sidebar[data-color=black]:after {
  background: #212120;
}
.sidebar[data-active-color=primary] .nav li.active > a, .sidebar[data-active-color=primary] .nav li.active > a i, .sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #51cbce;
  opacity: 1;
}
.sidebar[data-active-color=info] .nav li.active > a, .sidebar[data-active-color=info] .nav li.active > a i, .sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #2d3e75;
  opacity: 1;
}
.sidebar[data-active-color=success] .nav li.active > a, .sidebar[data-active-color=success] .nav li.active > a i, .sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #6bd098;
  opacity: 1;
}
.sidebar[data-active-color=warning] .nav li.active > a, .sidebar[data-active-color=warning] .nav li.active > a i, .sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #fbc658;
  opacity: 1;
}
.sidebar[data-active-color=danger] .nav li.active > a, .sidebar[data-active-color=danger] .nav li.active > a i, .sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #ef8157;
  opacity: 1;
}

.visible-on-sidebar-regular {
  display: inline-block !important;
}

.visible-on-sidebar-mini {
  display: none !important;
}

.off-canvas-sidebar .nav > li > a,
.off-canvas-sidebar .nav > li > a:hover {
  color: #FFFFFF;
}
.off-canvas-sidebar .nav > li > a:focus {
  background: rgba(200, 200, 200, 0.2);
}

.main-panel {
  position: relative;
  float: right;
  width: calc(100% - 260px);
  background-color: #f4f3ef;
  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}
.main-panel > .content {
  padding: 0 30px 30px;
  min-height: calc(100vh - 180px);
  margin-top: 93px;
}
.main-panel > .navbar {
  margin-bottom: 0;
}
.main-panel .header {
  margin-bottom: 50px;
}

.perfect-scrollbar-on .sidebar,
.perfect-scrollbar-on .main-panel {
  height: 100%;
  max-height: 100%;
}

.panel-header {
  height: 260px;
  padding-top: 80px;
  padding-bottom: 45px;
  background: #141E30; /* fallback for old browsers */
  background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);
  position: relative;
  overflow: hidden;
}
.panel-header .header .title {
  color: #FFFFFF;
}
.panel-header .header .category {
  max-width: 600px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 auto;
  font-size: 13px;
}
.panel-header .header .category a {
  color: #FFFFFF;
}

.panel-header-sm {
  height: 135px;
}

.panel-header-lg {
  height: 380px;
}

.sidebar-footer {
  padding: 15px;
  background-color: inherit;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  z-index: 10;
}
.sidebar-footer .footer-content {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.sidebar-footer .eu-flag {
  width: 35px;
  flex-shrink: 0;
}
.sidebar-footer .funding-statement {
  font-size: 10px;
  line-height: 1.2;
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
}

.footer {
  padding: 24px 0px 10px;
}
.footer.footer-default {
  background-color: #f2f2f2;
}
.footer nav {
  display: inline-block;
  float: left;
  padding-left: 0;
}
.footer ul {
  margin-bottom: 0;
  padding: 0;
  list-style: none;
}
.footer ul li {
  display: inline-block;
}
.footer ul li a {
  color: inherit;
  padding: 0.5rem;
  font-size: 0.8571em;
  text-transform: uppercase;
  text-decoration: none;
}
.footer ul li a:hover {
  text-decoration: none;
}
.footer .copyright {
  font-size: 0.8571em;
  line-height: 1.8;
}
.footer:after {
  display: table;
  clear: both;
  content: " ";
}

.fixed-plugin {
  position: fixed;
  right: 0;
  width: 64px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1031;
  border-radius: 8px 0 0 8px;
  text-align: center;
  top: 120px;
}
.fixed-plugin li > a,
.fixed-plugin .badge {
  transition: all 0.34s;
  -webkit-transition: all 0.34s;
  -moz-transition: all 0.34s;
}
.fixed-plugin .fa-cog {
  color: #FFFFFF;
  padding: 10px;
  border-radius: 0 0 6px 6px;
  width: auto;
}
.fixed-plugin .dropdown-menu {
  right: 80px;
  left: auto !important;
  top: -52px !important;
  width: 290px;
  border-radius: 10px;
  padding: 0 10px;
}
.fixed-plugin .dropdown .dropdown-menu .nc-icon {
  top: 2px;
  right: 10px;
  font-size: 14px;
}
.fixed-plugin .dropdown-menu:after,
.fixed-plugin .dropdown-menu:before {
  right: 10px;
  margin-left: auto;
  left: auto;
}
.fixed-plugin .fa-circle-thin {
  color: #FFFFFF;
}
.fixed-plugin .active .fa-circle-thin {
  color: #00bbff;
}
.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
  color: #777777;
  text-align: center;
}
.fixed-plugin img {
  border-radius: 0;
  width: 100%;
  height: 100px;
  margin: 0 auto;
}
.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
  box-shadow: none;
}
.fixed-plugin .badge {
  border: 3px solid #FFFFFF;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 23px;
  margin-right: 5px;
  position: relative;
  width: 23px;
}
.fixed-plugin .badge.badge-light {
  border: 1px solid #E3E3E3;
}
.fixed-plugin .badge.badge-light.active, .fixed-plugin .badge.badge-light:hover {
  border: 3px solid #0bf;
}
.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
  border-color: #00bbff;
}
.fixed-plugin .badge-blue {
  background-color: #2d3e75;
}
.fixed-plugin .badge-green {
  background-color: #6bd098;
}
.fixed-plugin .badge-orange {
  background-color: #51cbce;
}
.fixed-plugin .badge-yellow {
  background-color: #fbc658;
}
.fixed-plugin .badge-red {
  background-color: #ef8157;
}
.fixed-plugin h5 {
  font-size: 14px;
  margin: 10px;
}
.fixed-plugin .dropdown-menu li {
  display: block;
  padding: 15px 2px;
  width: 25%;
  float: left;
}
.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
  width: 100%;
  height: 35px;
  min-height: inherit;
}
.fixed-plugin li.button-container {
  height: auto;
}
.fixed-plugin li.button-container div {
  margin-bottom: 5px;
}
.fixed-plugin #sharrreTitle {
  text-align: center;
  padding: 10px 0;
  height: 50px;
}
.fixed-plugin li.header-title {
  height: 30px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}
.fixed-plugin .adjustments-line p {
  float: left;
  display: inline-block;
  margin-bottom: 0;
  font-size: 1em;
  color: #3C4858;
}
.fixed-plugin .adjustments-line a {
  color: transparent;
}
.fixed-plugin .adjustments-line a .badge-colors {
  position: relative;
  top: -2px;
}
.fixed-plugin .adjustments-line a a:hover,
.fixed-plugin .adjustments-line a a:focus {
  color: transparent;
}
.fixed-plugin .adjustments-line .togglebutton {
  text-align: center;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch {
  position: relative;
  left: -10px;
  font-size: 0.7142em;
  color: #66615B;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {
  left: 10px;
}
.fixed-plugin .adjustments-line .togglebutton .toggle {
  margin-right: 0;
}
.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {
  padding-right: 0;
  padding-left: 0;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
  margin: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder {
  font-size: 16px;
  text-align: center;
  border-radius: 10px;
  background-color: #FFF;
  border: 3px solid #FFF;
  padding-left: 0;
  padding-right: 0;
  opacity: 1;
  cursor: pointer;
  display: block;
  max-height: 100px;
  overflow: hidden;
  padding: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder img {
  margin-top: auto;
}
.fixed-plugin .dropdown-menu > li a.switch-trigger:hover, .fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {
  background-color: transparent;
}
.fixed-plugin .dropdown-menu > li:hover > a.img-holder, .fixed-plugin .dropdown-menu > li:focus > a.img-holder {
  border-color: rgba(0, 187, 255, 0.53);
}
.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
  border-color: #00bbff;
  background-color: #FFFFFF;
}
.fixed-plugin .btn-social {
  width: 50%;
  display: block;
  width: 48%;
  float: left;
  font-weight: 600;
}
.fixed-plugin .btn-social i {
  margin-right: 5px;
}
.fixed-plugin .btn-social:first-child {
  margin-right: 2%;
}
.fixed-plugin .dropdown .dropdown-menu {
  transform-origin: 0 0;
}
.fixed-plugin .dropdown .dropdown-menu:before {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid rgba(0, 0, 0, 0.2);
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -27px;
  bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:after {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid #FFFFFF;
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -26px;
  bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:before, .fixed-plugin .dropdown .dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
  width: 16px;
  transform: translateY(-50px);
  -webkit-transform: translateY(-50px);
  -moz-transform: translateY(-50px);
}
.fixed-plugin .dropdown.show-dropdown .show .dropdown-menu .show {
  transform: translate3d(0, -60px, 0) !important;
  bottom: auto !important;
  top: 0 !important;
}
.fixed-plugin .bootstrap-switch {
  margin: 0;
}

.fixed-plugin .show-dropdown .dropdown-menu[x-placement=bottom-start] {
  transform: translate3d(0, -100px, 0) !important;
}
.fixed-plugin .show-dropdown .dropdown-menu[x-placement=bottom-start]:before, .fixed-plugin .show-dropdown .dropdown-menu[x-placement=bottom-start]:after {
  top: 100px;
}
.fixed-plugin .show-dropdown .dropdown-menu[x-placement=top-start] {
  transform: translate3d(0, 100px, 0) !important;
}
.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement=bottom-start] {
  transform: translate3d(0, -60px, 0) !important;
}
.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement=top-start] {
  transform: translate3d(0, 470px, 0) !important;
}

.card {
  border-radius: 12px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
  background-color: #FFFFFF;
  color: #252422;
  margin-bottom: 20px;
  position: relative;
  border: 0 none;
  transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;
}
.card .card-body {
  padding: 15px 15px 10px 15px;
}
.card .card-body.table-full-width {
  padding-left: 0;
  padding-right: 0;
}
.card .card-header {
  padding: 15px 15px 0;
  border: 0;
}
.card .card-header:not([data-background-color]) {
  background-color: transparent;
}
.card .card-header .card-title {
  margin-top: 10px;
}
.card .map {
  border-radius: 3px;
}
.card .map.map-big {
  height: 400px;
}
.card[data-background-color=orange] {
  background-color: #51cbce;
}
.card[data-background-color=orange] .card-header {
  background-color: #51cbce;
}
.card[data-background-color=orange] .card-footer .stats {
  color: #FFFFFF;
}
.card[data-background-color=red] {
  background-color: #ef8157;
}
.card[data-background-color=yellow] {
  background-color: #fbc658;
}
.card[data-background-color=blue] {
  background-color: #2d3e75;
}
.card[data-background-color=green] {
  background-color: #6bd098;
}
.card .image {
  overflow: hidden;
  height: 200px;
  position: relative;
}
.card .avatar {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: 15px;
}
.card .numbers {
  font-size: 2em;
}
.card .big-title {
  font-size: 12px;
  text-align: center;
  font-weight: 500;
  padding-bottom: 15px;
}
.card label {
  font-size: 0.8571em;
  margin-bottom: 5px;
  color: #9A9A9A;
}
.card .card-footer {
  background-color: transparent;
  border: 0;
}
.card .card-footer .stats i {
  margin-right: 5px;
  position: relative;
  top: 0px;
  color: #66615B;
}
.card .card-footer .btn {
  margin: 0;
}
.card.card-plain {
  background-color: transparent;
  box-shadow: none;
  border-radius: 0;
}
.card.card-plain .card-body {
  padding-left: 5px;
  padding-right: 5px;
}
.card.card-plain img {
  border-radius: 12px;
}

.card-plain {
  background: transparent;
  box-shadow: none;
}
.card-plain .card-header,
.card-plain .card-footer {
  margin-left: 0;
  margin-right: 0;
  background-color: transparent;
}
.card-plain:not(.card-subcategories).card-body {
  padding-left: 0;
  padding-right: 0;
}

.card-chart .card-header .card-title {
  margin-top: 10px;
  margin-bottom: 0;
}
.card-chart .card-header .card-category {
  margin-bottom: 5px;
}
.card-chart .table {
  margin-bottom: 0;
}
.card-chart .table td {
  border-top: none;
  border-bottom: 1px solid #e9ecef;
}
.card-chart .card-progress {
  margin-top: 30px;
}
.card-chart .chart-area {
  height: 190px;
  width: calc(100% + 30px);
  margin-left: -15px;
  margin-right: -15px;
}
.card-chart .card-footer {
  margin-top: 15px;
}
.card-chart .card-footer .stats {
  color: #9A9A9A;
}
.card-chart .dropdown {
  position: absolute;
  right: 20px;
  top: 20px;
}
.card-chart .dropdown .btn {
  margin: 0;
}

.card-user .image {
  height: 130px;
}
.card-user .image img {
  border-radius: 12px;
}
.card-user .author {
  text-align: center;
  text-transform: none;
  margin-top: -77px;
}
.card-user .author a + p.description {
  margin-top: -7px;
}
.card-user .avatar {
  width: 124px;
  height: 124px;
  border: 1px solid #FFFFFF;
  position: relative;
}
.card-user .card-body {
  min-height: 240px;
}
.card-user hr {
  margin: 5px 15px 15px;
}
.card-user .card-body + .card-footer {
  padding-top: 0;
}
.card-user .card-footer h5 {
  font-size: 1.25em;
  margin-bottom: 0;
}
.card-user .button-container {
  margin-bottom: 6px;
  text-align: center;
}

.map {
  height: 500px;
}

.card-stats .card-body {
  padding: 15px 15px 0px;
}
.card-stats .card-body .numbers {
  text-align: right;
  font-size: 2em;
}
.card-stats .card-body .numbers p {
  margin-bottom: 0;
}
.card-stats .card-body .numbers .card-category {
  color: #9A9A9A;
  font-size: 16px;
  line-height: 1.4em;
}
.card-stats .card-footer {
  padding: 0px 15px 15px;
}
.card-stats .card-footer .stats {
  color: #9A9A9A;
}
.card-stats .card-footer hr {
  margin-top: 10px;
  margin-bottom: 15px;
}
.card-stats .icon-big {
  font-size: 3em;
  min-height: 64px;
}
.card-stats .icon-big i {
  line-height: 59px;
}

@media screen and (max-width: 991px) {
  .navbar {
    padding: 0;
  }
  .navbar.navbar-absolute {
    padding-top: 0;
  }
  .navbar .navbar-brand {
    font-size: 16px;
    margin-right: 0;
  }
  .profile-photo .profile-photo-small {
    margin-left: -2px;
  }
  .button-dropdown {
    display: none;
  }
  #minimizeSidebar {
    display: none;
  }
  .navbar .container-fluid {
    padding-right: 15px;
    padding-left: 15px;
  }
  .navbar .navbar-collapse .input-group {
    margin: 0;
    margin-top: 5px;
  }
  .navbar .navbar-nav .nav-item:first-child {
    margin-top: 10px;
  }
  .navbar .navbar-nav .nav-item:not(:last-child) {
    margin-bottom: 10px;
  }
  .navbar .dropdown.show .dropdown-menu {
    display: block;
  }
  .navbar .dropdown .dropdown-menu {
    display: none;
  }
  .navbar .dropdown.show .dropdown-menu,
  .navbar .dropdown .dropdown-menu {
    border: 0;
    transition: none;
    -webkit-box-shadow: none;
    width: auto;
    margin: 0px 1rem;
    margin-top: 0px;
    box-shadow: none;
    position: static;
    padding-left: 10px;
  }
  .navbar .dropdown.show .dropdown-menu:before,
  .navbar .dropdown .dropdown-menu:before {
    display: none;
  }
  .navbar .dropdown-menu .dropdown-item:focus,
  .navbar .dropdown-menu .dropdown-item:hover {
    color: #FFFFFF;
  }
  .navbar.bg-white .dropdown-menu .dropdown-item:focus, .navbar.bg-white .dropdown-menu .dropdown-item:hover {
    color: #66615B;
  }
  .navbar .navbar-toggler-bar {
    display: block;
    position: relative;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #66615B;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {
    margin-top: 3px;
  }
  .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
    background-color: #66615B;
  }
  .navbar .toggled .navbar-toggler-bar {
    width: 24px;
  }
  .navbar .toggled .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 5px;
  }
  .wrapper {
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .main-panel {
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .nav-open .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open body {
    position: relative;
    overflow-x: hidden;
  }
  .nav-open .menu-on-right .main-panel {
    transform: translate3d(-260px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-collapse,
  .nav-open .menu-on-right .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-translate {
    transform: translate3d(-300px, 0, 0);
  }
  .nav-open .menu-on-right #bodyClick {
    right: 260px;
    left: auto;
  }
  .menu-on-right .sidebar {
    left: auto;
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .bar1,
  .bar2,
  .bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 6px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 6px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 1;
    top: 0;
    right: 0;
    left: 260px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: transparent;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .footer .copyright {
    text-align: right;
  }
  .section-nucleo-icons .icons-container {
    margin-top: 65px;
  }
  .navbar-nav .nav-link i.fa,
  .navbar-nav .nav-link i.nc-icon {
    opacity: 0.5;
  }
  .sidebar,
  .bootstrap-navbar {
    position: fixed;
    display: flex !important;
    flex-direction: column !important;
    top: 0;
    height: 100vh !important;
    width: 260px;
    right: auto;
    left: 0;
    z-index: 1032;
    visibility: visible;
    overflow: hidden;
    padding: 0;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(-260px, 0, 0);
  }
  .sidebar .sidebar-wrapper {
    flex: 1 1;
    height: auto !important;
    padding-bottom: 0px;
    overflow-y: auto;
  }
  .main-panel {
    width: 100%;
  }
  .timeline:before {
    left: 5% !important;
  }
  .timeline > li > .timeline-badge {
    left: 5% !important;
  }
  .timeline > li > .timeline-panel {
    float: right !important;
    width: 82% !important;
  }
  .timeline > li > .timeline-panel:before {
    border-left-width: 0 !important;
    border-right-width: 15px !important;
    left: -15px !important;
    right: auto !important;
  }
  .timeline > li > .timeline-panel:after {
    border-left-width: 0 !important;
    border-right-width: 14px !important;
    left: -14px !important;
    right: auto !important;
  }
}
@media (max-width: 991px) and (min-width: 768px) {
  .nav-tabs-navigation.verical-navs {
    padding: 0px 2px;
  }
}
@media screen and (min-width: 768px) {
  .footer .footer-nav {
    padding-left: 21px;
  }
  .footer .credits {
    padding-right: 15px;
  }
}
@media screen and (min-width: 992px) {
  .navbar-collapse {
    background: none !important;
  }
  .navbar .navbar-toggle {
    display: none;
  }
  .navbar-nav .nav-link.profile-photo {
    padding: 0;
    margin: 7px 0.7rem;
  }
  .section-nucleo-icons .icons-container {
    margin: 0 0 0 auto;
  }
  .dropdown-menu .dropdown-item {
    color: inherit;
  }
  .footer .copyright {
    float: right;
    padding-right: 15px;
  }
  .sidebar .sidebar-wrapper li.active > a:not([data-toggle=collapse]):before,
  .sidebar .sidebar-wrapper li.active > [data-toggle=collapse] + div .nav li:before {
    border-right: 17px solid #DDDDDD;
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    content: "";
    display: inline-block;
    position: absolute;
    right: -16px;
    opacity: 1;
    top: 7px;
    transition: opacity 150ms ease-in;
  }
  .sidebar .sidebar-wrapper li.active > a:not([data-toggle=collapse]):after,
  .sidebar .sidebar-wrapper li.active > [data-toggle=collapse] + div .nav li:after {
    border-right: 17px solid #f4f3ef;
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    content: "";
    display: inline-block;
    position: absolute;
    right: -17px;
    opacity: 1;
    top: 7px;
    transition: opacity 150ms ease-in;
  }
  .sidebar .sidebar-wrapper li.active > [data-toggle=collapse] + div .nav li a:before, .sidebar .sidebar-wrapper li.active > [data-toggle=collapse] + div .nav li a:after {
    top: 0;
  }
}
@media screen and (max-width: 768px) {
  .card-stats [class*=col-] .statistics::after {
    display: none;
  }
  .main-panel .content {
    padding-left: 15px;
    padding-right: 15px;
  }
  .footer nav {
    display: block;
    margin-bottom: 5px;
    float: none;
  }
  .landing-page .section-story-overview .image-container:nth-child(2) {
    margin-left: 0;
    margin-bottom: 30px;
  }
  .card .form-horizontal .col-md-3.col-form-label {
    text-align: left;
  }
}
@media screen and (max-width: 767px) {
  .nav-tabs-navigation.verical-navs {
    padding: 0 28px;
  }
  .typography-line {
    padding-left: 23% !important;
  }
  .typography-line span {
    width: 60px !important;
  }
  .login-page .navbar,
  .lock-page .navbar,
  .register-page .navbar {
    padding: 0.5rem 1rem;
  }
  .footer .footer-nav,
  .footer .credits {
    margin: 0 auto !important;
  }
  .footer .footer-nav {
    margin-bottom: 10px !important;
  }
  .register-page .content {
    padding-top: 5vh;
  }
  .register-page .footer {
    position: relative;
  }
  .register-page .info-area.info-horizontal {
    margin-top: 0;
  }
}
@media screen and (max-width: 374px) {
  .login-page .content {
    padding-top: 10vh;
  }
}
@media screen and (max-width: 413px) {
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show {
    width: 225px !important;
  }
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show[x-placement=top-start] {
    transform: translate3d(0, 400px, 0) !important;
  }
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:before, .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:after {
    bottom: 360px !important;
  }
}
@media screen and (max-width: 576px) {
  .navbar[class*=navbar-toggleable-] .container {
    margin-left: 0;
    margin-right: 0;
  }
  .card-contributions .card-stats {
    flex-direction: column;
  }
  .card-contributions .card-stats .bootstrap-switch {
    margin-bottom: 15px;
  }
  .footer .copyright {
    text-align: center;
  }
  .section-nucleo-icons .icons-container i {
    font-size: 30px;
  }
  .section-nucleo-icons .icons-container i:nth-child(6) {
    font-size: 48px;
  }
  .page-header .container h6.category-absolute {
    width: 90%;
  }
  .card-timeline .timeline .timeline-panel {
    width: 38%;
    padding: 15px;
  }
}
.alert .close {
  font-weight: 300;
  font-size: 29px;
}
.alert .close i.fa,
.alert .close i.fas,
.alert .close i.far,
.alert .close i.fal,
.alert .close i.fab,
.alert .close i.nc-icon {
  font-size: 14px !important;
}

.btn.btn-icon.btn-sm .fa,
.btn.btn-icon.btn-sm .far,
.btn.btn-icon.btn-sm .fas,
.btn.btn-icon.btn-sm .fal,
.btn.btn-icon.btn-sm .fab,
.btn.btn-icon.btn-sm .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fal,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fab,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .nc-icon {
  font-size: 0.6875rem;
}
.btn.btn-icon.btn-lg .fa,
.btn.btn-icon.btn-lg .far,
.btn.btn-icon.btn-lg .fas,
.btn.btn-icon.btn-lg .fal,
.btn.btn-icon.btn-lg .fab,
.btn.btn-icon.btn-lg .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fal,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fab,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .nc-icon {
  font-size: 1.325rem;
}
.btn.btn-icon:not(.btn-footer) .nc-icon, .btn.btn-icon:not(.btn-footer) .fa, .btn.btn-icon:not(.btn-footer) .far, .btn.btn-icon:not(.btn-footer) .fas, .btn.btn-icon:not(.btn-footer) .fal, .btn.btn-icon:not(.btn-footer) .fas,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fa,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .far,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fas,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fal,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fas {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-12px, -12px);
  line-height: 1.5626rem;
  width: 24px;
}

.form-check .form-check-sign {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.form-check-radio .form-check-sign {
  font-family: "Font Awesome 5 Free";
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}
.form-check-radio .form-check-sign::before {
  font-size: 22px;
  content: "\\f111";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  position: absolute;
  opacity: 0.5;
  left: 5px;
  top: -5px;
}

.form-check .form-check-sign:after {
  font-family: "Font Awesome 5 Free";
  top: 4px;
}

.form-check-radio .form-check-sign::after, .form-check-radio input[type=radio]:checked + .form-check-sign::after {
  font-family: "Font Awesome 5 Free";
  top: -1px;
}

.form-check-radio .form-check-sign::before, .form-check-radio input[type=radio]:checked + .form-check-sign::before {
  font-family: "Font Awesome 5 Free";
  top: -1px;
}

.dropup .dropdown-toggle:after, .dropdown .dropdown-toggle:after {
  margin-left: 3px;
}

.fixed-plugin .dropdown .dropdown-menu:before {
  right: -17px;
  top: 28%;
}
.fixed-plugin .dropdown .dropdown-menu:after {
  right: -16px;
  top: 28%;
}
.fixed-plugin .gh-btn,
.fixed-plugin .gh-count,
.fixed-plugin .gh-ico {
  float: left;
}
.fixed-plugin .gh-btn,
.fixed-plugin .gh-count {
  padding: 2px 5px 2px 4px;
  color: #333;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  border-radius: 3px;
}
.fixed-plugin .gh-btn {
  background-color: #eee;
  background-image: linear-gradient(to bottom, #fcfcfc 0, #eee 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#fcfcfc", endColorstr="#eeeeee", GradientType=0);
  background-repeat: no-repeat;
  border: 1px solid #d5d5d5;
}
.fixed-plugin .gh-btn:hover,
.fixed-plugin .gh-btn:focus {
  text-decoration: none;
  background-color: #ddd;
  background-image: linear-gradient(to bottom, #eee 0, #ddd 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#eeeeee", endColorstr="#dddddd", GradientType=0);
  border-color: #ccc;
}
.fixed-plugin .gh-btn:active {
  background-image: none;
  background-color: #dcdcdc;
  border-color: #b5b5b5;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15);
}
.fixed-plugin .gh-ico {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.fixed-plugin .gh-count {
  position: relative;
  display: none; /* hidden to start */
  margin-left: 4px;
  background-color: #fafafa;
  border: 1px solid #d4d4d4;
}
.fixed-plugin .gh-count:hover,
.fixed-plugin .gh-count:focus {
  color: #4183C4;
}
.fixed-plugin .gh-count:before,
.fixed-plugin .gh-count:after {
  content: "";
  position: absolute;
  display: inline-block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.fixed-plugin .gh-count:before {
  top: 50%;
  left: -3px;
  margin-top: -4px;
  border-width: 4px 4px 4px 0;
  border-right-color: #fafafa;
}
.fixed-plugin .gh-count:after {
  top: 50%;
  left: -4px;
  z-index: -1;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #d4d4d4;
}
.fixed-plugin .github-btn-large {
  height: 30px;
}
.fixed-plugin .github-btn-large .gh-btn,
.fixed-plugin .github-btn-large .gh-count {
  padding: 3px 10px 3px 8px;
  font-size: 16px;
  line-height: 22px;
  border-radius: 4px;
}
.fixed-plugin .github-btn-large .gh-ico {
  width: 20px;
  height: 20px;
}
.fixed-plugin .github-btn-large .gh-count {
  margin-left: 6px;
}
.fixed-plugin .github-btn-large .gh-count:before {
  left: -5px;
  margin-top: -6px;
  border-width: 6px 6px 6px 0;
}
.fixed-plugin .github-btn-large .gh-count:after {
  left: -6px;
  margin-top: -7px;
  border-width: 7px 7px 7px 0;
}
.fixed-plugin .github-btn {
  display: inline-block;
}
.fixed-plugin .github-btn .gh-btn .gh-ico {
  margin-top: 3px;
}
.fixed-plugin .SocialMediaShareButton {
  display: inline-block;
}

@media screen and (max-width: 400px) {
  .fixed-plugin .dropdown-menu {
    width: 250px;
  }
}
select.form-control:not([size]):not([multiple]) {
  height: calc(2.25rem + 4px);
}

.form-control {
  height: auto;
  height: initial;
}

.form-group input[type=file] {
  opacity: 1;
  position: static;
  position: initial;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  height: initial;
  z-index: auto;
  z-index: initial;
}

.navbar .navbar-nav .nav-link i.fa + p,
.navbar .navbar-nav .nav-link i.fal + p,
.navbar .navbar-nav .nav-link i.fas + p,
.navbar .navbar-nav .nav-link i.fab + p,
.navbar .navbar-nav .nav-link i.far + p,
.navbar .navbar-nav .nav-link i.nc-icon + p {
  margin-left: 7px;
}
.navbar .navbar-nav .nav-link i.fa,
.navbar .navbar-nav .nav-link i.fal,
.navbar .navbar-nav .nav-link i.fas,
.navbar .navbar-nav .nav-link i.fab,
.navbar .navbar-nav .nav-link i.far,
.navbar .navbar-nav .nav-link i.nc-icon {
  font-size: 18px;
  position: relative;
  top: 3px;
  text-align: center;
  width: 21px;
}

/*--------------------------------

nucleo-icons Web Font - built using nucleoapp.com
License - nucleoapp.com/license/

-------------------------------- */
@font-face {
  font-family: "nucleo-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: normal;
  font-style: normal;
}
@media screen and (max-width: 991px) {
  .navbar-nav .nav-link i.fa,
  .navbar-nav .nav-link i.fal,
  .navbar-nav .nav-link i.fas,
  .navbar-nav .nav-link i.fab,
  .navbar-nav .nav-link i.far,
  .navbar-nav .nav-link i.nc-icon {
    opacity: 0.5;
  }
  .navbar .dropdown.show .dropdown-menu {
    border: 0;
    transition: none;
    -webkit-box-shadow: none;
    width: auto;
    margin: 0 1rem;
    box-shadow: none;
    position: static !important;
    padding-left: 10px;
    display: block !important;
    transform: translateZ(0) !important;
    background: inherit;
  }
  .navbar .dropdown.show .dropdown-menu:before, .navbar .dropdown.show .dropdown-menu:after {
    display: none;
  }
  .navbar.bg-dark .dropdown.show .dropdown-menu a {
    color: #FFFFFF;
  }
}
@media screen and (min-width: 992px) {
  .sidebar .sidebar-wrapper li.active > a:not([data-toggle=collapse]):before {
    border-right: 18px solid #DDDDDD;
    border-top: 18px solid transparent;
    border-bottom: 18px solid transparent;
    right: -15px;
    top: 6px;
  }
  .sidebar .sidebar-wrapper li.active > a:not([data-toggle=collapse]):after {
    border-right: 17px solid #f4f3ef;
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    right: -15px;
    top: 7px;
  }
}
*, *:focus, a, a:focus {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/paper-dashboard.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-animate-bootstrap-notify.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-perfect-scrollbar.scss","webpack://./src/assets/scss/paper-dashboard/_buttons.scss","webpack://./src/assets/scss/paper-dashboard/_variables.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_buttons.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_vendor-prefixes.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_transparency.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_inputs.scss","webpack://./src/assets/scss/paper-dashboard/_inputs.scss","webpack://./src/assets/scss/paper-dashboard/_typography.scss","webpack://./src/assets/scss/paper-dashboard/_misc.scss","webpack://./src/assets/scss/paper-dashboard/_checkboxes-radio.scss","webpack://./src/assets/scss/paper-dashboard/_navbar.scss","webpack://./src/assets/scss/paper-dashboard/_page-header.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_page-header.scss","webpack://./src/assets/scss/paper-dashboard/_dropdown.scss","webpack://./src/assets/scss/paper-dashboard/_alerts.scss","webpack://./src/assets/scss/paper-dashboard/_images.scss","webpack://./src/assets/scss/paper-dashboard/_nucleo-outline.scss","webpack://./src/assets/scss/paper-dashboard/_tables.scss","webpack://./src/assets/scss/paper-dashboard/_sidebar-and-main-panel.scss","webpack://./src/assets/scss/paper-dashboard/_footers.scss","webpack://./src/assets/scss/paper-dashboard/_fixed-plugin.scss","webpack://./src/assets/scss/paper-dashboard/_cards.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-plain.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-chart.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-user.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-map.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-stats.scss","webpack://./src/assets/scss/paper-dashboard/_responsive.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_alerts.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_buttons.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_checkboxes-radio.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_dropdown.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_fixed-plugin.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_inputs.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_navbar.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_nucleo-outline.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_responsive.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_typography.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAAA;ACkCA;;;;;CAAA;AAOA;EAEE,sBAAA;EAEA,yBAAA;ADlBF;;ACqBA;EAEE,mCAAA;ADlBF;;ACqBA;EAEE,sBAAA;ADlBF;;ACqBA;;EAGE,yBAAA;ADlBF;;ACqBA;;EAGE,yBAAA;ADlBF;ACsCA;EACE;IAEE,+BAAA;EDrBF;ECwBA;IAEE,mCAAA;EDtBF;ECyBA;IAEE,kCAAA;EDvBF;AACF;AC0BA;EAEE,qBAAA;ADxBF;AC2CA;EACE;IACE,UAAA;IAEA,mCAAA;ED5BF;EC+BA;IACE,UAAA;IAEA,eAAA;ED7BF;AACF;ACgCA;EAEE,0BAAA;AD9BF;AC4CA;EACE;IACE,UAAA;EDjCF;ECoCA;IACE,UAAA;EDlCF;AACF;ACqCA;EAEE,uBAAA;ADnCF;ACkDA;EACE;IACE,UAAA;EDrCF;ECwCA;IACE,UAAA;IAEA,kCAAA;EDtCF;AACF;ACyCA;EAEE,2BAAA;ADvCF;ACsDA;EACE;IACE,UAAA;EDzCF;EC4CA;IACE,UAAA;IAEA,mCAAA;ED1CF;AACF;AC6CA;EAEE,yBAAA;AD3CF;;AEtLA,8BAAA;AACA;EAEE,kBAAA;EACA,2BAAA;EACA,wBAAA;AFyLF;;AExLE;EACE;IACE,yBAAA;EF2LJ;AACF;AE3LE;EACE;IACE,yBAAA;EF6LJ;AACF;AE7LE;;EAEE,cAAA;EACA,6BAAA;AF+LJ;;AE9LE;EACE,sBAAA;EACA,YAAA;AFiMJ;;AEhMI;EACE,sBAAA;EACA,YAAA;AFmMN;;AElME;EACE,sBAAA;EACA,YAAA;AFqMJ;;AEpMI;EACE,sBAAA;EACA,WAAA;AFuMN;;AEtME;EACE,aAAA;EACA,kBAAA;EACA,mCAAA;EACA,UAAA;EAIA,6DAAA;EACA,WAAA;EACA,mDAAA;EACA,YAAA;AFyMJ;;AExMI;EACE,kBAAA;EACA,mCAAA;EACA,sBAAA;EAGA,kBAAA;EAKA,oHAAA;EAEA,WAAA;EACA,8CAAA;EACA,WAAA;AF2MN;;AE1MI;EACE,YAAA;AF6MN;;AE5ME;EACE,aAAA;EACA,kBAAA;EACA,mCAAA;EACA,UAAA;EAIA,6DAAA;EACA,QAAA;EACA,kDAAA;EACA,WAAA;AF+MJ;;AE9MI;EACE,kBAAA;EACA,mCAAA;EACA,sBAAA;EAGA,kBAAA;EAKA,oHAAA;EAEA,UAAA;EACA,6CAAA;EACA,UAAA;AFiNN;;AEhNI;EACE,WAAA;AFmNN;;AElNE;EACE,sBAAA;EACA,YAAA;AFqNJ;;AEpNI;EACE,sBAAA;EACA,YAAA;AFuNN;;AEtNE;EACE,sBAAA;EACA,YAAA;AFyNJ;;AExNI;EACE,sBAAA;EACA,WAAA;AF2NN;;AE1NE;;EAEE,YAAA;AF6NJ;;AE5NE;EACE,sBAAA;EACA,YAAA;AF+NJ;;AE9NI;EACE,sBAAA;AFiON;;AEhOE;EACE,sBAAA;EACA,YAAA;AFmOJ;;AElOI;EACE,sBAAA;AFqON;;AGrVA;;EAEI,iBCUyB;EDTzB,gBCsQ4B;EDrQ5B,mBC2P2B;ED1P3B,mBC0QyB;EDzQzB,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBCgJ4B;ED/I5B,kBAAA;EACA,eAAA;EETA,yBD2DyB;EC8DrB,cD7GqB;EEJzB,4BAAA;ANgWJ;AKtWI;;;;;;;;;;;;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;ALyWR;AKtWI;;EACI,gBAAA;ALyWR;AKlWQ;;;;;;;;;;;;;;;;;;;;;;;;;EAMI,yBD2BiB;EC1BjB,qBD0BiB;AJ6V7B;AK5RI;;EACI,cDlEqB;ECmErB,qBDnEqB;AJkW7B;AK7RQ;;;;EAGI,6BDnFiB;ECoFjB,cDvEiB;ECwEjB,qBDxEiB;ECyEjB,gBAAA;ALgSZ;AK5RI;;EACI,cDhFqB;AJ+W7B;AK7RQ;;;;;EAII,6BDjGiB;ECkGjB,cDrFiB;ECsFjB,qBAAA;EACA,gBAAA;ALgSZ;AGtaI;;;EIbF,UJeuB;EIZvB,0BAAA;EJaM,qBAAA;AH0aR;AGxaI;;;;EGnBM,gBHsBD;EACA,qBAAA;AH4aT;AGzaI;;EACE,SAAA;AH4aN;AGzaI;;EAEI,gBC4MwB;ED3MxB,mBC2MwB;ED1MxB,eC0MwB;EDzMxB,UAAA;EACA,oBCyMwB;EDxMxB,gBAAA;EACA,kBAAA;EACA,mBAAA;AH2aR;AGzaQ;;EACI,UAAA;AH4aZ;AGzaQ;;EACI,gBCiMoB;EDhMpB,mBCgMoB;ED/LpB,eC+LoB;AJ6OhC;AG1aY;;;;;;;;EAII,oBCwLgB;AJwPhC;AG5aQ;;EACI,cCsLoB;EDrLpB,iBCqLoB;EDpLpB,aCoLoB;AJ2PhC;AG7aY;;;;;;;;EAII,mBC6KgB;AJsQhC;AG/aQ;;;;;EAII,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,sBAAA;EACA,WAAA;AHkbZ;AG/aQ;;EACE,eAAA;AHkbV;AG9aI;;EACI,kBAAA;EACA,QAAA;AHibR;;AG3aA;EEhGI,yBDoEyB;ECqDrB,cD7GqB;AJogB7B;AK9gBI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;ALsgBR;AKngBI;EACI,gBAAA;ALqgBR;AK9fQ;EAMI,yBDoCiB;ECnCjB,qBDmCiB;AJwd7B;AKhaI;EACI,cDzDqB;EC0DrB,qBD1DqB;AJ4d7B;AKhaQ;EAGI,6BDnFiB;ECoFjB,cD/DiB;ECgEjB,qBDhEiB;ECiEjB,gBAAA;ALgaZ;AK5ZI;EACI,cDvEqB;AJqe7B;AK5ZQ;EAII,6BDjGiB;ECkGjB,cD7EiB;EC8EjB,qBAAA;EACA,gBAAA;AL2ZZ;;AG9cA;EEjGI,yBDuEyB;ECkDrB,cD7GqB;AJwiB7B;AKljBI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AL0iBR;AKviBI;EACI,gBAAA;ALyiBR;AKliBQ;EAMI,yBDuCiB;ECtCjB,qBDsCiB;AJyf7B;AKpcI;EACI,cDtDqB;ECuDrB,qBDvDqB;AJ6f7B;AKpcQ;EAGI,6BDnFiB;ECoFjB,cD5DiB;EC6DjB,qBD7DiB;EC8DjB,gBAAA;ALocZ;AKhcI;EACI,cDpEqB;AJsgB7B;AKhcQ;EAII,6BDjGiB;ECkGjB,cD1EiB;EC2EjB,qBAAA;EACA,gBAAA;AL+bZ;;AGjfA;EElGI,yBD0EyB;EC+CrB,cD7GqB;AJ4kB7B;AKtlBI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AL8kBR;AK3kBI;EACI,gBAAA;AL6kBR;AKtkBQ;EAMI,yBD0CiB;ECzCjB,qBDyCiB;AJ0hB7B;AKxeI;EACI,cDnDqB;ECoDrB,qBDpDqB;AJ8hB7B;AKxeQ;EAGI,6BDnFiB;ECoFjB,cDzDiB;EC0DjB,qBD1DiB;EC2DjB,gBAAA;ALweZ;AKpeI;EACI,cDjEqB;AJuiB7B;AKpeQ;EAII,6BDjGiB;ECkGjB,cDvEiB;ECwEjB,qBAAA;EACA,gBAAA;ALmeZ;;AGphBA;EEnGI,yBD6EyB;EC4CrB,cD7GqB;AJgnB7B;AK1nBI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;ALknBR;AK/mBI;EACI,gBAAA;ALinBR;AK1mBQ;EAMI,yBD6CiB;EC5CjB,qBD4CiB;AJ2jB7B;AK5gBI;EACI,cDhDqB;ECiDrB,qBDjDqB;AJ+jB7B;AK5gBQ;EAGI,6BDnFiB;ECoFjB,cDtDiB;ECuDjB,qBDvDiB;ECwDjB,gBAAA;AL4gBZ;AKxgBI;EACI,cD9DqB;AJwkB7B;AKxgBQ;EAII,6BDjGiB;ECkGjB,cDpEiB;ECqEjB,qBAAA;EACA,gBAAA;ALugBZ;;AGvjBA;EEpGI,yBDgFyB;ECyCrB,cD7GqB;AJopB7B;AK9pBI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;ALspBR;AKnpBI;EACI,gBAAA;ALqpBR;AK9oBQ;EAMI,yBDgDiB;EC/CjB,qBD+CiB;AJ4lB7B;AKhjBI;EACI,cD7CqB;EC8CrB,qBD9CqB;AJgmB7B;AKhjBQ;EAGI,6BDnFiB;ECoFjB,cDnDiB;ECoDjB,qBDpDiB;ECqDjB,gBAAA;ALgjBZ;AK5iBI;EACI,cD3DqB;AJymB7B;AK5iBQ;EAII,6BDjGiB;ECkGjB,cDjEiB;ECkEjB,qBAAA;EACA,gBAAA;AL2iBZ;;AGxlBA;EEmDI,uBD1GyB;EC2GzB,oCAAA;EACA,cDjGyB;EG1D3B,UF4JmB;EEzJnB,0BAAA;APmsBF;AKxiBI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;ALqiBN;AKpiBM;EACI,qDAAA;ALsiBV;AKliBI;EACI,oCAAA;ALoiBR;AK7hBM;EAME,wCAAA;EACA,gCAAA;AL0hBR;;AG9mBA;EEkDI,uBD1GyB;EC2GzB,oCAAA;EACA,cDxFyB;EGnE3B,UF4JmB;EEzJnB,0BAAA;AP0tBF;AK/jBI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;AL4jBN;AK3jBM;EACI,qDAAA;AL6jBV;AKzjBI;EACI,oCAAA;AL2jBR;AKpjBM;EAME,wCAAA;EACA,gCAAA;ALijBR;;AGpoBA;EEiDI,uBD1GyB;EC2GzB,oCAAA;EACA,cDrFyB;EGtE3B,UF4JmB;EEzJnB,0BAAA;APivBF;AKtlBI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;ALmlBN;AKllBM;EACI,qDAAA;ALolBV;AKhlBI;EACI,oCAAA;ALklBR;AK3kBM;EAME,wCAAA;EACA,gCAAA;ALwkBR;;AG1pBA;EEgDI,uBD1GyB;EC2GzB,oCAAA;EACA,cDlFyB;EGzE3B,UF4JmB;EEzJnB,0BAAA;APwwBF;AK7mBI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;AL0mBN;AKzmBM;EACI,qDAAA;AL2mBV;AKvmBI;EACI,oCAAA;ALymBR;AKlmBM;EAME,wCAAA;EACA,gCAAA;AL+lBR;;AGhrBA;EE+CI,uBD1GyB;EC2GzB,oCAAA;EACA,cD/EyB;EG5E3B,UF4JmB;EEzJnB,0BAAA;AP+xBF;AKpoBI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;ALioBN;AKhoBM;EACI,qDAAA;ALkoBV;AK9nBI;EACI,oCAAA;ALgoBR;AKznBM;EAME,wCAAA;EACA,gCAAA;ALsnBR;;AGtsBA;EE8CI,uBD1GyB;EC2GzB,oCAAA;EACA,cD5EyB;EG/E3B,UF4JmB;EEzJnB,0BAAA;APszBF;AK3pBI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;ALwpBN;AKvpBM;EACI,qDAAA;ALypBV;AKrpBI;EACI,oCAAA;ALupBR;AKhpBM;EAME,wCAAA;EACA,gCAAA;AL6oBR;;AG5tBA;EE6CI,uBD1GyB;EC2GzB,oCAAA;EACA,cDhJyB;EGX3B,UF4JmB;EEzJnB,0BAAA;AP60BF;AKlrBI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;AL+qBN;AK9qBM;EACI,qDAAA;ALgrBV;AK5qBI;EACI,oCAAA;AL8qBR;AKvqBM;EAME,wCAAA;EACA,gCAAA;ALoqBR;AGlvBI;EAEI,cCnDqB;EDoDrB,yBCrGqB;AJw1B7B;;AGhvBA;EEpHI,yBDYyB;EC2BrB,cD6BqB;EDkDzB,cC3DyB;AJ+yB7B;AKx2BI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;ALg2BR;AK71BI;EACI,gBAAA;AL+1BR;AKx1BQ;EAMI,yBDpBiB;ECqBjB,qBDrBiB;AJ02B7B;AK70BQ;EACI,cDsCiB;AJyyB7B;AK70BY;EAII,yBAAA;AL40BhB;AKx0BQ;EACI,yBAAA;AL00BZ;AKx0BY;EAII,yBAAA;ALu0BhB;AKn0BQ;EACI,yBAAA;ALq0BZ;AKn0BY;EAII,yBAAA;ALk0BhB;AK9zBQ;EACI,yBAAA;ALg0BZ;AK9zBY;EAII,yBAAA;AL6zBhB;AKzzBQ;EACI,yBAAA;AL2zBZ;AKzzBY;EAII,yBAAA;ALwzBhB;AKpzBQ;EASI,oCAAA;EACA,yBAAA;EACA,2BAAA;AL8yBZ;AK3yBQ;EAEI,yBAAA;AL4yBZ;AK1yBY;EACI,gBAAA;AL4yBhB;AKnyBI;EACI,cDjHqB;ECkHrB,qBDlHqB;AJu5B7B;AKnyBQ;EAGI,6BDnFiB;ECoFjB,cDxHiB;ECyHjB,qBDzHiB;EC0HjB,gBAAA;ALmyBZ;AK/xBI;EACI,cD/HqB;AJg6B7B;AK/xBQ;EAII,6BDjGiB;ECkGjB,cDtIiB;ECuIjB,qBAAA;EACA,gBAAA;AL8xBZ;AG3zBI;EAEI,cC5DqB;AJw3B7B;AGxzBQ;EAEI,cCpEiB;AJ63B7B;AGtzBQ;EAGK,yBCzHgB;ED0HhB,cC3EgB;AJi4B7B;AGlzBI;EAEI,6BAAA;AHmzBR;;AG9yBK;EIhJH,YJmJuB;EIhJvB,yBAAA;EJiJM,oBAAA;AHgzBR;;AG7yBA;EACI,iBCqE4B;EDpE5B,qBC/FyB;EDgGzB,kBAAA;EACA,6BC5GyB;AJ45B7B;;AGvyBQ;;;;;;;;;;;;;;;;;;;;;;;;;EAMI,6BC3HiB;AJw7B7B;;AGxzBA;EACE,SCzK2B;ED0K3B,sBAAA;EACA,6BCnI2B;AJ87B7B;;AGxzBA;EEYG,eD6D4B;EC5D5B,kBD1C6B;EC2C7B,kBAAA;ALgzBH;AK9yBG;EACI,kBAAA;ALgzBP;;AG9zBA;EESG,mBD2D4B;EC1D5B,kBD5C6B;EC6C7B,iBAAA;ALyzBH;AKvzBG;EACI,iBAAA;ALyzBP;;AGn0BA;EACI,gBAAA;AHs0BJ;;AGp0BA;EACI,WAAA;AHu0BJ;;AGr0BA;EACI,gBAAA;AHw0BJ;;AGt0BA;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;AHy0BJ;;AGt0BE;EACE,iBAAA;AHy0BJ;AGt0BI;EACE,oCAAA;AHw0BN;;AGl0BA;EACI,iBChNyB;EDiNzB,mBCa2B;EDZ3B,mBCpB2B;EDqB3B,kBCrB2B;AJ01B/B;AGn0BI;EACI,kBAAA;AHq0BR;;AGh0BE;EACE,aAAA;AHm0BJ;;AQlhCE;ECvBA,cL6B2B;AJghC7B;;AQnhCE;EC1BA,cL6B2B;AJohC7B;;AQphCE;EC7BA,cL6B2B;AJwhC7B;;ASjjCA;EACI,yBLQyB;EKPzB,yBAAA;EACA,kBLkJ4B;EKjJ5B,cLLyB;EKMzB,mBAAA;EACA,eLqP2B;EIhB7B,oGAAA;EF9OQ,gBGWN;ATyjCJ;ASrjCI;EACI,yBAAA;EHhBE,gBGiBF;EACA,qBAAA;EACA,cLwCqB;AJghC7B;AStjCQ;EAII,sBAAA;EACA,iBAAA;EACA,6BLqBiB;AJgiC7B;ASjjCI;EH/BM,gBGmCF;ATijCR;AS9iCI;EACI,sBAAA;EACA,cLtCqB;AJslC7B;AS9iCQ;EACI,+BAAA;ATgjCZ;AS7iCI;EACI,yBAAA;EACA,cLuBqB;AJwhC7B;AS7iCI;EACI,yBLCqB;EKArB,yBAAA;EACA,cL2BqB;AJohC7B;AS7iCQ;EACI,+BAAA;AT+iCZ;AS5iCI;EACI,yBLhDqB;EKiDrB,yBAAA;AT8iCR;AS3iCI;EACI,kBLwFwB;EKvFxB,eL4LuB;EK3LvB,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;AT6iCR;AS1iCI;EACI,0BAAA;EACA,gCAAA;AT4iCR;ASziCI;EAEI,yBLpEqB;AJ8mC7B;;AQhlCI;;EACE,yBAAA;ARolCN;AQjlCI;;EACE,kBAAA;ARolCN;AQllCM;;;EAEE,yBAAA;ARqlCR;;AQ9kCI;;EACE,kBAAA;ARklCN;AQhlCM;;;EAEE,yBAAA;ARmlCR;AQ9kCI;;;;EAEE,yBAAA;ARklCN;AQhlCM;;;;EACE,2BAAA;ARqlCR;;AQ3kCI;;EACE,kBAAA;AR+kCN;AQ7kCM;;;EAEE,yBAAA;ARglCR;AQ5kCI;;;;EAEE,yBAAA;ARglCN;;AQ1kCI;;EACE,4BAAA;AR8kCN;AQ3kCM;;;EAEE,yBAAA;AR8kCR;AQzkCI;;;;EAEE,yBAAA;AR6kCN;AQ1kCM;;;;;;;EAEE,2BAAA;ARilCR;;AS3mCM;;EACE,sBAAA;EACA,cL7FqB;EK8FrB,yBLpFqB;EKqFrB,kBAAA;AT+mCR;;ASvmCI;;;;;;EAGI,0CL3EqB;EK4ErB,mBAAA;AT6mCR;AS5mCQ;;;;;;;;;;;;;;;;EAGI,mBAAA;EACA,0CLhFiB;AJ2sC7B;ASrnCY;;;EAEI,0CLxFa;AJgtC7B;ASnnCI;;;;EAEI,0CLhGqB;EKiGrB,YAAA;ATunCR;;ASlnCI;EACI,cLxDqB;AJ6qC7B;;ASjnCI;EACI,cLtEqB;AJ0rC7B;;AS/mCE;EACE,kBLK4B;AJ6mChC;ASjnCI;EACE,yBAAA;EACA,kBAAA;ATmnCN;AShnCE;EACE,cAAA;EACA,WAAA;EACA,cL5EyB;EK6EzB,eAAA;ATknCJ;;AS7mCE;EACE,kBLX4B;AJ2nChC;AS/mCI;EAEE,kBAAA;ATgnCN;;ASzmCE;;EAEE,yBLlKyB;EKmKzB,qBLpJyB;AJgwC7B;ASxmCI;;EAEE,0CLpJuB;AJ8vC7B;ASnmCM;;EACE,yBL1IqB;AJgvC7B;AS9lCM;;EACE,yBLlJqB;EKmJrB,yBAAA;EACA,kBAAA;ATimCR;;AS3lCA;;EAEI,6BAAA;EACA,yBAAA;EACA,cLxJyB;EKyJzB,4BL5D4B;EK6D5B,+BL7D4B;EIsF9B,oGAAA;AR0kCF;ASjmCI;;EACE,YAAA;ATomCN;AS/lCI;;EACE,yBL1KuB;AJ4wC7B;AShmCI;;EACE,yBL5KuB;AJ+wC7B;ASjmCI;;EACE,yBLxNuB;EKyNvB,cLrJuB;AJyvC7B;ASlmCI;;EACE,yBL5NuB;EK6NvB,cLlKuB;AJuwC7B;ASnmCI;;EACE,cL5JuB;AJkwC7B;ASpmCI;;EACE,cLxKuB;AJ+wC7B;ASpmCI;;;EDnPF,uBAAA;ECsPM,kBAAA;ATumCR;ASpmCI;;EACI,WAAA;ATumCR;;ASnmCA;;EAEE,SAAA;ATsmCF;;ASlmCA;EACE,iBAAA;ATqmCF;;ASnmCA;EACE,kBAAA;ATsmCF;;ASnmCA;;EAEI,mBAAA;EACA,kBAAA;ATsmCJ;ASpmCI;;EACI,eAAA;ATumCR;ASpmCM;;EACE,cLpMqB;AJ2yC7B;;ASlmCI;;EAEI,yBLjQqB;AJs2C7B;;ASjmCA;EACI,kBLxI4B;EKyI5B,yBAAA;EACA,4BAAA;EACA,mBAAA;ATomCJ;;ASjmCA;;;EAGI,oBAAA;ATomCJ;;ASlmCA;;;EAGI,mBAAA;ATqmCJ;;ASnmCA;EACI,yBLvRyB;EKwRzB,cLvPyB;EKwPzB,mBAAA;ATsmCJ;;ASnmCA;EACI,iBL9SyB;EK+SzB,oBAAA;ATsmCJ;;ASpmCA;EACI,qBLhSyB;AJu4C7B;;ASpmCA;EACI,cAAA;ATumCJ;;ASrmCA;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBLhL4B;EKiL5B,cAAA;ATwmCJ;;ASlmCI;;;EAEI,mBAAA;ATsmCR;;ASlmCA;EACI,WAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;ATqmCJ;;ASlmCA;EACI,eAAA;ATqmCJ;;ASjmCA;EACE,UAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;ATomCF;;ASjmCA;EACI,mBLjH2B;AJqtC/B;;ASjmCA;EACI,UAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;ATomCJ;;AShmCI;;EAEI,wBAAA;EACA,iBAAA;EACA,gBAAA;ATmmCR;AShmCI;EACI,mBAAA;ATkmCR;AShmCQ;EACG,eAAA;ATkmCX;AS9lCI;EACI,gBAAA;EACA,wBAAA;ATgmCR;AS7lCI;EACI,eAAA;AT+lCR;;AU/+CA;;;;;EAKI,8DNEyB;AJg/C7B;;AUh/CA;EACI,gBNgQ4B;AJmvChC;;AUh/CA;EACI,cN0DyB;AJy7C7B;AUl/CI;EAEI,cNuDqB;AJ47C7B;;AUh/CA;EACI,gBNkO2B;EMjO3B,iBAAA;EACA,mBAAA;AVm/CJ;AUj/CI;EACI,gBNkPwB;EMjPxB,yBAAA;EACA,YAAA;AVm/CR;;AUh/CA;EACI,gBNwN2B;EMvN3B,mBAAA;AVm/CJ;;AUj/CA;EACI,cNqN2B;EMpN3B,mBAAA;EACA,kBAAA;AVo/CJ;;AUl/CA;EACI,kBNiN2B;EMhN3B,mBAAA;EACA,gBAAA;EACA,mBNqG2B;AJg5C/B;AUn/CI;EAEI,iBAAA;AVo/CR;;AUj/CA;EACI,iBNuM2B;EMtM3B,kBAAA;EACA,mBAAA;AVo/CJ;;AUl/CA;EACI,cNmM2B;EMlM3B,gBNkN4B;EMjN5B,yBAAA;AVq/CJ;;AUl/CI;EACI,iBAAA;AVq/CR;;AU3+CA;EACI,gBNkM4B;AJ4yChC;AU5+CI;EACI,yBAAA;AV8+CR;AU5+CQ;EACI,cNvDiB;EMwDjB,qBAAA;AV8+CZ;AU3+CI;EACI,iBAAA;AV6+CR;;AUz+CA;;;;EAII,cN7DyB;EM8DzB,gBN2K4B;AJi0ChC;;AU1+CA;;EAEI,0BAAA;EACA,gBNuK4B;EMtK5B,cNpEyB;EMqEzB,mBN2J2B;AJk1C/B;;AU1+CA;EACI,cNmJ2B;AJ01C/B;;AU1+CA;;EAEE,yBAAA;AV6+CF;;AU3+CA;;EAEE,yBAAA;AV8+CF;;AU5+CA;;EAEE,yBAAA;AV++CF;;AU7+CA;;EAEE,yBAAA;AVg/CF;;AU9+CA;;EAEE,yBAAA;AVi/CF;;AU9+CA;;EAEI,yBAAA;AVi/CJ;;AU7+CA;EACI,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBN0H2B;EMzH3B,gBAAA;AVg/CJ;AU9+CI;EACI,cNhFqB;EMiFrB,mBNiHuB;EMhHvB,yBAAA;AVg/CR;AU7+CI;EACI,qBN7EqB;EM8ErB,cN9EqB;AJ6jD7B;AU7+CQ;EACI,cNjFiB;AJgkD7B;AU3+CI;EACI,qBN1EqB;EM2ErB,cN3EqB;AJwjD7B;AU3+CQ;EACI,cN9EiB;AJ2jD7B;AUz+CI;EACI,sCN5HqB;EM6HrB,cNxJqB;AJmoD7B;AUz+CQ;EACI,+BNhIiB;AJ2mD7B;;AWppDA;EACI,cPsByB;EOrBzB,eP8P2B;EO7P3B,8DPIyB;EOHzB,kCAAA;EACA,mCAAA;AXupDJ;;AWppDA;EACI,kBAAA;EACA,mBPIyB;AJmpD7B;;AWrpDA,eAAA;AACA;;;;;;;;;;;;;;;;ELHI,6BAAA;AN+qDJ;;AW/pDA;;;ELhBI,6BAAA;ANyrDJ;;AWnqDA;;;;EN+KI,gEAAA;EAGA,yBAAA;AL2/CJ;;AWtqDA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBP9ByB;AJusD7B;AWvqDI;EACI,eAAA;AXyqDR;AWtqDI;EACI,WAAA;AXwqDR;;AWpqDA;EACI,qBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;AXuqDJ;;AWpqDA;EACE,WAAA;AXuqDF;;AWrqDA;EACE,YAAA;AXwqDF;;AWnqDE;EACE,iBAAA;EACA,mBAAA;AXsqDJ;AWpqDI;EACE,aAAA;AXsqDN;AWpqDI;;EAEE,yBAAA;AXsqDN;AWnqDE;EACE,qBAAA;AXqqDJ;AWlqDI;EACE,UAAA;AXoqDN;AWlqDI;EACE,oCAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;AXoqDN;;AW9pDE;EACE,uBAAA;AXiqDJ;;AW1pDE;EL0GE,qBFpKyB;EEqKzB,yBFrKyB;AJytD7B;AW5pDE;ELuGE,qBF3JyB;EE4JzB,yBF5JyB;AJotD7B;AW7pDE;ELoGE,qBFrJyB;EEsJzB,yBFtJyB;AJktD7B;AW9pDE;ELiGE,qBFxJyB;EEyJzB,yBFzJyB;AJytD7B;AW/pDE;EL8FE,qBFlJyB;EEmJzB,yBFnJyB;AJutD7B;AWhqDE;EL2FE,qBF/IyB;EEgJzB,yBFhJyB;AJwtD7B;AWjqDE;ELwFE,qBFnNyB;EEoNzB,yBFpNyB;EO6HvB,cAAA;AXoqDN;;AW9pDI;EACE,mBAAA;AXiqDN;;AYnzDA;;EAEI,mBAAA;EACA,kBAAA;AZszDJ;;AYnzDA;EACE,eAAA;EACA,qBAAA;AZszDF;AYpzDI;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AZszDR;AYnzDI;;EAEI,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,yBAAA;EAKA,+BAAA;AZqzDR;AYnzDI;EACI,0BAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;AZqzDR;AYlzDQ;EACI,cRpBiB;EQqBjB,YAAA;EACA,mBAAA;AZozDZ;;AYzyDA;;EAEI,UAAA;EACA,kBAAA;EACA,kBAAA;AZ4yDJ;;AY1yDA;EACI,UAAA;AZ6yDJ;;AY1yDA;;EAEI,mBAAA;AZ6yDJ;;AY1yDA;;EAEI,+BAAA;AZ6yDJ;;AY1yDA;EACE,iBAAA;AZ6yDF;AY3yDI;EACI,kBAAA;AZ6yDR;AY1yDQ;EACI,cR7DiB;EQ8DjB,YAAA;EACA,mBAAA;AZ4yDZ;;AYvyDA;EACI,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;AZ0yDJ;;AYvyDA;EACI,yBAAA;AZ0yDJ;;AYvyDA;;EAEI,UAAA;ENnEA,+BAAA;EMqEA,YAAA;EACA,cAAA;AZ8yDJ;;AY3yDA;EACI,0BAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AZ8yDJ;;AY3yDA;EACI,UAAA;AZ8yDJ;;AY1yDA;;EAEI,cR9GyB;AJ25D7B;;Aaz7DA;EACI,qBTkT6B;ESjT7B,wBTiT6B;EShT7B,gBAAA;EACA,mBAAA;Ab47DJ;Aa17DI;EACI,sBAAA;Ab47DR;Aa17DQ;EACI,cTIiB;AJw7D7B;Aaz7DQ;EACI,cT+CiB;AJ44D7B;Aap7DM;;EAEE,cTsCqB;AJg5D7B;AQr7DE;;EKEQ,cTmCmB;AJo5D7B;AQt7DE;;EKDQ,cTmCmB;AJw5D7B;AQv7DE;;EKJQ,cTmCmB;AJ45D7B;Aa57DM;;EAEE,cT8BqB;ES7BrB,YAAA;Ab87DR;Aa17DI;;EAEE,SAAA;EACA,iBAAA;EACA,iBAAA;Ab47DN;Aa17DM;;;;;;EAGE,cTgBqB;AJ+6D7B;Aa77DQ;;;;;;EACE,UAAA;Abo8DV;Aa/7DQ;;EACE,cTOmB;AJ27D7B;AQh+DE;;EKiCU,cTIiB;AJ+7D7B;AQj+DE;;EK8BU,cTIiB;AJm8D7B;AQl+DE;;EK2BU,cTIiB;AJu8D7B;Aar8DI;EACI,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;Abu8DR;Aap8DI;EACI,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;Abs8DR;Aal8DQ;EACI,OAAA;EACA,WAAA;EAAA,cAAA;Abo8DZ;Aah8DI;EACI,oBAAA;EACA,mBAAA;Abk8DR;Aah8DQ;EACI,mBAAA;Abk8DZ;Aah8DY;EACI,SAAA;Abk8DhB;Aa77DY;EACI,eAAA;Ab+7DhB;Aa37DgB;EACI,WAAA;Ab67DpB;Aap7DQ;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;Abs7DZ;Aan7DQ;EACI,kBAAA;Abq7DZ;Aap7DY;EACI,kBAAA;Abs7DhB;Aap7DY;EACI,iBAAA;Abs7DhB;Aal7DQ;EACI,yBAAA;EACA,mBTwHmB;ESvHnB,sBAAA;EACA,qBTqIiB;ESpIjB,iBAAA;Abo7DZ;Aal7DY;;EAEI,gBAAA;Abo7DhB;Aaj7DY;;EAEI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;Abm7DhB;Aah7DY;EACI,QAAA;EACA,eAAA;Abk7DhB;Aa96DgB;EACI,WAAA;EACA,YAAA;Abg7DpB;Aa56DY;EACI,YAAA;EACA,cTzJa;AJukE7B;Aa16DQ;;;;EAII,kBTtBoB;ESuBpB,cTnHiB;AJ+hE7B;Aax6DI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;Ab06DR;Aav6DI;EACI,0BAAA;EACA,eTmEuB;ESlEvB,mBTMuB;ESLvB,sBTKuB;ESJvB,qBT2EqB;AJ81D7B;Aat6DI;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,eAAA;Abw6DR;Aat6DQ;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;Abw6DZ;Aan6DQ;EACI,WAAA;Abq6DZ;Aaj6DI;EACE,wCAAA;EACA,gBAAA;EACA,6BAAA;Abm6DN;Aaj6DM;EACE,cTnKqB;AJskE7B;Aaj6DQ;EACE,YAAA;EACA,cTvKmB;AJ0kE7B;Aa/5DO;EACI,mBT5KkB;AJ6kE7B;Aa95DM;EACE,cThLqB;AJglE7B;Aa95DM;;;;;EAKE,cT9KqB;AJ8kE7B;Aa35DQ;EACI,cT7LiB;AJ0lE7B;Aa35DY;EACI,YAAA;EACA,cTjMa;AJ8lE7B;Aaz5DQ;EACI,mBTtMiB;AJimE7B;Aax5DQ;;;;EAII,cT9LiB;AJwlE7B;Aav5DQ;EACI,yBAAA;Aby5DZ;Aan5DQ;EACE,eTrBqB;AJ06D/B;;Aa/4DA;EACI,oCAAA;Abk5DJ;;Aa/4DA;EACI,oCAAA;Abk5DJ;;Aa/4DA;EACI,oCAAA;Abk5DJ;;Aa/4DA;EACI,oCAAA;Abk5DJ;;Aa/4DA;EACI,oCAAA;Abk5DJ;;Aa/4DA;EACI,oCAAA;Abk5DJ;;Aa/4DA;EACI,oCAAA;Abk5DJ;;ActsEA;EACI,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cVUyB;EUTzB,kBAAA;AdysEJ;AcvsEI;EACI,kBAAA;EACA,sBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AdysER;ActsEI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EAGA,gCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AdwsER;AcpsEI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AdssER;AcnsEI;EACI,YAAA;EACA,UAAA;AdqsER;AclsEI;;EAEI,+BVJqB;AJwsE7B;AcjsEI;EACI,gBAAA;EACA,iBAAA;AdmsER;AchsEI;EACI,gBAAA;EACA,iBAAA;AdksER;Ac/rEI;EACI,mBAAA;AdisER;Ac/rEI;EACI,gBAAA;AdisER;Ac9rEI;EAEI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;Ad+rER;Ac5rEI;EACI,oCAAA;Ad8rER;Ac3rEI;EChFA,iCDiF6B,ECjFR,+CAAA,EACrB,0BAAA,EACA,2BAAA,EACA,0BAAA;EACA,+EAAA,EAAA,oBAAA;Af8wEJ;;AgBhxEI;;;EACI,cAAA;ETDN,USEuB;ETCvB,wBAAA;EDJQ,gDUIF;EACA,kBAAA;EACA,kBAAA;EACA,yGAAA;AhBuxER;AgBrxEQ;;;EV+CD,gDAAA;AN+uEP;AgB1xEQ;;;EV2CD,gDAAA;ANwvEP;AgB9xEI;;;ETjBF,USkBuB;ETfvB,0BAAA;ESgBM,mBAAA;AhBmyER;AgBjyEQ;;;EVkCD,kDAAA;EUhCK,oBAAA;EACA,oBAAA;AhByyEZ;AgBtyEQ;;;EV4BD,iDAAA;EU1BK,uBAAA;EACA,iBAAA;AhB8yEZ;;AgBxyEA;;EVmBO,gDAAA;EUhBH,oBAAA;EACA,oBAAA;AhB+yEJ;;AgB3yEA;;EAEI,UAAA;EACA,mBAAA;AhB8yEJ;AgB5yEI;;EVsBI,4CAAA;AN8xER;;AgB7yEI;EVDG,kDAAA;EUGC,oBAAA;EACA,oBAAA;AhBozER;AgBhzEM;EACE,4BAAA;AhBkzER;;AgB3yEE;EACE,oBAAA;AhB8yEJ;AgB3yEE;EACE,oBAAA;AhB6yEJ;;AgB1yEA;EACI,yBZrEyB;EYsEzB,cAAA;EACA,mBZwE4B;EYvE5B,gBAAA;EACA,YAAA;AhB6yEJ;AgB3yEI;EACI,yBZvBqB;EYwBrB,WAAA;AhB6yER;AgB1yEI;EACI,cZjEqB;EYkErB,mBZ+JuB;EY9JvB,kBAAA;AhB4yER;AgBzyEI;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AhB2yER;AgBxyEI;EACI,cZxGqB;EYyGrB,eZmJuB;EYlJvB,4BAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AhB0yER;AgBxyEO;EACI,gBAAA;AhB0yEX;AgBtyEI;EACI,qBAAA;AhBwyER;AgBryEI;EACI,eAAA;AhBuyER;AgBpyEI;EACG,4BZ2ByB;EY1BzB,6BZ0ByB;AJ4wEhC;AgBnyEI;EACI,+BZsBwB;EYrBxB,gCZqBwB;AJgxEhC;AgBlyEI;EACI,gBAAA;EACA,qBAAA;AhBoyER;AgBjyEI;;EAEI,yBAAA;EACA,UAAA;EACA,qBAAA;AhBmyER;AgBhyEI;;EAEI,yBZ5FqB;AJ83E7B;AgB/xEI;EAEI,yBZ7CgB;AJ60ExB;AgB9xEI;EAEI,yBZhDgB;AJ+0ExB;AgB7xEI;EAEI,yBZnDgB;AJi1ExB;AgB5xEI;EAEI,yBZtDgB;AJm1ExB;AgB3xEI;EAEI,yBZzDgB;AJq1ExB;;AgBxxEA;EACI,oBAAA;AhB2xEJ;;AgBpxEA;EACI,iBAAA;AhBuxEJ;;AgBrxEA;EACI,WAAA;EACA,UAAA;AhBwxEJ;;AgBrxEA;;;;;;EAMI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AhBwxEJ;;AgBrxEA;;;;;;EAMI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AhBwxEJ;;AgBrxEA;;EAEI,qBAAA;EACA,WAAA;AhBwxEJ;;AgBtxEA;;EAEI,qBAAA;EACA,WAAA;AhByxEJ;;AgBpxEA;EACI;IACE,gBAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;EhBuxEJ;EgBrxEE;IACE,aAAA;EhBuxEJ;EgBrxEE;;;IAGE,uCAAA;IACA,yGAAA;EhBuxEJ;EgBrxEE;;;IAGE,qCAAA;IACA,8BAAA;EhBuxEJ;EgBrxEE;IAKE,4BAAA;EhBuxEJ;EgBrxEE;IACE,8BAAA;EhBuxEJ;EgBpxEE;IACE,yGAAA;IACA,qCAAA;EhBsxEJ;EgBnxEE;;IAEI,UAAA;IACA,WAAA;EhBqxEN;EgB/wES;IACE,cAAA;EhBixEX;EgB3wEE;IACI,wBAAA;EhB6wEN;AACF;AgBzwEI;EACI,cZxSqB;EYySrB,eZ7CuB;AJwzE/B;AgBzwEQ;EACI,iBAAA;EACA,sCAAA;AhB2wEZ;AgBzwEY;EACI,eAAA;AhB2wEhB;AgBxwEQ;EACI,cAAA;EACA,cAAA;AhB0wEZ;AgBxwEQ;EACI,YAAA;AhB0wEZ;AgBpwEQ;;;;EAEI,yBZtTiB;EYuTjB,cZjUiB;EYkUjB,UAAA;EACA,qBAAA;AhBwwEZ;;AgBpwEA;;EAEI,kBAAA;AhBuwEJ;;AgBnwEI;EACI,kBAAA;AhBswER;AgBrwEQ;EACI,iBAAA;EACA,iBAAA;EACA,iBAAA;AhBuwEZ;AgBtwEY;EACI,eAAA;AhBwwEhB;AgBtwEY;EACI,iBAAA;AhBwwEhB;AgBrwEQ;EACI,cZ7QiB;AJohF7B;AgBtwEY;EACI,cZ/Qa;AJuhF7B;AgBlwEQ;;EACI,cZpWiB;EYqWjB,UAAA;EACA,qBAAA;AhBqwEZ;AgBjwEQ;EACI,kBAAA;AhBmwEZ;;AgB/vEA;;;EAGI,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AhBkwEJ;;AgB/vEA;;;EAGI,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AhBkwEJ;;AgB7vEI;;EACI,cAAA;AhBiwER;;AgB3vEY;EACI,gCAAA;EACA,eAAA;EACA,cAAA;AhB8vEhB;AgB5vEgB;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AhB8vEpB;AgB3vEoB;EACI,cAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,SAAA;AhB6vExB;AgB3vEoB;EACI,gBAAA;EACA,gBAAA;EACA,iBAAA;AhB6vExB;AgB3vEoB;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;AhB6vExB;AgB1vEgB;EACI,eAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;AhB4vEpB;AgB1vEgB;EACI,qBAAA;AhB4vEpB;AgB1vEoB;EACI,cAAA;EACA,oCAAA;AhB4vExB;AgB1vEoB;EACI,qBAAA;AhB4vExB;AgBtvEI;EACI,yBAAA;EACA,0BAAA;AhBwvER;AgBtvEQ;EACI,6BAAA;EACA,gBAAA;AhBwvEZ;AgBvvEY;EACI,qBAAA;EACA,gBAAA;EACA,eAAA;AhByvEhB;AgBvvEgB;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;AhByvEpB;;AiBntFA;EACI,SAAA;EACA,kBbuJ4B;EatJ5B,cbWyB;EaVzB,mBAAA;EACA,sBAAA;EACA,kBAAA;AjBstFJ;AiBptFI;EACI,yBAAA;AjBstFR;AiBntFI;EACI,yBAAA;AjBqtFR;AiBltFI;EACI,yBAAA;AjBotFR;AiBjtFI;EACI,yBAAA;AjBmtFR;AiBhtFI;EACI,yBAAA;AjBktFR;AiB/sFI;EACE,cbfuB;EagBvB,YAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AjBitFN;AiB/sFM;;EAEI,0BAAA;AjBitFV;AiB9sFM;EAEE,UAAA;AjB+sFR;AiB3sFI;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AjB6sFR;AiB1sFI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AjB4sFR;AiBzsFI;EACI,cAAA;EACA,cAAA;AjB2sFR;AiBxsFI;EACI,kBAAA;AjB0sFR;;AkBjxFA;EACI,eAAA;EACA,kBduJ4B;AJ6nFhC;;AkBlxFA;EACI,gDdkRuB;AJmgF3B;;AmB1xFA;;;;;kCAAA;AAMA;EACE,2BAAA;EACA,4CAAA;EACA,qPAAA;EACA,mBAAA;EACA,kBAAA;AnB6xFF;AmB3xFA;;0BAAA;AAGA;EACE,qBAAA;EACA,gDAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,0BAAA;EACA,mCAAA;EACA,kCAAA;AnB6xFF;;AmB3xFA;;0BAAA;AAGA;EACE,uBAAA;EACA,oBAAA;AnB8xFF;;AmB5xFA;EACE,cAAA;AnB+xFF;;AmB7xFA;EACE,cAAA;AnBgyFF;;AmB9xFA;;oCAAA;AAGA;;EAEE,qBAAA;EACA,oBAAA;EACA,sBAAA;AnBiyFF;;AmB/xFA;EACE,kBAAA;AnBkyFF;;AmBhyFA;;0BAAA;AAGA;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;AnBmyFF;;AmBjyFA;EACE,kBAAA;AnBoyFF;;AmBlyFA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AnBqyFF;;AmBnyFA;EACE,MAAA;EACA,mBAAA;AnBsyFF;;AmBpyFA;;EAEE,kBAAA;EACA,kBAAA;AnBuyFF;;AmBryFA;;0BAAA;AAGA;EAGE,0CAAA;AnBwyFF;AmBtxFA;EACE;IAKE,uBAAA;EnByyFF;EmBvyFA;IAKE,yBAAA;EnByyFF;AACF;AmBvyFA;;0BAAA;AAGA;EACE,gEAAA;EAKA,wBAAA;AnByyFF;;AmBvyFA;EACE,gEAAA;EAKA,yBAAA;AnB0yFF;;AmBxyFA;EACE,gEAAA;EAKA,yBAAA;AnB2yFF;;AmBzyFA;EACE,gEAAA;EAKA,uBAAA;AnB4yFF;;AmB1yFA;EACE,gEAAA;EAKA,uBAAA;AnB6yFF;;AmB3yFA;;0BAAA;AAIA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmB1yFA;EACI,gBAAA;AnB6yFJ;;AmBzyFA,oCAAA;ACnjBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;ApBg2GN;AoB71GI;EACE,eAAA;EACA,WAAA;ApB+1GN;AoB51GI;EACI,SAAA;ApB81GR;AoB51GQ;EAEI,UAAA;EACA,SAAA;ApB61GZ;AoBz1GI;EACI,SAAA;ApB21GR;AoBx1GI;EACE,gBAAA;ApB01GN;AoBv1GI;EACI,gBAAA;ApBy1GR;AoBv1GQ;;;;;;EAMI,cAAA;EACA,iBAAA;ApBy1GZ;AoBr1GG;EACI,eAAA;EACA,gBhByNyB;EgBxNzB,iBAAA;EACA,yBAAA;EACA,SAAA;ApBu1GP;AoBp1GG;;EAEI,aAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;ApBs1GP;AoBp1GO;;EACI,kBAAA;ApBu1GX;AoBn1GY;;;EAEI,UAAA;EACA,UAAA;ApBs1GhB;AoBl1GG;;;;;;EAMI,iBAAA;EACA,sBAAA;ApBo1GP;AoBj1GG;EACI,gBAAA;ApBm1GP;AoBj1GG;EACI,eAAA;EACA,gBhB8KyB;EgB7KzB,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;ApBm1GP;AoBj1GG;EACK,gBhB0KwB;EgBzKxB,iBhBwJuB;EgBvJvB,iBAAA;EACA,iBAAA;ApBm1GR;AoBh1GG;EACC,WAAA;ApBk1GJ;AoB/0GI;EACI,kBAAA;ApBi1GR;;AoB50GI;EACI,chByIuB;EgBxIvB,yBAAA;ApB+0GR;AoB70GI;EACI,chBuIuB;AJwsG/B;AoB70GQ;EACI,cAAA;EACA,kBAAA;ApB+0GZ;AoB50GI;EACI,gBhB2IwB;EgB1IxB,gBAAA;ApB80GR;AoB70GQ;EACI,chBlGiB;EgBmGjB,iBAAA;EACA,gBhBqIoB;AJ0sGhC;AoB50GI;EACG,gBhBiIyB;EgBhIzB,kBhBiHwB;AJ6tG/B;AoB50GI;EACI,gBAAA;ApB80GR;AoB50GI;EACI,iBAAA;EACA,gBAAA;ApB80GR;AoB50GQ;EACI,iBAAA;ApB80GZ;AoB10GI;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ApB40GR;AoB10GQ;EACI,WAAA;ApB40GZ;;AoBv0GA;EACE,gBAAA;EACA,oBAAA;ApB00GF;;AoBv0GA;EACI,mBAAA;ApB00GJ;;AoBv0GA;EACE,yBAAA;ApB00GF;;AqBr/GA;EACI,kBAAA;EACA,MAAA;EACA,aAAA;ArBw/GJ;AqBt/GI;EACI,iBAAA;EACA,YAAA;ArBw/GR;;AqBp/GA;;EAEI,eAAA;EACA,MAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,OAAA;EACA,aAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;ArBu/GJ;AqBr/GI;;EACI,kBAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;ArBw/GR;AqBt/GQ;;EACE,wBAAA;ArBy/GV;AqBv/GQ;;EACI,YAAA;ArB0/GZ;AqBt/GI;;EACI,cAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA;ArBy/GR;AqBv/GQ;;EACI,aAAA;EACA,mBAAA;EACA,SAAA;ArB0/GZ;AqBv/GQ;;EACI,WAAA;EACA,cAAA;EACA,eAAA;ArB0/GZ;AqBv/GQ;;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;ArB0/GZ;AqBt/GI;;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;ArBy/GN;AqBr/GI;;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;ArBw/GN;AqBt/GM;;EACI,WAAA;EACA,YAAA;ArBy/GV;AqBr/GI;;EACI,gBAAA;EACA,cAAA;ArBw/GR;AqBt/GQ;;EACI,SAAA;EACA,kBAAA;EACA,WAAA;ArBy/GZ;AqBr/GY;;EACI,eAAA;ArBw/GhB;AqBr/GY;;EACI,mBAAA;EACA,cjB9Fa;EiB+Fb,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;ArBw/GhB;AqBr/GY;;EACE,gBAAA;ArBw/Gd;AqBr/GY;;;EAEE,UAAA;ArBw/Gd;AqBr/GY;;;EAEI,UAAA;ArBw/GhB;AqBp/GQ;;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,+BjBtGiB;EiBuGjB,kBAAA;ArBu/GZ;AqBp/GQ;;EACE,gBAAA;ArBu/GV;AqBl/GU;;;;EACE,aAAA;ArBu/GZ;AqBl/GI;;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;ArBq/GR;AqBn/GQ;;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;ArBs/GZ;AqBl/GI;;EACI,kBAAA;EACA,mBAAA;EACA,UAAA;ArBq/GR;AqB9+GQ;;EACI,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ArBi/GZ;AqB9+GQ;;EACI,cAAA;EACA,UAAA;EACA,mBAAA;EfzIJ,iCAAA;AN+nHR;AqBl/GQ;;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,0CjB9KiB;AJmqH7B;AqBj/GQ;;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,cjBhNiB;EiBiNjB,iBAAA;EACA,2DAAA;ArBo/GZ;AqBj/GQ;;EACI,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,ejByBmB;EiBxBnB,cjB3NiB;EiB4NjB,qBAAA;EACA,gBjB6BoB;EiB5BpB,iBAAA;EACA,gBAAA;ArBo/GZ;AqBh/GI;;EACI,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;ArBm/GR;AqBj/GQ;;EACI,WAAA;EACA,YAAA;ArBo/GZ;AqBh/GI;;;EAEI,cAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;ArBm/GR;AqBh/GI;;EftLA,mBFzByB;EE6BzB,iDAAA;EeoLI,UAAA;ArBu/GR;AMtvHE;;EACE,mBFFyB;AJ2vH7B;AMjlHQ;;;;;;;;;;;;EAME,cFjImB;EEkInB,YAAA;ANylHV;AMtlHQ;;;EAEI,UAAA;ANylHZ;AMnlHM;;EACE,cF9IqB;AJouH7B;AMplHM;;EACE,yBFjJqB;EEkJrB,YAAA;ANulHR;AMllHM;;;;;;EAGE,yBAAA;ANulHR;AMrlHM;;EACE,yBF7JqB;EE8JrB,YAAA;ANwlHR;AMpyHE;;EACE,mBFkHyB;AJqrH7B;AMvxHU;;;;;;;EAME,cFgCiB;EE/BjB,UAAA;AN0xHZ;AMjyHU;;;;;;;EAME,cFsCiB;EErCjB,UAAA;ANoyHZ;AM3yHU;;;;;;;EAME,cFmCiB;EElCjB,UAAA;AN8yHZ;AMrzHU;;;;;;;EAME,cFyCiB;EExCjB,UAAA;ANwzHZ;AM/zHU;;;;;;;EAME,cF4CiB;EE3CjB,UAAA;ANk0HZ;;AqB5jHA;EACI,gCAAA;ArB+jHJ;;AqB7jHA;EACI,wBAAA;ArBgkHJ;;AqB3jHQ;;EAEI,cjB1SiB;AJw2H7B;AqB3jHQ;EACI,oCAAA;ArB6jHZ;;AqBvjHA;EACI,kBAAA;EACA,YAAA;EACA,yBjBkCyB;EiBjCzB,yBAAA;Ef5TA,0DAAA;AN23HJ;AqB1jHI;EACI,oBAAA;EACA,+BAAA;EACA,gBAAA;ArB4jHR;AqBzjHI;EACI,gBAAA;ArB2jHR;AqBvjHI;EACI,mBAAA;ArByjHR;;AqBnjHE;;EAEI,YAAA;EACA,gBAAA;ArBsjHN;;AqBljHA;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA,EAAA,8BAAA;EAEA,4EAAA;EACA,kBAAA;EACA,gBAAA;ArBqjHF;AqBljHI;EACE,cjBlWuB;AJs5H7B;AqBljHI;EACE,gBAAA;EACA,+BjB5UuB;EiB6UvB,cAAA;EACA,eAAA;ArBojHN;AqBljHM;EACE,cjB3WqB;AJ+5H7B;;AqB9iHA;EACE,aAAA;ArBijHF;;AqB9iHA;EACE,aAAA;ArBijHF;;AqB7iHA;EACI,aAAA;EACA,yBAAA;EACA,8CAAA;EACA,WAAA;EACA,WAAA;ArBgjHJ;AqB9iHI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;ArBgjHR;AqB7iHI;EACI,WAAA;EACA,cAAA;ArB+iHR;AqB5iHI;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EACA,+BAAA;ArB8iHR;;AsB58HA;EACI,sBAAA;AtB+8HJ;AsB78HI;EACI,yBAAA;AtB+8HR;AsB58HI;EACI,qBAAA;EACA,WAAA;EACA,eAAA;AtB88HR;AsB38HI;EACI,gBAAA;EACA,UAAA;EACA,gBAAA;AtB68HR;AsB38HQ;EACI,qBAAA;AtB68HZ;AsB38HY;EACI,cAAA;EACA,elB+Ke;EkB9Kf,mBlBuOe;EkBtOf,yBAAA;EACA,qBAAA;AtB68HhB;AsB38HgB;EACI,qBAAA;AtB68HpB;AsBv8HI;EACI,mBlB2NuB;EkB1NvB,gBAAA;AtBy8HR;AsBt8HI;EACI,cAAA;EACA,WAAA;EACA,YAAA;AtBw8HR;;AuBn/HA;EACI,eAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,UAAA;AvBs/HJ;AuBp/HI;;EAEI,qBAAA;EACA,6BAAA;EACA,0BAAA;AvBs/HR;AuBn/HI;EACI,cAAA;EACA,aAAA;EACA,0BAAA;EACA,WAAA;AvBq/HR;AuBl/HI;EACI,WAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AvBo/HR;AuBj/HI;EACE,QAAA;EACA,WAAA;EACA,eAAA;AvBm/HN;AuBh/HI;;EAEI,WAAA;EACA,iBAAA;EACA,UAAA;AvBk/HR;AuB/+HI;EACI,cAAA;AvBi/HR;AuB9+HI;EACI,cAAA;AvBg/HR;AuB7+HI;;;EAGI,cAAA;EACA,kBAAA;AvB++HR;AuB5+HI;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;AvB8+HR;AuB3+HI;;EAEI,gBAAA;AvB6+HR;AuB1+HI;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AvB4+HR;AuB1+HM;EACE,yBAAA;AvB4+HR;AuB1+HQ;EAEE,sBAAA;AvB2+HV;AuBt+HI;;EAEI,qBAAA;AvBw+HR;AuBr+HI;EACI,yBnBvBqB;AJ8/H7B;AuBr+HI;EACI,yBnB7BqB;AJogI7B;AuBr+HI;EACI,yBnBnCqB;AJ0gI7B;AuBr+HI;EACI,yBnB7BqB;AJogI7B;AuBr+HI;EACI,yBnB7BqB;AJogI7B;AuBp+HI;EACI,eAAA;EACA,YAAA;AvBs+HR;AuBn+HI;EACI,cAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;AvBq+HR;AuBl+HI;;;EAGI,WAAA;EACA,YAAA;EACA,mBAAA;AvBo+HR;AuBj+HI;EACI,YAAA;AvBm+HR;AuBj+HQ;EACI,kBAAA;AvBm+HZ;AuB/9HI;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AvBi+HR;AuB99HI;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AvBg+HR;AuB59HQ;EACI,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AvB89HZ;AuB39HQ;EACI,kBAAA;AvB69HZ;AuB39HY;EACI,kBAAA;EACA,SAAA;AvB69HhB;AuB19HY;;EAEI,kBAAA;AvB49HhB;AuBx9HQ;EACI,kBAAA;AvB09HZ;AuBx9HY;EACE,kBAAA;EACA,WAAA;EACA,mBnBoEiB;EmBnEjB,cnB9He;AJwlI7B;AuBx9Hc;EACE,UAAA;AvB09HhB;AuBt9HY;EACI,eAAA;AvBw9HhB;AuBp9HQ;EACM,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;AvBs9Hd;AuB98HY;EACM,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AvBg9HlB;AuB98HkB;EACG,gBAAA;AvBg9HrB;AuB58HY;EAEI,6BAAA;AvB68HhB;AuBx8HgB;EACI,qCAAA;AvB08HpB;AuBr8HQ;;EAEI,qBAAA;EACA,yBAAA;AvBu8HZ;AuBl8HI;EACI,UAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AvBo8HR;AuBh8HQ;EACI,iBAAA;AvBk8HZ;AuB/7HQ;EACI,gBAAA;AvBi8HZ;AuB57HQ;EACE,qBAAA;AvB87HV;AuB57HU;EACG,0CAAA;EACA,0CAAA;EACA,uCAAA;EACA,YAAA;EACA,aAAA;AvB87Hb;AuB37HU;EACG,0CAAA;EACA,+BAAA;EACA,uCAAA;EACA,YAAA;EACA,aAAA;AvB67Hb;AuB17HU;EAEG,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;AvB27Hb;AuBt7HQ;EACE,8CAAA;EACA,uBAAA;EACA,iBAAA;AvBw7HV;AuBn7HI;EACI,SAAA;AvBq7HR;;AuB/6HI;EjB7OI,+CAAA;ANoqIR;AuBp7HM;EAEE,UAAA;AvBq7HR;AuBl7HI;EjBrPI,8CAAA;AN8qIR;AuBp7HM;EjB1PE,8CAAA;ANqrIR;AuBv7HM;EjB9PE,8CAAA;AN4rIR;;AwB9wIA;EACE,mBpB4J8B;EoB3J9B,+CAAA;EACA,yBAAA;EACA,cpB4J0B;EoB3J1B,mBAAA;EACA,kBAAA;EACA,cAAA;EAMA,gFAAA;AxBgxIF;AwB9wII;EACI,4BAAA;AxBgxIR;AwB9wIQ;EACI,eAAA;EACA,gBAAA;AxBgxIZ;AwB5wII;EAIE,oBAAA;EACA,SAAA;AxB2wIN;AwB/wIM;EACE,6BAAA;AxBixIR;AwB5wIM;EACI,gBAAA;AxB8wIV;AwB1wII;EACI,kBpBoHwB;AJwpIhC;AwB1wIQ;EACE,aAAA;AxB4wIV;AwBxwII;EACI,yBpByBqB;AJivI7B;AwBxwIQ;EACI,yBpBsBiB;AJovI7B;AwBtwIY;EACI,cpBvCa;AJ+yI7B;AwBnwII;EACI,yBpBuBqB;AJ8uI7B;AwBlwII;EACI,yBpBgBqB;AJovI7B;AwBjwII;EACI,yBpBSqB;AJ0vI7B;AwBhwII;EACI,yBpBEqB;AJgwI7B;AwB/vII;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;AxBiwIR;AwB9vII;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AxBgwIR;AwB7vII;EACE,cAAA;AxB+vIN;AwB5vII;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AxB8vIN;AwB3vII;EACI,mBpB2JuB;EoB1JvB,kBAAA;EACA,cpBxEqB;AJq0I7B;AwB1vII;EACI,6BAAA;EACA,SAAA;AxB4vIR;AwBxvIY;EACI,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,cpBtDa;AJgzI7B;AwBtvIQ;EACI,SAAA;AxBwvIZ;AwBpvII;EACI,6BAAA;EACA,gBAAA;EACA,gBAAA;AxBsvIR;AwBnvIQ;EACI,iBAAA;EACA,kBAAA;AxBqvIZ;AwBlvIQ;EACI,mBpBqBoB;AJ+tIhC;;AyB33IA;EACI,uBAAA;EACA,gBAAA;AzB83IJ;AyB53II;;EAEI,cAAA;EACA,eAAA;EACA,6BAAA;AzB83IR;AyB33II;EACI,eAAA;EACA,gBAAA;AzB63IR;;A0Bz4II;EACE,gBAAA;EACA,gBAAA;A1B44IN;A0B14II;EACE,kBAAA;A1B44IN;A0Bx4IE;EACE,gBAAA;A1B04IJ;A0Bx4II;EACE,gBAAA;EACA,gCAAA;A1B04IN;A0Bt4IE;EACE,gBAAA;A1Bw4IJ;A0Br4IE;EACE,aAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;A1Bu4IJ;A0Br4IE;EACE,gBAAA;A1Bu4IJ;A0Br4II;EACE,ctBJuB;AJ24I7B;A0Bn4IE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;A1Bq4IJ;A0Bn4II;EACE,SAAA;A1Bq4IN;;A2Bh7II;EACI,aAAA;A3Bm7IR;A2Bj7IM;EACE,mBAAA;A3Bm7IR;A2B/6II;EACI,kBAAA;EACA,oBAAA;EACA,iBAAA;A3Bi7IR;A2B/6IQ;EACI,gBAAA;A3Bi7IZ;A2B76II;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;A3B+6IR;A2B56II;EACI,iBAAA;A3B86IR;A2B36II;EACI,qBAAA;A3B66IR;A2B16II;EACE,cAAA;A3B46IN;A2Bx6IM;EACE,iBAAA;EACA,gBAAA;A3B06IR;A2Bt6II;EACI,kBAAA;EACA,kBAAA;A3Bw6IR;;A4Bv9IA;EACI,aAAA;A5B09IJ;;A6Bn9II;EACI,sBAAA;A7Bs9IR;A6Bp9IQ;EACE,iBAAA;EACA,cAAA;A7Bs9IV;A6Bp9IY;EACI,gBAAA;A7Bs9IhB;A6Bp9IY;EACE,czBWe;EyBVf,eAAA;EACA,kBAAA;A7Bs9Id;A6Bl9II;EACI,sBAAA;A7Bo9IR;A6Bl9IQ;EACE,czBCmB;AJm9I7B;A6Bj9IQ;EACE,gBAAA;EACA,mBAAA;A7Bm9IV;A6Bh9II;EACI,cAAA;EACA,gBAAA;A7Bk9IR;A6Bh9IQ;EACI,iBAAA;A7Bk9IZ;;A8B5/IA;EAEE;IACE,UAAA;E9B8/IF;E8B5/IE;IACE,cAAA;E9B8/IJ;E8B3/IE;IACE,eAAA;IACA,eAAA;E9B6/IJ;E8Bz/IE;IACI,iBAAA;E9B2/IN;E8Bx/IE;IACI,aAAA;E9B0/IN;E8Bv/IE;IACI,aAAA;E9By/IN;E8Br/IM;IACI,mBAAA;IACA,kBAAA;E9Bu/IV;E8Bn/IQ;IACE,SAAA;IACA,eAAA;E9Bq/IV;E8Bh/IU;IACE,gBAAA;E9Bk/IZ;E8Bh/IU;IACI,mBAAA;E9Bk/Id;E8B9+IM;IACI,cAAA;E9Bg/IV;E8B7+IM;IACI,aAAA;E9B++IV;E8B5+IM;;IAEI,SAAA;IACA,gBAAA;IACA,wBAAA;IACA,WAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;E9B8+IV;E8B5+IU;;IACI,aAAA;E9B++Id;E8B3+IM;;IAEI,c1B9DiB;EJ2iJ3B;E8B1+IM;IAEI,c1BpBiB;EJ+/I3B;E8Bx+IM;IACI,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,mB1B7BiB;EJugJ3B;E8Bx+IU;IACI,eAAA;E9B0+Id;E8Bv+IU;IACI,eAAA;E9By+Id;E8Bt+IU;IACI,WAAA;IACA,6BAAA;E9Bw+Id;E8Bp+IM;IACI,yB1B9CiB;EJohJ3B;E8Bn+IM;IACI,WAAA;E9Bq+IV;E8Bn+IU;IACI,eAAA;E9Bq+Id;E8B/9IE;IxB9GA,0DAAA;ENolJF;E8Bj+IM;IACI,QAAA;IxB5DJ,mCAAA;ENoiJN;E8Bp+IM;IxBhEA,iCAAA;EN2iJN;E8Bv+IM;IACI,kBAAA;IACA,kBAAA;E9By+IV;E8Br+IU;IxB1EJ,oCAAA;ENsjJN;E8Bx+IU;;IxB9EJ,iCAAA;EN8jJN;E8B3+IU;IxBnFJ,oCAAA;ENqkJN;E8B9+IU;IACI,YAAA;IACA,UAAA;E9Bg/Id;E8B1+IM;IACI,UAAA;IACA,QAAA;IxBjGJ,mCAAA;ENklJN;E8B5+IE;;;IAGE,8BAAA;E9B8+IJ;E8B5+IE;IACE,QAAA;IxBvJD,+BAAA;IAGA,6BAAA;ENwoJH;E8Bj/IE;IACE,UAAA;E9Bm/IJ;E8Bj/IE;IACE,WAAA;IxB9JD,kCAAA;IAGA,6BAAA;ENopJH;E8Bt/IE;IACE,QAAA;IxBlKD,4BAAA;IAGA,6BAAA;EN6pJH;E8B3/IE;IACE,UAAA;E9B6/IJ;E8B3/IE;IACE,WAAA;IxBzKD,+BAAA;IAGA,6BAAA;ENyqJH;EMrmJE;IACE;MAAI,QAAA;MAAU,uBAAA;INymJhB;IMxmJE;MAAK,QAAA;MAAU,yBAAA;IN4mJjB;IM3mJE;MAAK,yBAAA;IN8mJP;IM7mJE;MAAM,yBAAA;INgnJR;EACF;EM/lJE;IACE;MAAK,QAAA;MAAU,yBAAA;INmoJjB;IMloJE;MAAM,yBAAA;INqoJR;IMpoJE;MAAM,uBAAA;INuoJR;IMtoJE;MAAO,QAAA;MAAU,oBAAA;IN0oJnB;EACF;EMxnJE;IACE;MAAI,WAAA;MAAa,uBAAA;IN4pJnB;IM3pJE;MAAK,WAAA;MAAa,0BAAA;IN+pJpB;IM9pJE;MAAK,0BAAA;INiqJP;IMhqJE;MAAM,0BAAA;INmqJR;EACF;EMnpJE;IACE;MAAK,WAAA;MAAY,0BAAA;INurJnB;IMtrJE;MAAM,wBAAA;INyrJR;IMxrJE;MAAM,wBAAA;IN2rJR;IM1rJE;MAAO,WAAA;MAAY,oBAAA;IN8rJrB;EACF;E8BlpJE;IACE;MAAI,UAAA;I9BqsJN;I8BpsJE;MAAM,UAAA;I9BusJR;EACF;E8BrsJE;IACI,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,QAAA;IACA,WAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;IACA,6BAAA;IxBvNJ,0DAAA;ENm6JF;E8BvsJM;IACI,iBAAA;E9BysJV;E8BrsJE;IACI,gBAAA;E9BusJN;E8BlsJU;;IAEI,YAAA;E9BosJd;E8B/rJE;;IAEI,eAAA;IACA,wBAAA;IACA,iCAAA;IACA,MAAA;IACA,wBAAA;IACA,YAAA;IACA,WAAA;IACA,OAAA;IACA,aAAA;IACA,mBAAA;IACA,gBAAA;IACA,UAAA;IxB3PJ,0DAAA;IAwDI,oCAAA;EN84JN;E8BpsJM;IACI,SAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;E9BssJV;E8BjsJE;IACE,WAAA;E9BmsJJ;E8B/rJI;IACI,mBAAA;E9BisJR;E8B9rJI;IACI,mBAAA;E9BgsJR;E8B7rJI;IACI,uBAAA;IACA,qBAAA;E9B+rJR;E8B7rJQ;IACI,+BAAA;IACA,mCAAA;IACA,sBAAA;IACA,sBAAA;E9B+rJZ;E8B5rJQ;IACI,+BAAA;IACA,mCAAA;IACA,sBAAA;IACA,sBAAA;E9B8rJZ;AACF;A8BzrJA;EACE;IACE,gBAAA;E9B2rJF;AACF;A8BxrJA;EAEI;IACE,kBAAA;E9ByrJJ;E8BtrJE;IACE,mBAAA;E9BwrJJ;AACF;A8BprJA;EACI;IACI,2BAAA;E9BsrJN;E8BnrJE;IACI,aAAA;E9BqrJN;E8BhrJU;IACI,UAAA;IACA,kBAAA;E9BkrJd;E8B7qJE;IACI,kBAAA;E9B+qJN;E8B5qJE;IACI,cAAA;E9B8qJN;E8B1qJM;IACI,YAAA;IACA,mBAAA;E9B4qJV;E8BnqJU;;IACE,gCAAA;IACA,kCAAA;IACA,qCAAA;IACA,WAAA;IACA,qBAAA;IACA,kBAAA;IACA,YAAA;IACA,UAAA;IACA,QAAA;IACA,iCAAA;E9BsqJZ;E8BnqJU;;IACE,gCAAA;IACA,kCAAA;IACA,qCAAA;IACA,WAAA;IACA,qBAAA;IACA,kBAAA;IACA,YAAA;IACA,UAAA;IACA,QAAA;IACA,iCAAA;E9BsqJZ;E8BjqJY;IAEE,MAAA;E9BkqJd;AACF;A8BzpJA;EACE;IACE,aAAA;E9B2pJF;E8BxpJA;IACE,kBAAA;IACA,mBAAA;E9B0pJF;E8BtpJM;IACI,cAAA;IACA,kBAAA;IACA,WAAA;E9BwpJV;E8BppJE;IACI,cAAA;IACA,mBAAA;E9BspJN;E8BjpJM;IACE,gBAAA;E9BmpJR;AACF;A8B7oJA;EACE;IACE,eAAA;E9B+oJF;E8B5oJA;IACE,4BAAA;E9B8oJF;E8B5oJE;IACE,sBAAA;E9B8oJJ;E8BvoJE;;;IACE,oBAAA;E9B2oJJ;E8BtoJE;;IAEE,yBAAA;E9BwoJJ;E8BroJE;IACE,8BAAA;E9BuoJJ;E8BloJE;IACE,gBAAA;E9BooJJ;E8BloJE;IACE,kBAAA;E9BooJJ;E8BloJE;IACE,aAAA;E9BooJJ;AACF;A8BhoJA;EAEI;IACE,iBAAA;E9BioJJ;AACF;A8B7nJA;EAGM;IACE,uBAAA;E9B6nJN;E8B3nJM;IACE,8CAAA;E9B6nJR;E8B1nJM;IAEE,wBAAA;E9B2nJR;AACF;A8BnnJA;EACI;IACI,cAAA;IACA,eAAA;E9BqnJN;E8BlnJE;IACE,sBAAA;E9BonJJ;E8BlnJI;IACE,mBAAA;E9BonJN;E8B/mJM;IACI,kBAAA;E9BinJV;E8B3mJU;IACI,eAAA;E9B6mJd;E8B3mJc;IACI,eAAA;E9B6mJlB;E8BtmJM;IACI,UAAA;E9BwmJV;E8BnmJI;IACE,UAAA;IACA,aAAA;E9BqmJN;AACF;A+BhpKE;EACE,gBAAA;EACA,eAAA;A/BkpKJ;A+BjpKI;;;;;;EAME,0BAAA;A/BmpKN;;AgCzpKM;;;;;;;;;;;;EAME,oB5BsOwB;AJ47JhC;AgC9pKM;;;;;;;;;;;;EAME,mB5B8NwB;AJw8JhC;AgCnqKI;;;;;;;EAME,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,sBAAA;EACA,WAAA;AhCsqKN;;AiCvsKE;EACE,kCAAA;EACA,gBAAA;EACA,mCAAA;EACA,qBAAA;EACA,kBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;AjC0sKJ;;AiCtsKA;EAEE,kCAAA;EACA,gBAAA;EACA,mCAAA;EACA,qBAAA;EACA,kBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;AjCwsKF;AiCvsKE;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;AjCysKJ;;AiCtsKA;EACE,kCAAA;EACA,QAAA;AjCysKF;;AiCvsKA;EACE,kCAAA;EACA,SAAA;AjC0sKF;;AiCxsKA;EACE,kCAAA;EACA,SAAA;AjC2sKF;;AkCxvKA;EACI,gBAAA;AlC2vKJ;;AmCxvKM;EACE,YAAA;EACA,QAAA;AnC2vKR;AmCxvKM;EACE,YAAA;EACA,QAAA;AnC0vKR;AmCtvKE;;;EAGE,WAAA;AnCwvKJ;AmCtvKE;;EAEE,wBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AnCwvKJ;AmCtvKE;EACE,sBAAA;EAMA,kEAAA;EACA,kHAAA;EACA,4BAAA;EACA,yBAAA;AnCwvKJ;AmCtvKE;;EAEE,qBAAA;EACA,sBAAA;EAMA,+DAAA;EACA,kHAAA;EACA,kBAAA;AnCwvKJ;AmCtvKE;EACE,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,+CAAA;AnCwvKJ;AmCtvKE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yDAAA;EACA,0BAAA;EACA,4BAAA;AnCwvKJ;AmCtvKE;EACE,kBAAA;EACA,aAAA,EAAA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;AnCwvKJ;AmCtvKE;;EAEE,cAAA;AnCwvKJ;AmCtvKE;;EAEE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;AnCwvKJ;AmCtvKE;EACE,QAAA;EACA,UAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BAAA;AnCwvKJ;AmCtvKE;EACE,QAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BAAA;AnCwvKJ;AmCtvKE;EACE,YAAA;AnCwvKJ;AmCtvKE;;EAEE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AnCwvKJ;AmCtvKE;EACE,WAAA;EACA,YAAA;AnCwvKJ;AmCtvKE;EACE,gBAAA;AnCwvKJ;AmCtvKE;EACE,UAAA;EACA,gBAAA;EACA,2BAAA;AnCwvKJ;AmCtvKE;EACE,UAAA;EACA,gBAAA;EACA,2BAAA;AnCwvKJ;AmCtvKE;EACE,qBAAA;AnCwvKJ;AmCtvKM;EACE,eAAA;AnCwvKR;AmCpvKE;EACE,qBAAA;AnCsvKJ;;AmCnvKA;EACE;IACE,YAAA;EnCsvKF;AACF;AoCx4KA;EACE,2BAAA;ApC04KF;;AoCv4KA;EACE,YAAA;EAAA,eAAA;ApC04KF;;AoCv4KA;EACE,UAAA;EACA,gBAAA;EAAA,iBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAAA,eAAA;EACA,aAAA;EAAA,gBAAA;ApC04KF;;AqCx5KM;;;;;;EAME,gBAAA;ArC25KR;AqCz5KM;;;;;;EAME,eAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;ArC25KR;;AsCh7KA;;;;;kCAAA;AAMA;EACE,2BAAA;EACA,4CAAA;EACA,kOAAA;EACA,mBAAA;EACA,kBAAA;AtCm7KF;AuC97KA;EAGM;;;;;;IAME,YAAA;EvC87KN;EuC17KA;IACE,SAAA;IAEA,gBAAA;IACA,wBAAA;IACA,WAAA;IACA,cAAA;IACA,gBAAA;IACA,2BAAA;IACA,kBAAA;IACA,yBAAA;IAEA,mCAAA;IACA,mBAAA;EvC47KF;EuC37KE;IACE,aAAA;EvC67KJ;EuC17KA;IACE,cnClByB;EJ88K3B;AACF;AuCz7KA;EAMU;IACE,gCAAA;IACA,kCAAA;IACA,qCAAA;IACA,YAAA;IACA,QAAA;EvCs7KV;EuCn7KQ;IACE,gCAAA;IACA,kCAAA;IACA,qCAAA;IACA,YAAA;IACA,QAAA;EvCq7KV;AACF;AwC5+KE;EACE,aAAA;AxC8+KJ","sourcesContent":["/*!\n\n =========================================================\n * Paper Dashboard React - v1.3.0 based on Paper Dashboard 2 - v2.0.0\n =========================================================\n\n * Product Page: https://www.creative-tim.com/product/paper-dashboard-2\n * Copyright 2021 Creative Tim (http://www.creative-tim.com)\n\n * Designed by www.invisionapp.com Coded by www.creative-tim.com\n\n =========================================================\n\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n */\n\n@import 'paper-dashboard/variables';\n@import 'paper-dashboard/mixins';\n\n// Plugins CSS\n@import \"paper-dashboard/plugins/plugin-animate-bootstrap-notify\";\n@import \"paper-dashboard/plugins/plugin-perfect-scrollbar\";\n\n// Core CSS\n@import \"paper-dashboard/buttons\";\n@import \"paper-dashboard/inputs\";\n@import \"paper-dashboard/typography\";\n@import \"paper-dashboard/misc\";\n@import \"paper-dashboard/checkboxes-radio\";\n\n\n// components\n@import \"paper-dashboard/navbar\";\n@import \"paper-dashboard/page-header\";\n@import \"paper-dashboard/dropdown\";\n@import \"paper-dashboard/alerts\";\n@import \"paper-dashboard/images\";\n@import \"paper-dashboard/nucleo-outline\";\n@import \"paper-dashboard/tables\";\n@import \"paper-dashboard/sidebar-and-main-panel\";\n@import \"paper-dashboard/footers\";\n@import \"paper-dashboard/fixed-plugin\";\n\n// cards\n@import \"paper-dashboard/cards\";\n@import \"paper-dashboard/cards/card-plain\";\n@import \"paper-dashboard/cards/card-chart\";\n@import \"paper-dashboard/cards/card-user\";\n@import \"paper-dashboard/cards/card-map\";\n@import \"paper-dashboard/cards/card-stats\";\n\n@import \"paper-dashboard/responsive\";\n\n// html to react differences\n@import \"paper-dashboard/react/react-differences.scss\";\n","\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n// This file was modified by Creative Tim to keep only the animation that we need for Bootstrap Notify\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@charset \"UTF-8\";\n\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\n\nCopyright (c) 2015 Daniel Eden\n*/\n\n.animated {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.animated.infinite {\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n}\n\n.animated.hinge {\n  -webkit-animation-duration: 2s;\n  animation-duration: 2s;\n}\n\n.animated.bounceIn,\n.animated.bounceOut {\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s;\n}\n\n.animated.flipOutX,\n.animated.flipOutY {\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s;\n}\n\n@-webkit-keyframes shake {\n  from, to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n@keyframes shake {\n  from, to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n.shake {\n  -webkit-animation-name: shake;\n  animation-name: shake;\n}\n\n\n\n@-webkit-keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n\n@-webkit-keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n@keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n.fadeOutDown {\n  -webkit-animation-name: fadeOutDown;\n  animation-name: fadeOutDown;\n}\n\n@-webkit-keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n@keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n.fadeOutUp {\n  -webkit-animation-name: fadeOutUp;\n  animation-name: fadeOutUp;\n}\n","/* perfect-scrollbar v0.6.13 */\n.ps-container {\n  -ms-touch-action: auto;\n  touch-action: auto;\n  overflow: hidden !important;\n  -ms-overflow-style: none; }\n  @supports (-ms-overflow-style: none) {\n    .ps-container {\n      overflow: auto !important; } }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .ps-container {\n      overflow: auto !important; } }\n  .ps-container.ps-active-x > .ps-scrollbar-x-rail,\n  .ps-container.ps-active-y > .ps-scrollbar-y-rail {\n    display: block;\n    background-color: transparent; }\n  .ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n      background-color: #999;\n      height: 11px; }\n  .ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n      background-color: #999;\n      width: 11px; }\n  .ps-container > .ps-scrollbar-x-rail {\n    display: none;\n    position: absolute;\n    /* please don't change 'position' */\n    opacity: 0;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    -o-transition: background-color .2s linear, opacity .2s linear;\n    -moz-transition: background-color .2s linear, opacity .2s linear;\n    transition: background-color .2s linear, opacity .2s linear;\n    bottom: 0px;\n    /* there must be 'bottom' for ps-scrollbar-x-rail */\n    height: 15px; }\n    .ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n      position: absolute;\n      /* please don't change 'position' */\n      background-color: #aaa;\n      -webkit-border-radius: 6px;\n      -moz-border-radius: 6px;\n      border-radius: 6px;\n      -webkit-transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, -webkit-border-radius .2s ease-in-out;\n      transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, -webkit-border-radius .2s ease-in-out;\n      -o-transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out;\n      -moz-transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out, -moz-border-radius .2s ease-in-out;\n      transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out;\n      transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out, -webkit-border-radius .2s ease-in-out, -moz-border-radius .2s ease-in-out;\n      bottom: 2px;\n      /* there must be 'bottom' for ps-scrollbar-x */\n      height: 6px; }\n    .ps-container > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x, .ps-container > .ps-scrollbar-x-rail:active > .ps-scrollbar-x {\n      height: 11px; }\n  .ps-container > .ps-scrollbar-y-rail {\n    display: none;\n    position: absolute;\n    /* please don't change 'position' */\n    opacity: 0;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    -o-transition: background-color .2s linear, opacity .2s linear;\n    -moz-transition: background-color .2s linear, opacity .2s linear;\n    transition: background-color .2s linear, opacity .2s linear;\n    right: 0;\n    /* there must be 'right' for ps-scrollbar-y-rail */\n    width: 15px; }\n    .ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n      position: absolute;\n      /* please don't change 'position' */\n      background-color: #aaa;\n      -webkit-border-radius: 6px;\n      -moz-border-radius: 6px;\n      border-radius: 6px;\n      -webkit-transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, -webkit-border-radius .2s ease-in-out;\n      transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, -webkit-border-radius .2s ease-in-out;\n      -o-transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out;\n      -moz-transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out, -moz-border-radius .2s ease-in-out;\n      transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out;\n      transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out, -webkit-border-radius .2s ease-in-out, -moz-border-radius .2s ease-in-out;\n      right: 2px;\n      /* there must be 'right' for ps-scrollbar-y */\n      width: 6px; }\n    .ps-container > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y, .ps-container > .ps-scrollbar-y-rail:active > .ps-scrollbar-y {\n      width: 11px; }\n  .ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n      background-color: #999;\n      height: 11px; }\n  .ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n      background-color: #999;\n      width: 11px; }\n  .ps-container:hover > .ps-scrollbar-x-rail,\n  .ps-container:hover > .ps-scrollbar-y-rail {\n    opacity: 0.6; }\n  .ps-container:hover > .ps-scrollbar-x-rail:hover {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {\n      background-color: #999; }\n  .ps-container:hover > .ps-scrollbar-y-rail:hover {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {\n      background-color: #999; }\n",".btn,\n.navbar .navbar-nav > a.btn{\n    border-width: $border-thick;\n    font-weight: $font-weight-semi;\n    font-size: $font-size-small;\n    line-height: $line-height;\n    text-transform: uppercase;\n    border: none;\n    margin: 10px 1px;\n    border-radius: $border-radius-small;\n    padding: $padding-btn-vertical $padding-btn-horizontal;\n    cursor: pointer;\n\n    @include btn-styles($default-color, $default-states-color);\n    @include transition($fast-transition-time, linear);\n\n    &:hover,\n    &:focus{\n        @include opacity(1);\n        outline: 0 !important;\n    }\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle {\n         @include box-shadow(none);\n         outline: 0 !important;\n    }\n\n    .badge{\n      margin: 0;\n    }\n\n    &.btn-icon {\n        // see above for color variations\n        height: $btn-icon-size-regular;\n        min-width: $btn-icon-size-regular;\n        width: $btn-icon-size-regular;\n        padding: 0;\n        font-size: $btn-icon-font-size-regular;\n        overflow: hidden;\n        position: relative;\n        line-height: normal;\n\n        &.btn-simple{\n            padding: 0;\n        }\n\n        &.btn-sm{\n            height: $btn-icon-size-small;\n            min-width: $btn-icon-size-small;\n            width: $btn-icon-size-small;\n\n            .fa,\n            .far,\n            .fas,\n            .nc-icon{\n                font-size: $btn-icon-font-size-small;\n            }\n        }\n\n        &.btn-lg{\n            height: $btn-icon-size-lg;\n            min-width: $btn-icon-size-lg;\n            width: $btn-icon-size-lg;\n\n            .fa,\n            .far,\n            .fas,\n            .nc-icon{\n                font-size: $btn-icon-font-size-lg;\n            }\n        }\n\n        &:not(.btn-footer) .nc-icon,\n        &:not(.btn-footer) .fa,\n        &:not(.btn-footer) .far,\n        &:not(.btn-footer) .fas{\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-12px, -12px);\n            line-height: 1.5626rem;\n            width: 24px;\n        }\n\n        &.btn-neutral {\n          font-size: 20px;\n        }\n    }\n\n    &:not(.btn-icon) .nc-icon{\n        position: relative;\n        top: 1px;\n    }\n}\n\n// Apply the mixin to the buttons\n// .btn-default { @include btn-styles($default-color, $default-states-color); }\n.btn-primary { @include btn-styles($primary-color, $primary-states-color); }\n.btn-success { @include btn-styles($success-color, $success-states-color); }\n.btn-info    { @include btn-styles($info-color, $info-states-color); }\n.btn-warning { @include btn-styles($warning-color, $warning-states-color); }\n.btn-danger  { @include btn-styles($danger-color, $danger-states-color); }\n// .btn-neutral { @include btn-styles($white-color, $white-color); }\n\n.btn-outline-default { @include btn-outline-styles($default-color, $default-states-color); }\n.btn-outline-primary { @include btn-outline-styles($primary-color, $primary-states-color); }\n.btn-outline-success { @include btn-outline-styles($success-color, $success-states-color); }\n.btn-outline-info    { @include btn-outline-styles($info-color, $info-states-color); }\n.btn-outline-warning { @include btn-outline-styles($warning-color, $warning-states-color); }\n.btn-outline-danger  { @include btn-outline-styles($danger-color, $danger-states-color); }\n.btn-outline-neutral { @include btn-outline-styles($white-color, $default-states-color);\n    &:hover,\n    &:focus{\n        color: $default-states-color;\n        background-color: $white-color;\n    }\n}\n.btn-neutral {\n    @include btn-styles($white-color, $white-color);\n    color: $default-color;\n    &:hover,\n    &:focus{\n        color: $default-states-color;\n    }\n\n    &.btn-border{\n        &:hover,\n        &:focus{\n            color: $default-color;\n        }\n\n        &:active,\n        &.active,\n        .open > &.dropdown-toggle{\n             background-color: $white-color;\n             color: $default-color;\n        }\n    }\n\n    &.btn-link:active,\n    &.btn-link.active{\n        background-color: transparent;\n    }\n}\n\n.btn{\n     &:disabled,\n     &[disabled],\n     &.disabled{\n        @include opacity(.5);\n        pointer-events: none;\n    }\n}\n.btn-simple{\n    border: $border;\n    border-color: $default-color;\n    padding: $padding-btn-vertical - 1 $padding-round-horizontal - 1;\n    background-color: $transparent-bg;\n}\n\n.btn-simple,\n.btn-link{\n    &.disabled,\n    &:disabled,\n    &[disabled],\n    fieldset[disabled] & {\n        &,\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $transparent-bg;\n        }\n    }\n}\n\n.btn-link{\n  border: $none;\n  padding: $padding-base-vertical $padding-base-horizontal;\n  background-color: $transparent-bg;\n}\n\n.btn-lg{\n   @include btn-size($padding-large-vertical, $padding-large-horizontal, $font-size-large, $border-radius-large);\n}\n.btn-sm{\n    @include btn-size($padding-small-vertical, $padding-small-horizontal, $font-size-small, $border-radius-small);\n}\n\n.btn-wd {\n    min-width: 140px;\n}\n.btn-group.select{\n    width: 100%;\n}\n.btn-group.select .btn{\n    text-align: left;\n}\n.btn-group.select .caret{\n    position: absolute;\n    top: 50%;\n    margin-top: -1px;\n    right: 8px;\n}\n.btn-group {\n  .btn + .btn {\n    margin-left: -3px;\n  }\n  .btn {\n    &:focus {\n      background-color: $info-color !important;\n    }\n  }\n}\n\n\n.btn-round{\n    border-width: $border-thin;\n    border-radius: $btn-round-radius;\n    padding-right: $padding-round-horizontal;\n    padding-left: $padding-round-horizontal;\n\n    &.btn-simple{\n        padding: $padding-btn-vertical - 1  $padding-round-horizontal - 1;\n    }\n}\n\n.no-caret {\n  &.dropdown-toggle::after {\n    display: none;\n  }\n}\n","//== Buttons\n//\n//## For each of Bootstrap's buttons, define text, background and border color.\n\n$font-color:                 #66615b !default;\n$fill-font-color:            rgba(255, 255, 255, 0.8);\n$font-family-sans-serif:     'Montserrat', \"Helvetica\", Arial, sans-serif;\n$sans-serif-family:          'Montserrat', 'Helvetica Neue',  Arial, sans-serif;\n\n\n$none:                       0   !default;\n$border-thin:                1px !default;\n$border-thick:               2px !default;\n\n$white-color:                #FFFFFF !default;\n$white-bg:                   #FFFFFF !default;\n$orange-bg:                  #e95e38 !default;\n\n$smoke-bg:                   #F5F5F5 !default;\n$light-black:                #444    !default;\n\n$black-bg:                   rgba(30,30,30,.97) !default;\n\n$black-color:                #2c2c2c !default;\n$black-hr:                   #444444 !default;\n\n$hr-line:                    rgba(0,0,0, .1) !default;\n\n$light-gray:                 #E3E3E3 !default;\n$medium-gray:                #DDDDDD !default;\n$dark-gray:                  #9A9A9A !default;\n\n$table-line-color:           #ccc !default;\n$muted-color:                #a49e93 !default;\n\n$opacity-gray-3:             rgba(222,222,222, .3) !default;\n$opacity-gray-5:             rgba(222,222,222, .5) !default;\n$opacity-gray-8:             rgba(222,222,222, .8) !default;\n\n\n$opacity-5:                  rgba(255,255,255, .5) !default;\n$opacity-8:                  rgba(255,255,255, .8) !default;\n\n$datepicker-color-days:             rgba(255,255,255, .8)  !default;\n$datepicker-color-old-new-days:     rgba(255,255,255, .4)  !default;\n\n\n$opacity-1:                  rgba(255,255,255, .1) !default;\n$opacity-2:                  rgba(255,255,255, .2) !default;\n\n$transparent-bg:             transparent !default;\n$dark-background:            #555555 !default;\n\n$gray-input-bg:              #fffcf5 !default;\n$danger-input-bg:            #FFC0A4 !default;\n$success-input-bg:           #ABF3CB !default;\n$other-medium-gray:          #A49E93 !default;\n$transparent-bg:             transparent !default;\n\n$placeholder-gray:           rgba(210, 210, 210, 1)  !default;\n\n$default-color:              #66615B !default;\n$default-bg:                 #66615B !default;\n$default-states-color:       #403D39 !default;\n\n$smoke-bg:                   #F5F5F5 !default;\n$pale-bg:                    #FFFCF5 !default;\n$medium-pale-bg:             #F1EAE0 !default;\n$default-body-bg:                 #f4f3ef !default;\n\n$primary-color:              #51cbce !default;\n$primary-states-color:       darken($primary-color, 10%) !default;\n\n$success-color:              #6bd098 !default;\n$success-states-color:       darken($success-color, 10%) !default;\n\n$info-color:                 #2d3e75 !default;\n$info-states-color:          darken($info-color, 10%) !default;\n\n$warning-color:              #fbc658 !default;\n$warning-states-color:       darken($warning-color, 10%) !default;\n\n$danger-color:               #ef8157 !default;\n$danger-states-color:        darken($danger-color, 8%) !default;\n\n$link-disabled-color:        #666666 !default;\n\n$purple-color:               #c178c1 !default;\n$purple-states-color:        darken($purple-color, 8%) !default;\n\n$medium-pale-bg:             #F1EAE0 !default;\n\n$brown-color:                #dcb285 !default;\n$default-color-opacity:      rgba(182, 182, 182, .6) !default;\n$primary-color-opacity:      rgba(249, 99, 50, .3) !default;\n$success-color-opacity:      rgba(24, 206, 15, .3) !default;\n$info-color-opacity:         rgba(44, 168, 255, .3) !default;\n$warning-color-opacity:      rgba(255, 178, 54, .3) !default;\n$danger-color-opacity:       rgba(255, 54, 54, .3) !default;\n\n$new-blue:            #1DC7EA;\n$new-purple:          #9368E9;\n$new-red:             #FB404B;\n$new-green:           #87CB16;\n$new-orange:          #FFA534;\n$new-dark-blue:       #1F77D0;\n$new-black:           #5e5e5e;\n\n$orange-color:               #f96332 !default;\n$color-red-error: rgb(185, 74, 72) !default;\n$color-grey-arrow: rgba(204, 204, 204, 0.2) !default;\n\n$bg-nude:               #FFFCF5 !default;\n$bg-primary:            lighten($primary-color, 7%) !default;\n$bg-info:               lighten($info-color, 7%) !default;\n$bg-success:            lighten($success-color, 7%) !default;\n$bg-warning:            lighten($warning-color, 7%) !default;\n$bg-danger:             lighten($danger-color, 7%) !default;\n$bg-brown:              lighten($brown-color, 7%) !default;\n$bg-purple:             lighten($purple-color, 7%) !default;\n\n//     brand Colors\n$brand-primary:              $primary-color !default;\n$brand-info:                 $info-color !default;\n$brand-success:              $success-color !default;\n$brand-warning:              $warning-color !default;\n$brand-danger:               $danger-color !default;\n$brand-inverse:              $black-color !default;\n\n$link-disabled-color:        #666666 !default;\n$dark-color:                 #212120 !default;\n//     light colors\n$light-blue:                 rgba($primary-color, .2);\n$light-azure:                rgba($info-color, .2);\n$light-green:                rgba($success-color, .2);\n$light-orange:               rgba($warning-color, .2);\n$light-red:                  rgba($danger-color, .2);\n\n// padding for links inside dropdown menu\n$padding-dropdown-vertical:     10px !default;\n$padding-dropdown-horizontal:   15px !default;\n\n$margin-large-vertical:        30px !default;\n$margin-base-vertical:         15px !default;\n\n// border radius for buttons\n$border-radius-none:             0px !default;\n$border-radius-btn-small:      26px !default;\n$border-radius-btn-base:       20px !default;\n$border-radius-btn-large:      50px !default;\n\n\n$margin-bottom:                0 0 10px 0 !default;\n$border-radius-small:           3px !default;\n$border-radius-base:            4px !default;\n$border-radius-large:           6px !default;\n$border-radius-x-large:         8px !default;\n$border-radius-extreme:         12px !default;\n\n//variables used in cards\n$card-black-color:          #252422 !default;\n$card-muted-color:          #ccc5b9 !default;\n\n$card-background-blue:      #b8d8d8 !default;\n$card-font-blue:            #506568 !default;\n$card-subtitle-blue:        #7a9e9f !default;\n\n$card-background-green:      #d5e5a3 !default;\n$card-font-green:            #60773d !default;\n$card-subtitle-green:        #92ac56 !default;\n\n$card-background-yellow:      #ffe28c !default;\n$card-font-yellow:            #b25825 !default;\n$card-subtitle-yellow:        #d88715 !default;\n\n$card-background-brown:      #d6c1ab !default;\n$card-font-brown:            #75442e !default;\n$card-subtitle-brown:        #a47e65 !default;\n\n$card-background-purple:      #baa9ba !default;\n$card-font-purple:            #3a283d !default;\n$card-subtitle-purple:        #5a283d !default;\n\n$card-background-orange:      #ff8f5e !default;\n$card-font-orange:            #772510 !default;\n$card-subtitle-orange:        #e95e37 !default;\n\n\n\n//== Components\n//\n\n$padding-input-vertical:        11px !default;\n$padding-input-horizontal:      11px !default;\n\n$padding-btn-vertical:         11px !default;\n$padding-btn-horizontal:       22px !default;\n\n$padding-base-vertical:        .5rem !default;\n$padding-base-horizontal:      .7rem !default;\n\n$padding-round-horizontal:     23px !default;\n\n$padding-simple-vertical:      10px !default;\n$padding-simple-horizontal:    17px !default;\n\n$padding-large-vertical:       15px !default;\n$padding-large-horizontal:     48px !default;\n\n$padding-small-vertical:        5px !default;\n$padding-small-horizontal:     15px !default;\n\n// $padding-xs-vertical:           1px !default;\n// $padding-xs-horizontal:         5px !default;\n\n$padding-label-vertical:        2px !default;\n$padding-label-horizontal:     12px !default;\n\n$margin-large-vertical:        30px !default;\n$margin-base-vertical:         15px !default;\n\n$margin-base-horizontal:       15px !default;\n\n$margin-bottom:                 10px        !default;\n$border:                        1px solid   !default;\n$border-radius-extra-small:     0.125rem    !default;\n$border-radius-small:           0.1875rem   !default;\n$border-radius-large:           0.25rem     !default;\n$border-radius-extreme:         0.875rem    !default;\n\n$border-radius-large-top:      $border-radius-large $border-radius-large 0 0 !default;\n$border-radius-large-bottom:   0 0 $border-radius-large $border-radius-large !default;\n\n$btn-round-radius:             30px         !default;\n\n$height-base:                  40px         !default;\n\n$btn-icon-size:                 3.5rem       !default;\n$btn-icon-size-regular:         2.375rem      !default;\n$btn-icon-font-size-regular:    0.9375rem     !default;\n$btn-icon-font-size-small:      0.6875rem      !default;\n$btn-icon-size-small:           1.875rem     !default;\n$btn-icon-font-size-lg:         1.325rem     !default;\n$btn-icon-size-lg:              3.6rem         !default;\n\n$font-size-h1:                 3.5em        !default; // ~ 49px\n$font-size-h2:                 2.5em        !default; // ~ 35px\n$font-size-h3:                 2em          !default; // ~ 28px\n$font-size-h4:                 1.714em      !default; // ~ 24px\n$font-size-h5:                 1.57em       !default; // ~ 22px\n$font-size-h6:                 1em          !default; // ~ 14px\n\n$font-paragraph:               1em          !default;\n$font-size-navbar:             1em          !default;\n$font-size-mini:               0.7142em     !default;\n$font-size-small:              0.8571em     !default;\n$font-size-base:               14px         !default;\n$font-size-large:              1rem         !default;\n$font-size-large-navbar:       20px         !default;\n$font-size-blockquote:         1.1em        !default; // ~ 15px\n$font-size-medium:             16px         !default;\n$font-size-xs:                 12px         !default;\n\n$font-weight-light:             300         !default;\n$font-weight-normal:            400         !default;\n$font-weight-semi:              600         !default;\n$font-weight-bold:              700         !default;\n\n$line-height-general:        1.5            !default;\n$line-height-nav-link:       1.625rem       !default;\n$btn-icon-line-height:       2.4em          !default;\n$line-height:                1.35em         !default;\n$line-height-lg:             54px           !default;\n\n\n$border-radius-top:        10px 10px 0 0     !default;\n$border-radius-bottom:     0 0 10px 10px     !default;\n\n$dropdown-shadow:          1px 2px 7px 1px rgba(0,0,0,.125);\n$box-shadow-raised:        0px 10px 25px 0px rgba(0, 0, 0, 0.3);\n$box-shadow:               0 2px 2px rgba(204, 197, 185, 0.5);\n$sidebar-box-shadow:       0px 2px 22px 0 rgba(0, 0, 0,.20), 0px 2px 30px 0 rgba(0, 0, 0,.35);\n\n$general-transition-time:  300ms             !default;\n\n$slow-transition-time:           370ms       !default;\n$dropdown-coordinates:      29px -50px       !default;\n\n$fast-transition-time:           150ms       !default;\n$select-coordinates:         50% -40px       !default;\n\n$transition-linear:         linear           !default;\n$transition-bezier:         cubic-bezier(0.34, 1.61, 0.7, 1) !default;\n$transition-ease:           ease 0s;\n\n\n//$navbar-padding-a:               9px 13px;\n$navbar-margin-a:                15px 0px;\n\n$padding-social-a:               10px 5px;\n\n$navbar-margin-a-btn:            15px 0px;\n$navbar-margin-a-btn-round:      16px 0px;\n\n$navbar-padding-a-icons:         6px 15px;\n$navbar-margin-a-icons:          6px  3px;\n\n$navbar-padding-base:            0.625rem;\n//$navbar-margin-brand:             5px  0px;\n\n$navbar-margin-brand-icons:      12px auto;\n$navbar-margin-btn:              15px  3px;\n\n$height-icon-sm:\t\t\t\t 32px;\n$width-icon-sm:\t\t\t\t\t 32px;\n$padding-icon-sm:\t\t\t     4px;\n$border-radius-icon-sm:\t\t\t 7px;\n\n$height-icon-message:\t\t\t 40px;\n$width-icon-message:\t\t\t 40px;\n\n$height-icon-message-sm: \t\t 20px;\n$width-icon-message-sm:\t\t\t 20px;\n\n$white-navbar:                  rgba(#FFFFFF, .96);\n$primary-navbar:                rgba(#34ACDC, .98);\n$info-navbar:                   rgba(#5BCAFF, .98);\n$success-navbar:                rgba(#4CD964, .98);\n$warning-navbar:                rgba(#FF9500, .98);\n$danger-navbar:                 rgba(#FF4C40, .98);\n\n$topbar-x:             topbar-x !default;\n$topbar-back:          topbar-back !default;\n$bottombar-x:          bottombar-x !default;\n$bottombar-back:       bottombar-back !default;\n\n//Nucleo Icons\n\n$nc-font-path:        '../fonts' !default;\n$nc-font-size-base:   14px !default;\n$nc-css-prefix:       nc !default;\n$nc-background-color:     #eee !default;\n$nc-li-width:         (30em / 14) !default;\n$nc-padding-width:    (1em/3) !default;\n\n// Social icons color\n$social-twitter:                   #55acee !default;\n$social-twitter-state-color:       darken(#55acee, 5%) !default;\n\n$social-facebook: \t\t\t       #3b5998 !default;\n$social-facebook-state-color:      darken(#3b5998, 5%) !default;\n\n$social-google: \t\t\t       #dd4b39 !default;\n$social-google-state-color:        darken(#dd4b39, 5%) !default;\n\n$social-linkedin: \t\t\t         #0077B5 !default;\n$social-linkedin-state-color:        darken(#0077B5, 5%) !default;\n\n// Sidebar variables\n$sidebar-width:              calc(100% - 260px) !default;\n$sidebar-mini-width:         calc(100% - 80px) !default;\n\n\n// Social icons color\n$social-twitter:                   #55acee !default;\n$social-twitter-state-color:       lighten(#55acee, 6%) !default;\n\n$social-facebook: \t\t\t       #3b5998 !default;\n$social-facebook-state-color:      lighten(#3b5998, 6%) !default;\n\n$social-google: \t\t\t       #dd4b39 !default;\n$social-google-state-color:        lighten(#dd4b39, 6%) !default;\n\n$social-linkedin: \t\t\t       #0077B5 !default;\n$social-linkedin-state-color:      lighten(#0077B5, 6%) !default;\n\n$social-pinterest: \t\t\t       #cc2127 !default;\n$social-pinterest-state-color:     lighten(#cc2127, 6%) !default;\n\n$social-dribbble: \t\t           #ea4c89 !default;\n$social-dribbble-state-color:      lighten(#ea4c89, 6%) !default;\n\n$social-github: \t\t      \t   #333333 !default;\n$social-github-state-color:        lighten(#333333, 6%) !default;\n\n$social-youtube: \t\t    \t   #e52d27 !default;\n$social-youtube-state-color:       lighten(#e52d27, 6%) !default;\n\n$social-instagram: \t\t           #125688 !default;\n$social-instagram-state-color:     lighten(#125688, 6%) !default;\n\n$social-reddit: \t\t  \t       #ff4500 !default;\n$social-reddit-state-color:        lighten(#ff4500, 6%) !default;\n\n$social-tumblr: \t\t\t       #35465c !default;\n$social-tumblr-state-color:        lighten(#35465c, 6%) !default;\n\n$social-behance: \t\t\t       #1769ff !default;\n$social-behance-state-color:       lighten(#1769ff, 6%) !default;\n\n// Placeholder text color\n$input-color-placeholder: #999 !default;\n\n$zindex-select-dropdown: 1060 !default; // must be higher than a modal background (1050)\n","// Mixin for generating new styles\n@mixin btn-styles($btn-color, $btn-states-color) {\n    background-color: $btn-color;\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active,\n    &:active:focus,\n    &:active:hover,\n    &.active:focus,\n    &.active:hover,\n    .show > &.dropdown-toggle,\n    .show > &.dropdown-toggle:focus,\n    .show > &.dropdown-toggle:hover {\n        background-color: $btn-states-color !important;\n        color: $white-color !important;\n        box-shadow: none !important;\n    }\n\n    &:not([data-action]):hover{\n        box-shadow:  none;\n    }\n\n    &.disabled,\n    &:disabled,\n    &[disabled],\n    fieldset[disabled] & {\n        &,\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $btn-color;\n            border-color: $btn-color;\n        }\n    }\n\n    // btn-neutral style\n    @if $btn-color == $white-color{\n        color: $primary-color;\n\n        &.btn-danger{\n            color: $danger-color;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $danger-states-color !important;\n            }\n        }\n\n        &.btn-info{\n            color: $info-color !important;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $info-states-color !important;\n            }\n        }\n\n        &.btn-warning{\n            color: $warning-color !important;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $warning-states-color !important;\n            }\n        }\n\n        &.btn-success{\n            color: $success-color !important;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $success-states-color !important;\n            }\n        }\n\n        &.btn-default{\n            color: $default-color !important;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $default-states-color !important;\n            }\n        }\n\n        &.active,\n        &:active,\n        &:active:focus,\n        &:active:hover,\n        &.active:focus,\n        &.active:hover,\n        .show > &.dropdown-toggle,\n        .show > &.dropdown-toggle:focus,\n        .show > &.dropdown-toggle:hover {\n            background-color: $white-color !important;\n            color: $primary-states-color !important;\n            box-shadow: none !important;\n        }\n\n        &:hover,\n        &:focus{\n            color: $primary-states-color !important;\n\n            &:not(.nav-link){\n                box-shadow: none;\n            }\n\n        }\n\n    } @else {\n        color: $white-color;\n    }\n\n    &.btn-simple{\n        color: $btn-color;\n        border-color: $btn-color;\n\n        &:hover,\n        &:focus,\n        &:active{\n            background-color: $transparent-bg;\n            color: $btn-states-color;\n            border-color: $btn-states-color;\n            box-shadow: none;\n        }\n    }\n\n    &.btn-link{\n        color: $btn-color;\n\n        &:hover,\n        &:focus,\n        &:active,\n        &:active:focus {\n            background-color: $transparent-bg;\n            color: $btn-states-color;\n            text-decoration: none;\n            box-shadow: none;\n        }\n    }\n}\n\n@mixin btn-outline-styles($btn-color, $btn-states-color){\n    background: $transparent-bg;\n    border: 2px solid $btn-color !important;\n    color: $btn-color;\n    @include opacity(1);\n\n    &:hover,\n    &:focus,\n    &:active,\n    &:focus:active,\n    &.active,\n    .open > &.dropdown-toggle {\n      background-color: $btn-color !important;\n      color: $fill-font-color !important;\n      border-color: $btn-color !important;\n      .caret{\n          border-top-color: $fill-font-color !important;\n      }\n    }\n\n    .caret{\n        border-top-color: $white-color !important;\n    }\n\n    &.disabled,\n    &:disabled,\n    &[disabled],\n    fieldset[disabled] & {\n      &,\n      &:hover,\n      &:focus,\n      &.focus,\n      &:active,\n      &.active {\n        background-color: $transparent-bg !important;\n        border-color: $btn-color !important;\n      }\n    }\n}\n\n@mixin btn-size($padding-vertical, $padding-horizontal, $font-size, $border){\n   font-size: $font-size;\n   border-radius: $border;\n   padding: $padding-vertical $padding-horizontal;\n\n   &.btn-simple{\n       padding: $padding-vertical - 1 $padding-horizontal - 1;\n   }\n\n}\n\n@mixin rotate-180(){\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n","@mixin box-shadow($shadow...) {\n  -webkit-box-shadow: $shadow; // iOS <4.3 & Android <4.1\n          box-shadow: $shadow;\n}\n\n@mixin transition($time, $type){\n    -webkit-transition: all $time $type;\n    -moz-transition: all $time $type;\n    -o-transition: all $time $type;\n    -ms-transition: all $time $type;\n    transition: all $time $type;\n}\n\n\n@mixin sidebar-color($color){\n  &:after{\n    background: $color;\n  }\n}\n\n@mixin bar-animation($type){\n     -webkit-animation: $type 500ms linear 0s;\n     -moz-animation: $type 500ms linear 0s;\n     animation: $type 500ms 0s;\n     -webkit-animation-fill-mode: forwards;\n     -moz-animation-fill-mode: forwards;\n     animation-fill-mode: forwards;\n}\n\n@mixin sidebar-active-color($font-color){\n    .nav {\n        li {\n          &.active > a,\n          &.active > a i,\n          &.active > a[data-toggle=\"collapse\"],\n          &.active > a[data-toggle=\"collapse\"] i,\n          &.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active .sidebar-mini-icon,\n          &.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active > a {\n            color: $font-color;\n            opacity: 1;\n          }\n        }\n    }\n}\n\n@mixin transition-opacity($time, $type){\n    -webkit-transition: opacity $time $type;\n    -moz-transition: opacity $time $type;\n    -o-transition: opacity $time $type;\n    -ms-transition: opacity $time $type;\n    transition: opacity $time $type;\n}\n\n@mixin transform-translate-y-dropdown($value) {\n    -webkit-transform:  translate3d(-20px,$value,0) !important;\n       -moz-transform: translate3d(-20px,$value,0) !important;\n       -o-transform: translate3d(-20px,$value,0) !important;\n       -ms-transform: translate3d(-20px,$value,0) !important;\n       transform: translate3d(-20px,$value,0) !important;\n}\n\n@mixin transform-translate-x($value){\n     -webkit-transform:  translate3d($value, 0, 0);\n        -moz-transform: translate3d($value, 0, 0);\n        -o-transform: translate3d($value, 0, 0);\n        -ms-transform: translate3d($value, 0, 0);\n        transform: translate3d($value, 0, 0);\n}\n\n@mixin transform-translate-y($value){\n     -webkit-transform:  translate3d(0,$value,0) !important;\n        -moz-transform: translate3d(0,$value,0) !important;\n        -o-transform: translate3d(0,$value,0) !important;\n        -ms-transform: translate3d(0,$value,0) !important;\n        transform: translate3d(0,$value,0) !important;\n}\n\n@mixin transform-translate-y-fixed-plugin($value){\n     -webkit-transform:  translate3d(0,$value,0) !important;\n        -moz-transform: translate3d(0,$value,0) !important;\n        -o-transform: translate3d(0,$value,0) !important;\n        -ms-transform: translate3d(0,$value,0) !important;\n        transform: translate3d(0,$value,0) !important;\n}\n\n@mixin icon-gradient($color, $bottomColor: #000){\n    background: $color;\n    background: -webkit-linear-gradient($color 0%, $bottomColor 80%);\n    background: -o-linear-gradient($color 0%, $bottomColor 80%);\n    background: -moz-linear-gradient($color 0%, $bottomColor 80%);\n    background: linear-gradient($color 0%, $bottomColor 80%);\n}\n\n@mixin topbar-x-rotation(){\n    @keyframes topbar-x {\n      0% {top: 0px; transform: rotate(0deg); }\n      45% {top: 6px; transform: rotate(145deg); }\n      75% {transform: rotate(130deg); }\n      100% {transform: rotate(135deg); }\n    }\n    @-webkit-keyframes topbar-x {\n      0% {top: 0px; -webkit-transform: rotate(0deg); }\n      45% {top: 6px; -webkit-transform: rotate(145deg); }\n      75% {-webkit-transform: rotate(130deg); }\n      100% { -webkit-transform: rotate(135deg); }\n    }\n    @-moz-keyframes topbar-x {\n      0% {top: 0px; -moz-transform: rotate(0deg); }\n      45% {top: 6px; -moz-transform: rotate(145deg); }\n      75% {-moz-transform: rotate(130deg); }\n      100% { -moz-transform: rotate(135deg); }\n    }\n}\n\n\n@mixin topbar-back-rotation(){\n    @keyframes topbar-back {\n      0% { top: 6px; transform: rotate(135deg); }\n      45% { transform: rotate(-10deg); }\n      75% { transform: rotate(5deg); }\n      100% { top: 0px; transform: rotate(0); }\n    }\n\n    @-webkit-keyframes topbar-back {\n      0% { top: 6px; -webkit-transform: rotate(135deg); }\n      45% { -webkit-transform: rotate(-10deg); }\n      75% { -webkit-transform: rotate(5deg); }\n      100% { top: 0px; -webkit-transform: rotate(0); }\n    }\n\n    @-moz-keyframes topbar-back {\n      0% { top: 6px; -moz-transform: rotate(135deg); }\n      45% { -moz-transform: rotate(-10deg); }\n      75% { -moz-transform: rotate(5deg); }\n      100% { top: 0px; -moz-transform: rotate(0); }\n    }\n}\n\n@mixin bottombar-x-rotation(){\n    @keyframes bottombar-x {\n      0% {bottom: 0px; transform: rotate(0deg);}\n      45% {bottom: 6px; transform: rotate(-145deg);}\n      75% {transform: rotate(-130deg);}\n      100% {transform: rotate(-135deg);}\n    }\n    @-webkit-keyframes bottombar-x {\n      0% {bottom: 0px; -webkit-transform: rotate(0deg);}\n      45% {bottom: 6px; -webkit-transform: rotate(-145deg);}\n      75% {-webkit-transform: rotate(-130deg);}\n      100% {-webkit-transform: rotate(-135deg);}\n    }\n    @-moz-keyframes bottombar-x {\n      0% {bottom: 0px; -moz-transform: rotate(0deg);}\n      45% {bottom: 6px; -moz-transform: rotate(-145deg);}\n      75% {-moz-transform: rotate(-130deg);}\n      100% {-moz-transform: rotate(-135deg);}\n    }\n}\n\n@mixin bottombar-back-rotation{\n    @keyframes bottombar-back {\n      0% { bottom: 6px;transform: rotate(-135deg);}\n      45% { transform: rotate(10deg);}\n      75% { transform: rotate(-5deg);}\n      100% { bottom: 0px;transform: rotate(0);}\n    }\n    @-webkit-keyframes bottombar-back {\n      0% {bottom: 6px;-webkit-transform: rotate(-135deg);}\n      45% {-webkit-transform: rotate(10deg);}\n      75% {-webkit-transform: rotate(-5deg);}\n      100% {bottom: 0px;-webkit-transform: rotate(0);}\n    }\n    @-moz-keyframes bottombar-back {\n      0% {bottom: 6px;-moz-transform: rotate(-135deg);}\n      45% {-moz-transform: rotate(10deg);}\n      75% {-moz-transform: rotate(-5deg);}\n      100% {bottom: 0px;-moz-transform: rotate(0);}\n    }\n\n}\n\n@mixin sidebar-text-color($text-color){\n    .nav {\n      li {\n        a,\n        a i,\n        a[data-toggle=\"collapse\"],\n        a[data-toggle=\"collapse\"] i,\n        a[data-toggle=\"collapse\"] ~ div > ul > li .sidebar-mini-icon,\n        a[data-toggle=\"collapse\"] ~ div > ul > li > a {\n          color: $text-color;\n          opacity: .7;\n        }\n\n        &:hover:not(.active) > a,\n        &:focus:not(.active) > a {\n            opacity: 1;\n        }\n      }\n    }\n\n    .logo {\n      .simple-text {\n        color: $text-color;\n      }\n      &:after {\n        background-color: $text-color;\n        opacity: .4;\n      }\n    }\n\n    .user {\n      .info a span,\n      .nav .sidebar-mini-icon,\n      .nav .sidebar-normal {\n        color: $text-color !important;\n      }\n      &:after {\n        background-color: $text-color;\n        opacity: .4;\n      }\n    }\n}\n\n@mixin badge-color($color) {\n    border-color: $color;\n    background-color: $color;\n}\n","// Opacity\n\n@mixin opacity($opacity) {\n  opacity: $opacity;\n  // IE8 filter\n  $opacity-ie: ($opacity * 100);\n  filter: #{alpha(opacity=$opacity-ie)};\n}\n","@mixin input-size($padding-vertical, $padding-horizontal) {\n  padding: $padding-vertical $padding-horizontal;\n}\n\n@mixin form-control-placeholder($color, $opacity) {\n  .form-control::-moz-placeholder {\n    color: $color;\n    @include opacity(1);\n  }\n  .form-control:-moz-placeholder {\n    color: $color;\n    @include opacity(1);\n  }\n  .form-control::-webkit-input-placeholder {\n    color: $color;\n    @include opacity(1);\n  }\n  .form-control:-ms-input-placeholder {\n    color: $color;\n    @include opacity(1);\n  }\n}\n\n@mixin placeholder() {\n  ::-moz-placeholder {\n    @content;\n  } // Firefox\n  :-ms-input-placeholder {\n    @content;\n  } // Internet Explorer 10+\n  ::-webkit-input-placeholder {\n    @content;\n  } // Safari and Chrome\n}\n\n@mixin light-form() {\n  border-radius: 0;\n  border: 0;\n  padding: 0;\n  background-color: transparent;\n}\n\n@mixin form-control-lg-padding($padding-vertical, $padding-horizontal) {\n  .form-group.no-border.form-control-lg,\n  .input-group.no-border.form-control-lg {\n    .input-group-append .input-group-text {\n      padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\n    }\n\n    .form-control {\n      padding: $padding-vertical $padding-horizontal;\n\n      & + .input-group-prepend .input-group-text,\n      & + .input-group-append .input-group-text {\n        padding: $padding-vertical $padding-horizontal $padding-vertical 0;\n      }\n    }\n  }\n\n  .form-group.form-control-lg,\n  .input-group.form-control-lg {\n    .form-control {\n      padding: $padding-vertical - 1 $padding-horizontal - 1;\n\n      & + .input-group-prepend .input-group-text,\n      & + .input-group-append .input-group-text {\n        padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical -\n          1 0;\n      }\n    }\n\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n      padding: $padding-vertical - 1 0 $padding-vertical $padding-horizontal - 1;\n\n      & + .form-control {\n        padding: $padding-vertical $padding-horizontal - 1 $padding-vertical\n          $padding-horizontal - 3;\n      }\n    }\n  }\n}\n\n@mixin input-base-padding($padding-vertical, $padding-horizontal) {\n  .form-group.no-border,\n  .input-group.no-border {\n    .form-control {\n      padding: $padding-vertical $padding-horizontal;\n\n      & + .input-group-prepend .input-group-text,\n      & + .input-group-append .input-group-text {\n        padding: $padding-vertical $padding-horizontal $padding-vertical 0;\n      }\n    }\n\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n      padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\n    }\n  }\n\n  .form-group,\n  .input-group {\n    .form-control {\n      padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical -\n        1 $padding-horizontal - 1;\n\n      & + .input-group-prepend .input-group-text,\n      & + .input-group-append .input-group-text {\n        padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical -\n          1 0;\n      }\n    }\n\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n      padding: $padding-vertical - 1 0 $padding-vertical - 1 $padding-horizontal -\n        1;\n\n      & + .form-control,\n      & ~ .form-control {\n        padding: $padding-vertical - 1 $padding-horizontal $padding-vertical\n          $padding-horizontal - 3;\n      }\n    }\n  }\n}\n\n//color1 = $opacity-5\n//color2 = $opacity-8\n//color3 = $white-color\n//color4 = $transparent-bg\n//color5 = $opacity-1\n//color6 = $opacity-2\n\n@mixin input-coloured-bg($color1, $color2, $color3, $color4, $color5, $color6) {\n  @include form-control-placeholder(darken($color2, 8%), 1);\n\n  .form-control {\n    border-color: $color1;\n    color: $color2;\n\n    &:focus {\n      border-color: $color3;\n      background-color: $color4;\n      color: $color3;\n    }\n  }\n\n  .has-success,\n  .has-danger {\n    &:after {\n      color: $color3;\n    }\n  }\n\n  .has-danger {\n    .form-control {\n      background-color: $color4;\n    }\n  }\n\n  .input-group-prepend .input-group-text,\n  .input-group-append .input-group-text {\n    background-color: $color4;\n    border-color: $color1;\n    color: $color2;\n  }\n\n  .input-group-focus {\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n      background-color: $color4;\n      border-color: $color3;\n      color: $color3;\n    }\n  }\n\n  .form-group.no-border,\n  .input-group.no-border {\n    .form-control {\n      background-color: $color5;\n      color: $color2;\n\n      &:focus,\n      &:active,\n      &:active {\n        background-color: $color6;\n        color: $color3;\n      }\n    }\n\n    .form-control + .input-group-prepend .input-group-text,\n    .form-control + .input-group-append .input-group-text {\n      background-color: $color5;\n\n      &:focus,\n      &:active,\n      &:active {\n        background-color: $color6;\n        color: $color3;\n      }\n    }\n\n    .form-control {\n      &:focus {\n        & + .input-group-prepend .input-group-text,\n        & + .input-group-append .input-group-text {\n          background-color: $color6;\n          color: $color3;\n        }\n      }\n    }\n\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n      background-color: $color5;\n      border: none;\n      color: $color2;\n    }\n\n    &.input-group-focus {\n      .input-group-prepend .input-group-text,\n      .input-group-append .input-group-text {\n        background-color: $color6;\n        color: $color3;\n      }\n    }\n  }\n}\n\n@mixin transition-input-focus-color() {\n  -webkit-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  -moz-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  -o-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  -ms-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n}\n","@include placeholder() {\n  color: $dark-gray;\n};\n\n\n.form-control {\n    background-color: $white-color;\n    border: 1px solid $medium-gray;\n    border-radius: $border-radius-base;\n    color: $font-color;\n    line-height: normal;\n    font-size: $font-size-base;\n    @include transition-input-focus-color();\n    @include box-shadow(none);\n\n\n\n    &:focus{\n        border: 1px solid $dark-gray;\n        @include box-shadow(none);\n        outline: 0 !important;\n        color: $default-color;\n\n        & + .input-group-append .input-group-text,\n        & ~ .input-group-append .input-group-text,\n        & + .input-group-prepend .input-group-text,\n        & ~ .input-group-prepend .input-group-text{\n            border: 1px solid #ccc;\n            border-left: none;\n            background-color: $transparent-bg;\n        }\n    }\n\n    .has-success &,\n    .has-error &,\n    .has-success &:focus,\n    .has-error &:focus{\n        @include box-shadow(none);\n    }\n\n    .has-success &{\n        border: 1px solid $table-line-color;\n        color: $font-color;\n\n        &.form-control-success{\n            padding-right: 2.5em !important;\n        }\n    }\n    .has-success &:focus{\n        border: 1px solid $success-color;\n        color: $success-color;\n    }\n    .has-danger &{\n        background-color: $danger-input-bg;\n        border: 1px solid $danger-color;\n        color: $danger-color;\n\n        &.form-control-danger{\n            padding-right: 2.5em !important;\n        }\n    }\n    .has-danger &:focus{\n        background-color: $white-color;\n        border: 1px solid $danger-color;\n    }\n\n    & + .form-control-feedback{\n        border-radius: $border-radius-large;\n        font-size: $font-size-base;\n        margin-top: -7px;\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        vertical-align: middle;\n    }\n\n    .open &{\n        border-radius: $border-radius-large $border-radius-large 0 0;\n        border-bottom-color: transparent;\n    }\n\n    & + .input-group-append .input-group-text,\n    & + .input-group-prepend .input-group-text{\n        background-color: $white-bg;\n    }\n}\n\n\n@include form-control-lg-padding($padding-large-vertical, $padding-input-horizontal);\n@include input-base-padding($padding-input-vertical, $padding-input-horizontal);\n\n.input-group {\n  &.has-success {\n    .input-group-prepend,\n    .input-group-append {\n      .input-group-text {\n        border: 1px solid $table-line-color;\n        color: $font-color;\n        background-color: $white-color;\n        border-right: none;\n      }\n    }\n  }\n}\n\n.form-group.no-border,\n.input-group.no-border{\n    .form-control,\n    .form-control + .input-group-prepend .input-group-text,\n    .form-control + .input-group-append .input-group-text{\n        background-color: $opacity-gray-3;\n        border: medium none;\n        &:focus,\n        &:active,\n        &:active{\n            border: medium none;\n            background-color: $opacity-gray-5;\n        }\n    }\n\n    .form-control{\n        &:focus{\n            & + .input-group-prepend .input-group-text,\n            & + .input-group-append .input-group-text{\n                background-color: $opacity-gray-5;\n            }\n        }\n    }\n\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text{\n        background-color: $opacity-gray-3;\n        border: none;\n    }\n}\n\n.has-error{\n    .form-control-feedback, .control-label{\n        color: $danger-color;\n    }\n}\n.has-success{\n    .form-control-feedback, .control-label{\n        color: $success-color;\n    }\n}\n\n.input-group.has-danger {\n  .input-group-prepend {\n    border-radius: $border-radius-base;\n    .input-group-text {\n      border: 1px solid $danger-color;\n      border-right: none;\n    }\n  }\n  .error {\n    display: block;\n    width: 100%;\n    color: $danger-color;\n    margin-top: 3px;\n  }\n}\n\n.input-group.has-success {\n  .input-group-prepend {\n    border-radius: $border-radius-base;\n    .input-group-text {\n      // border: 1px solid $success-color;\n      border-right: none;\n    }\n  }\n}\n\n\n.input-group-focus{\n  .input-group-prepend .input-group-text,\n  .input-group-append .input-group-text{\n    background-color: $white-bg;\n    border-color: $dark-gray;\n  }\n\n  &.no-border{\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text{\n      background-color: $opacity-gray-5;\n    }\n  }\n\n  &.has-danger {\n    .input-group-append,\n    .input-group-prepend {\n      .input-group-text {\n        background-color: $danger-input-bg;\n      }\n    }\n  }\n\n  &.has-success {\n    .input-group-append,\n    .input-group-prepend {\n      .input-group-text {\n        background-color: $success-input-bg;\n        border: 1px solid $success-color;\n        border-right: none;\n      }\n    }\n  }\n}\n\n.input-group-append .input-group-text,\n.input-group-prepend .input-group-text {\n    background-color: transparent;\n    border: 1px solid $light-gray;\n    color: $default-color;\n    border-top-right-radius: $border-radius-base;\n    border-bottom-right-radius: $border-radius-base;\n\n    & i{\n      opacity: .5;\n    }\n\n    @include transition-input-focus-color();\n\n    .has-danger &{\n      background-color: $danger-input-bg;\n    }\n    .has-success &{\n      background-color: $success-input-bg;\n    }\n    .has-danger.input-group-focus &{\n      background-color: $white-color;\n      color: $danger-color;\n    }\n    .has-success.input-group-focus &{\n      background-color: $white-color;\n      color: $success-color;\n    }\n    .has-danger .form-control:focus + &{\n      color: $danger-color;\n    }\n    .has-success .form-control:focus + &{\n      color: $success-color;\n    }\n\n    & + .form-control,\n    & ~ .form-control{\n        @include input-size($padding-base-vertical - 1, $padding-base-horizontal);\n        padding-left: 18px;\n    }\n\n    i{\n        width: 17px;\n    }\n}\n\n.input-group-append,\n.input-group-prepend{\n  margin: 0;\n}\n\n\n.input-group-append .input-group-text{\n  border-left: none;\n}\n.input-group-prepend .input-group-text{\n  border-right: none;\n}\n\n.input-group,\n.form-group{\n    margin-bottom: 10px;\n    position: relative;\n\n    .form-control-static{\n        margin-top: 9px;\n    }\n    &.has-danger {\n      .error {\n        color: $danger-color;\n      }\n    }\n}\n.input-group[disabled]{\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text{\n        background-color: $light-gray;\n    }\n}\n\n.input-group .form-control:not(:first-child):not(:last-child), .input-group-btn:not(:first-child):not(:last-child){\n    border-radius: $border-radius-base;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-left: 0 none;\n}\n\n.input-group .form-control:first-child,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\n    border-right: 0 none;\n}\n.input-group .form-control:last-child,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child) {\n    border-left: 0 none;\n}\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\n    background-color: $light-gray;\n    color: $default-color;\n    cursor: not-allowed;\n}\n\n.input-group-btn .btn{\n    border-width: $border-thin;\n    padding: $padding-btn-vertical  $padding-base-horizontal;\n}\n.input-group-btn .btn-default:not(.btn-fill){\n    border-color: $medium-gray;\n}\n\n.input-group-btn:last-child > .btn{\n    margin-left: 0;\n}\ntextarea.form-control{\n    max-width: 100%;\n    max-height: 80px;\n    padding: 10px 10px 0 0;\n    resize: none;\n    border: none;\n    border: 1px solid $light-gray;\n    border-radius: $border-radius-base;\n    line-height: 2;\n}\n\n.has-success,\n.has-danger{\n\n    &.form-group .form-control,\n    &.form-group.no-border .form-control{\n        padding-right: $padding-input-horizontal + 21;\n    }\n}\n\n.form.form-newsletter .form-group{\n    float: left;\n    width: 78%;\n    margin-right: 2%;\n    margin-top: 9px;\n}\n\n.input-group .input-group-btn{\n    padding: 0 12px;\n}\n\n// Input files - hide actual input - requires specific markup in the sample.\n.form-group input[type=file] {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n\n.form-text{\n    font-size: $font-size-small;\n}\n\n.form-control-lg{\n    padding: 0;\n    font-size: inherit;\n    line-height: 0;\n    border-radius: 0;\n}\n\n.form-horizontal{\n    .col-form-label,\n    .label-on-right{\n        padding: 10px 5px 0 15px;\n        text-align: right;\n        max-width: 180px;\n    }\n\n    .checkbox-radios{\n        margin-bottom: 15px;\n\n        .form-check:first-child{\n           margin-top: 8px;\n       }\n    }\n\n    .label-on-right{\n        text-align: left;\n        padding: 10px 15px 0 5px;\n    }\n\n    .form-check-inline{\n        margin-top: 6px;\n    }\n}\n","button,\ninput,\noptgroup,\nselect,\ntextarea{\n    font-family: $sans-serif-family;\n}\nh1,h2,h3,h4,h5,h6{\n    font-weight: $font-weight-normal;\n}\n\na{\n    color: $primary-color;\n    &:hover,\n    &:focus{\n        color: $primary-color;\n    }\n}\nh1, .h1 {\n    font-size: $font-size-h1;\n    line-height: 1.15;\n    margin-bottom: $margin-base-vertical * 2;\n\n    small{\n        font-weight: $font-weight-bold;\n        text-transform: uppercase;\n        opacity: .8;\n    }\n}\nh2, .h2{\n    font-size: $font-size-h2;\n    margin-bottom: $margin-base-vertical * 2;\n}\nh3, .h3{\n    font-size: $font-size-h3;\n    margin-bottom: $margin-base-vertical * 2;\n    line-height: 1.4em;\n}\nh4, .h4{\n    font-size: $font-size-h4;\n    line-height: 1.45em;\n    margin-top: $margin-base-vertical * 2;\n    margin-bottom: $margin-base-vertical;\n\n    & + .category,\n    &.title + .category{\n        margin-top: -10px;\n    }\n}\nh5, .h5 {\n    font-size: $font-size-h5;\n    line-height: 1.4em;\n    margin-bottom: 15px;\n}\nh6, .h6{\n    font-size: $font-size-h6;\n    font-weight: $font-weight-bold;\n    text-transform: uppercase;\n}\np{\n    &.description{\n        font-size: 1.14em;\n    }\n}\n\n// i.fa{\n//     font-size: 18px;\n//     position: relative;\n//     top: 1px;\n// }\n\n.title{\n    font-weight: $font-weight-bold;\n\n    &.title-up{\n        text-transform: uppercase;\n\n        a{\n            color: $black-color;\n            text-decoration: none;\n        }\n    }\n    & + .category{\n        margin-top: -10px;\n    }\n}\n\n.description,\n.card-description,\n.footer-big p,\n.card .footer .stats{\n    color: $dark-gray;\n    font-weight: $font-weight-light;\n}\n.category,\n.card-category{\n    text-transform: capitalize;\n    font-weight: $font-weight-normal;\n    color: $dark-gray;\n    font-size: $font-size-mini;\n}\n\n.card-category{\n    font-size: $font-size-h6;\n}\n\n.text-primary,\na.text-primary:focus, a.text-primary:hover {\n  color: $brand-primary !important;\n}\n.text-info,\na.text-info:focus, a.text-info:hover {\n  color: $brand-info !important;\n}\n.text-success,\na.text-success:focus, a.text-success:hover {\n  color: $brand-success !important;\n}\n.text-warning,\na.text-warning:focus, a.text-warning:hover {\n  color: $brand-warning !important;\n}\n.text-danger,\na.text-danger:focus, a.text-danger:hover {\n  color: $brand-danger !important;\n}\n\n.text-gray,\na.text-gray:focus, a.text-gray:hover{\n    color: $light-gray !important;\n}\n\n\n.blockquote{\n    border-left: none;\n    border: 1px solid $default-color;\n    padding: 20px;\n    font-size: $font-size-blockquote;\n    line-height: 1.8;\n\n    small{\n        color: $default-color;\n        font-size: $font-size-small;\n        text-transform: uppercase;\n    }\n\n    &.blockquote-primary{\n        border-color: $primary-color;\n        color: $primary-color;\n\n        small{\n            color: $primary-color;\n        }\n    }\n\n    &.blockquote-danger{\n        border-color: $danger-color;\n        color: $danger-color;\n\n        small{\n            color: $danger-color;\n        }\n    }\n\n    &.blockquote-white{\n        border-color: $opacity-8;\n        color: $white-color;\n\n        small{\n            color: $opacity-8;\n        }\n    }\n}\n","body{\n    color: $black-color;\n    font-size: $font-size-base;\n    font-family: $sans-serif-family;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n}\n\n.main{\n    position: relative;\n    background: $white-color;\n}\n/* Animations */\n.nav-pills .nav-link,\n.navbar,\n.nav-tabs .nav-link,\n.sidebar .nav a,\n.sidebar .nav a i,\n.animation-transition-general,\n.tag,\n.tag [data-role=\"remove\"],\n.animation-transition-general{\n    @include transition($general-transition-time, $transition-ease);\n}\n\n//transition for dropdown caret\n.dropdown-toggle:after,\n.bootstrap-switch-label:before,\n.caret{\n    @include transition($fast-transition-time, $transition-ease);\n}\n\n.dropdown-toggle[aria-expanded=\"true\"]:after,\na[data-toggle=\"collapse\"][aria-expanded=\"true\"] .caret,\n.card-collapse .card a[data-toggle=\"collapse\"][aria-expanded=\"true\"] i,\n.card-collapse .card a[data-toggle=\"collapse\"].expanded i{\n    @include rotate-180();\n}\n\n.button-bar{\n    display: block;\n    position: relative;\n    width: 22px;\n    height: 1px;\n    border-radius: 1px;\n    background: $white-bg;\n\n    & + .button-bar{\n        margin-top: 7px;\n    }\n\n    &:nth-child(2){\n        width: 17px;\n    }\n}\n\n.caret{\n    display: inline-block;\n    width: 0;\n    height: 0;\n    margin-left: 2px;\n    vertical-align: middle;\n    border-top: 4px dashed;\n    border-top: 4px solid\\9;\n    border-right: 4px solid transparent;\n    border-left: 4px solid transparent;\n}\n\n.pull-left{\n  float: left;\n}\n.pull-right{\n  float: right;\n}\n\n\n.offline-doc {\n  .navbar.navbar-transparent{\n    padding-top: 25px;\n    border-bottom: none;\n\n    .navbar-minimize {\n      display: none;\n    }\n    .navbar-brand,\n    .collapse .navbar-nav .nav-link {\n      color: $white-color !important;\n    }\n  }\n  .footer {\n    z-index: 3 !important;\n  }\n  .page-header{\n    .container {\n      z-index: 3;\n    }\n    &:after {\n      background-color: rgba(0, 0, 0, 0.5);\n      content: \"\";\n      display: block;\n      height: 100%;\n      left: 0;\n      position: absolute;\n      top: 0;\n      width: 100%;\n      z-index: 2;\n    }\n  }\n}\n\n.fixed-plugin {\n  .dropdown-menu li {\n    padding: 2px !important;\n  }\n}\n\n// badge color\n\n.badge{\n  &.badge-default{\n      @include badge-color($default-color);\n  }\n  &.badge-primary{\n      @include badge-color($primary-color);\n  }\n  &.badge-info{\n      @include badge-color($info-color);\n  }\n  &.badge-success{\n      @include badge-color($success-color);\n  }\n  &.badge-warning{\n      @include badge-color($warning-color);\n  }\n  &.badge-danger{\n      @include badge-color($danger-color);\n  }\n  &.badge-neutral{\n      @include badge-color($white-color);\n      color: inherit;\n  }\n}\n\n.card-user {\n  form {\n    .form-group {\n      margin-bottom: 20px;\n    }\n  }\n}\n",".from-check,\n.form-check-radio {\n    margin-bottom: 12px;\n    position: relative;\n}\n\n.form-check {\n  padding-left: 0;\n  margin-bottom: .5rem;\n\n    .form-check-label{\n        display: inline-block;\n        position: relative;\n        cursor: pointer;\n        padding-left: 35px;\n        line-height: 26px;\n        margin-bottom: 0;\n    }\n\n    .form-check-sign::before,\n    .form-check-sign::after {\n        content: \" \";\n        display: inline-block;\n        position: absolute;\n        width: 24px;\n        height: 24px;\n        left: 0;\n        cursor: pointer;\n        border-radius: 6px;\n        top: 0;\n        background-color: #AAA7A4;\n        -webkit-transition: opacity 0.3s linear;\n        -moz-transition: opacity 0.3s linear;\n        -o-transition: opacity 0.3s linear;\n        -ms-transition: opacity 0.3s linear;\n        transition: opacity 0.3s linear;\n    }\n    .form-check-sign::after {\n        font-family: 'FontAwesome';\n        content: \"\\f00c\";\n        top: -1px;\n        text-align: center;\n        font-size: 15px;\n        opacity: 0;\n        color: #FFF;\n        border: 0;\n        background-color: inherit;\n    }\n    &.disabled{\n        .form-check-label{\n            color: $dark-gray;\n            opacity: .5;\n            cursor: not-allowed;\n        }\n    }\n\n}\n\n.form-check.disabled .form-check-label,\n.form-check.disabled .form-check-label {\n\n}\n\n.form-check input[type=\"checkbox\"],\n.form-check-radio input[type=\"radio\"]{\n    opacity: 0;\n    position: absolute;\n    visibility: hidden;\n}\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::after{\n    opacity: 1;\n}\n\n.form-control input[type=\"checkbox\"]:disabled + .form-check-sign::before,\n.checkbox input[type=\"checkbox\"]:disabled + .form-check-sign::after{\n    cursor: not-allowed;\n}\n\n.form-check .form-check-label input[type=\"checkbox\"]:disabled + .form-check-sign,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign{\n    pointer-events: none !important;\n}\n\n.form-check-radio{\n  margin-left: -3px;\n\n    .form-check-label{\n        padding-left: 2rem;\n    }\n    &.disabled{\n        .form-check-label{\n            color: $dark-gray;\n            opacity: .5;\n            cursor: not-allowed;\n        }\n    }\n}\n\n.form-check-radio .form-check-sign::before{\n    font-family: 'FontAwesome';\n    content: \"\\f10c\";\n    font-size: 22px;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    display: inline-block;\n    position: absolute;\n    opacity: .50;\n    left: 5px;\n    top: -5px;\n}\n\n.form-check-label input[type=\"checkbox\"]:checked + .form-check-sign:before{\n    background-color: #66615B;\n}\n\n.form-check-radio input[type=\"radio\"] + .form-check-sign:after,\n.form-check-radio input[type=\"radio\"] {\n    opacity: 0;\n    @include transition-opacity(0.3s, linear);\n    content:\" \";\n    display: block;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n    font-family: 'FontAwesome';\n    content: \"\\f192\";\n    top: -5px;\n    position: absolute;\n    left: 5px;\n    opacity: 1;\n    font-size: 22px;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after{\n    opacity: 1;\n}\n\n\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::before,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::after {\n    color: $dark-gray;\n}\n",".navbar{\n    padding-top: $navbar-padding-base;\n    padding-bottom: $navbar-padding-base;\n    min-height: 53px;\n    margin-bottom: 20px;\n\n    a{\n        vertical-align: middle;\n\n        &:not(.btn):not(.dropdown-item){\n            color: $white-color;\n        }\n\n        &.dropdown-item{\n            color: $default-color;\n        }\n    }\n\n\n\n    &.bg-white{\n      .input-group .form-control,\n      .input-group.no-border .form-control{\n        color: $default-color;\n\n        @include placeholder(){\n          color: $default-color;\n        };\n      }\n      .input-group-prepend .input-group-text i,\n      .input-group-append .input-group-text i{\n        color: $default-color;\n        opacity: .5;\n      }\n    }\n\n    .form-group,\n    .input-group{\n      margin: 0;\n      margin-left: -3px;\n      margin-right: 5px;\n\n      .form-group-addon,\n      .input-group-prepend .input-group-text,\n      .input-group-append .input-group-text{\n        color: $default-color;\n\n        i {\n          opacity: 1;\n        }\n      }\n\n      &.no-border{\n        .form-control{\n          color: $default-color;\n\n          @include placeholder(){\n            color: $default-color;\n          };\n        }\n      }\n    }\n\n    p{\n        display: inline-block;\n        margin: 0;\n        line-height: 1.8em;\n        font-size: 1em;\n        font-weight: 400;\n    }\n\n    &.navbar-absolute{\n        position: absolute;\n        width: 100%;\n        padding-top: 10px;\n        z-index: 1029;\n    }\n\n    .documentation &{\n        &.fixed-top{\n            left: 0;\n            width: initial;\n        }\n    }\n\n    .navbar-wrapper{\n        display: inline-flex;\n        align-items: center;\n\n        .navbar-minimize{\n            padding-right: 10px;\n\n            .btn{\n                margin: 0;\n            }\n        }\n\n        .navbar-toggle{\n            .navbar-toggler{\n                padding-left: 0;\n            }\n\n            &:hover{\n                & .navbar-toggler-bar.bar2{\n                    width: 22px;\n                }\n            }\n        }\n    }\n\n\n\n    .navbar-nav{\n        &.navbar-logo{\n            position: absolute;\n            left: 0;\n            right: 0;\n            margin: 0 auto;\n            width: 49px;\n            top: -4px;\n        }\n\n        .nav-link.btn{\n            padding: $padding-btn-vertical $padding-btn-horizontal;\n            &.btn-lg{\n                padding: $padding-large-vertical $padding-large-horizontal;\n            }\n            &.btn-sm{\n                padding: $padding-small-vertical $padding-small-horizontal;\n            }\n        }\n\n        .nav-link{\n            text-transform: uppercase;\n            font-size: $font-size-mini;\n            padding: $padding-base-vertical $padding-base-horizontal;\n            line-height: $line-height-nav-link;\n            margin-right: 3px;\n\n            i.fa + p,\n            i.nc-icon + p{\n                margin-left: 3px;\n            }\n\n            i.fa,\n            i.nc-icon{\n                font-size: 18px;\n                position: relative;\n                top: 3px;\n                text-align: center;\n                width: 21px;\n            }\n\n            i.nc-icon{\n                top: 4px;\n                font-size: 16px;\n            }\n\n            &.profile-photo{\n                .profile-photo-small{\n                    width: 27px;\n                    height: 27px;\n                }\n            }\n\n            &.disabled{\n                opacity: .5;\n                color: $white-color;\n            }\n        }\n\n        .nav-item.active .nav-link:not(.btn),\n        .nav-item .nav-link:not(.btn):focus,\n        .nav-item .nav-link:not(.btn):hover,\n        .nav-item .nav-link:not(.btn):active{\n            border-radius: $border-radius-small;\n            color: $default-color;\n        }\n    }\n\n    .logo-container{\n        width: 27px;\n        height: 27px;\n        overflow: hidden;\n        margin: 0 auto;\n        border-radius: 50%;\n        border: 1px solid transparent;\n    }\n\n    .navbar-brand{\n        text-transform: capitalize;\n        font-size: $font-size-large-navbar;\n        padding-top: $padding-base-vertical;\n        padding-bottom: $padding-base-vertical;\n        line-height: $line-height-nav-link;\n    }\n\n    .navbar-toggler{\n        width: 37px;\n        height: 27px;\n        vertical-align: middle;\n        outline: 0;\n        cursor: pointer;\n\n        & .navbar-toggler-bar.navbar-kebab{\n            width: 3px;\n            height: 3px;\n            border-radius: 50%;\n            margin: 0 auto;\n        }\n    }\n\n    .button-dropdown{\n        .navbar-toggler-bar:nth-child(2){\n            width: 17px;\n        }\n    }\n\n    &.navbar-transparent{\n      background-color: $transparent-bg !important;\n      box-shadow: none;\n      border-bottom: 1px solid #ddd;\n\n      a:not(.dropdown-item):not(.btn){\n        color: $default-color;\n\n        &.disabled{\n          opacity: .5;\n          color: $default-color;\n         }\n       }\n\n       .button-bar{\n           background: $default-color;\n       }\n\n      .nav-item .nav-link:not(.btn){\n        color: $default-color;\n      }\n      .nav-item.active .nav-link:not(.btn),\n      .nav-item .nav-link:not(.btn):focus,\n      .nav-item .nav-link:not(.btn):hover,\n      .nav-item .nav-link:not(.btn):focus:hover,\n      .nav-item .nav-link:not(.btn):active {\n        color: $primary-color;\n      }\n    }\n\n    &.bg-white {\n        a:not(.dropdown-item):not(.btn){\n            color: $default-color;\n\n            &.disabled{\n                opacity: .5;\n                color: $default-color;\n            }\n        }\n\n        .button-bar{\n            background: $default-color;\n        }\n\n        .nav-item.active .nav-link:not(.btn),\n        .nav-item .nav-link:not(.btn):focus,\n        .nav-item .nav-link:not(.btn):hover,\n        .nav-item .nav-link:not(.btn):active{\n            color: $info-color;\n        }\n\n        .logo-container{\n            border: 1px solid $default-color;\n        }\n    }\n\n    .navbar-collapse {\n      .nav-item {\n        a {\n          font-size: $font-size-base;\n        }\n      }\n    }\n}\n\n.bg-default{\n    background-color: $default-color !important;\n}\n\n.bg-primary{\n    background-color: $primary-color !important;\n}\n\n.bg-info{\n    background-color: $info-color !important;\n}\n\n.bg-success{\n    background-color: $success-color !important;\n}\n\n.bg-danger{\n    background-color: $danger-color !important;\n}\n\n.bg-warning{\n    background-color: $warning-color !important;\n}\n\n.bg-white{\n    background-color: $white-color !important;\n}\n",".page-header{\n    min-height: 100vh;\n    max-height: 1000px;\n    padding: 0;\n    color: $white-color;\n    position: relative;\n\n    .page-header-image{\n        position: absolute;\n        background-size: cover;\n        background-position: center center;\n        width: 100%;\n        height: 100%;\n        z-index: -1;\n    }\n\n    .content-center{\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        z-index: 2;\n        -ms-transform: translate(-50%, -50%);\n        -webkit-transform: translate(-50%, -50%);\n        transform: translate(-50%, -50%);\n        text-align: center;\n        color: #FFFFFF;\n        padding: 0 15px;\n        width: 100%;\n        max-width: 880px;\n\n    }\n\n    footer{\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n    }\n\n    .container{\n        height: 100%;\n        z-index: 1;\n    }\n\n    .category,\n    .description{\n        color: $opacity-8;\n    }\n\n    &.page-header-small{\n        min-height: 60vh;\n        max-height: 440px;\n    }\n\n    &.page-header-mini{\n        min-height: 40vh;\n        max-height: 340px;\n    }\n\n    .title{\n        margin-bottom: 15px;\n    }\n    .title + h4{\n        margin-top: 10px;\n    }\n\n    &:after,\n    &:before{\n        position: absolute;\n        z-index: 0;\n        width: 100%;\n        height: 100%;\n        display: block;\n        left: 0;\n        top: 0;\n        content: \"\";\n    }\n\n    &:before{\n        background-color: rgba(0,0,0,.3);\n    }\n\n    &[filter-color=\"orange\"]{\n        @include linear-gradient(rgba($black-color,.20), rgba(224, 23, 3, 0.6));\n    }\n}\n","@mixin linear-gradient($color1, $color2){\n    background: $color1; /* For browsers that do not support gradients */\n    background: -webkit-linear-gradient(90deg, $color1 , $color2); /* For Safari 5.1 to 6.0 */\n    background: -o-linear-gradient(90deg, $color1, $color2); /* For Opera 11.1 to 12.0 */\n    background: -moz-linear-gradient(90deg, $color1, $color2); /* For Firefox 3.6 to 15 */\n    background: linear-gradient(0deg, $color1 , $color2); /* Standard syntax */\n}\n",".dropdown,\n.dropup,\n.bootstrap-select{\n    .dropdown-menu{\n        display: block;\n        @include opacity(0);\n        @include box-shadow($dropdown-shadow);\n        visibility: hidden;\n        position: absolute;\n        transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;\n\n        &[x-placement=\"top-start\"]{\n            @include transform-translate-y-dropdown(0px);\n\n        }\n        &[x-placement=\"bottom-start\"]{\n            @include transform-translate-y-dropdown(0px);\n        }\n    }\n\n    &.show .dropdown-menu{\n        @include opacity(1);\n        visibility: visible;\n\n        &[x-placement=\"top-start\"]{\n            @include transform-translate-y-dropdown(-50px);\n            top: auto !important;\n            bottom: 0 !important;\n\n        }\n        &[x-placement=\"bottom-start\"]{\n            @include transform-translate-y-dropdown(50px);\n            bottom: auto !important;\n            top: 0 !important;\n        }\n    }\n\n}\n\n.dropup .dropdown-menu,\n.dropdown-btn .dropdown-menu{\n    @include transform-translate-y-dropdown(0px);\n    top: auto !important;\n    bottom: 0 !important;\n\n}\n\n.dropup.show .dropdown-menu,\n.dropdown-btn.show .dropdown-menu{\n    opacity: 1;\n    visibility: visible;\n\n    .dropdown-menu.inner{\n      @include transform-translate-y(0px);\n    }\n}\n\n.bootstrap-select.show{\n  .dropdown-menu.show{\n    &[x-placement=\"top-start\"]{\n        @include transform-translate-y-dropdown(-60px);\n        top: auto !important;\n        bottom: 0 !important;\n    }\n\n    li:last-child {\n      a:hover{\n        border-radius: 0 0 12px 12px;\n      }\n    }\n  }\n}\n\n.bootstrap-select.dropup.show{\n  &:before {\n    top: -1px !important;\n  }\n\n  &:after {\n    top: -2px !important;\n  }\n}\n.dropdown-menu{\n    background-color: $white-color;\n    border: 0 none;\n    border-radius: $border-radius-extreme;\n    margin-top: 10px;\n    padding: 0px;\n\n    .divider{\n        background-color: $medium-pale-bg;\n        margin: 0px;\n    }\n\n    .dropdown-header{\n        color: $dark-gray;\n        font-size: $font-size-small;\n        padding: $padding-dropdown-vertical $padding-dropdown-horizontal;\n    }\n\n    .no-notification{\n        color: #9A9A9A;\n        font-size: 1.2em;\n        padding: 30px 30px;\n        text-align: center;\n    }\n\n    .dropdown-item{\n        color: $font-color;\n        font-size: $font-size-base;\n        padding: 10px 45px 10px 15px;\n        clear: both;\n        white-space: nowrap;\n        width: 100%;\n        display: block;\n\n       img{\n           margin-top: -3px;\n       }\n\n    }\n    .dropdown-item:focus{\n        outline: 0 !important;\n    }\n\n    .btn-group.select &{\n        min-width: 100%;\n    }\n\n    .dropdown-item:first-child{\n       border-top-left-radius: $border-radius-extreme;\n       border-top-right-radius: $border-radius-extreme;\n    }\n\n    .dropdown-item:last-child{\n        border-bottom-left-radius: $border-radius-extreme;\n        border-bottom-right-radius: $border-radius-extreme;\n    }\n\n    .select & .dropdown-item:first-child{\n        border-radius: 0;\n        border-bottom: 0 none;\n    }\n\n    .dropdown-item:hover,\n    .dropdown-item:focus{\n        color: $white-color !important;\n        opacity: 1;\n        text-decoration: none;\n\n    }\n    .dropdown-item:hover,\n    .dropdown-item:focus{\n        background-color: $default-color;\n    }\n\n    &.dropdown-primary .dropdown-item:hover,\n    &.dropdown-primary .dropdown-item:focus{\n        background-color: $bg-primary;\n    }\n    &.dropdown-info .dropdown-item:hover,\n    &.dropdown-info .dropdown-item:focus{\n        background-color: $bg-info;\n    }\n    &.dropdown-success .dropdown-item:hover,\n    &.dropdown-success .dropdown-item:focus{\n        background-color: $bg-success;\n    }\n    &.dropdown-warning .dropdown-item:hover,\n    &.dropdown-warning .dropdown-item:focus{\n        background-color: $bg-warning;\n    }\n    &.dropdown-danger .dropdown-item:hover,\n    &.dropdown-danger .dropdown-item:focus{\n        background-color: $bg-danger;\n    }\n\n}\n.dropdown-divider{\n    margin: 0 !important;\n}\n\n//fix bug for the select items in btn-group\n.btn-group.select{\n    // overflow: hidden;\n}\n.btn-group.select.open{\n    overflow: visible;\n}\n.dropdown-menu-right{\n    right: -2px;\n    left: auto;\n}\n\n.navbar-nav .dropdown-menu:before,\n.dropdown .dropdown-menu[x-placement=\"bottom-start\"]:before,\n.dropdown .dropdown-menu[x-placement=\"bottom-end\"]:before,\n.card.card-just-text .dropdown .dropdown-menu:before,\n.card-just-text .dropdown .dropdown-menu:before,\n.dropdown-btn .dropdown-menu:before{\n    border-bottom: 11px solid $medium-pale-bg;\n    border-left: 11px solid rgba(0, 0, 0, 0);\n    border-right: 11px solid rgba(0, 0, 0, 0);\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: 12px;\n    top: -12px;\n}\n\n.navbar-nav .dropdown-menu:after,\n.dropdown .dropdown-menu[x-placement=\"bottom-start\"]:after,\n.dropdown .dropdown-menu[x-placement=\"bottom-end\"]:after,\n.card.card-just-text .dropdown .dropdown-menu:after,\n.card-just-text .dropdown .dropdown-menu:after,\n.dropdown-btn .dropdown-menu:after{\n    border-bottom: 11px solid $white-color;\n    border-left: 11px solid rgba(0, 0, 0, 0);\n    border-right: 11px solid rgba(0, 0, 0, 0);\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: 12px;\n    top: -11px;\n}\n\n.dropdown .dropdown-menu.dropdown-notification[x-placement=\"top-start\"]:before,\n.dropdown .dropdown-menu.dropdown-notification[x-placement=\"bottom-start\"]:before{\n    left: 30px !important;\n    right: auto;\n}\n.dropdown .dropdown-menu.dropdown-notification[x-placement=\"top-start\"]:after,\n.dropdown .dropdown-menu.dropdown-notification[x-placement=\"bottom-start\"]:after{\n    left: 30px !important;\n    right: auto;\n}\n//  the style for opening dropdowns on mobile devices; for the desktop version check the _responsive.scss file\n//  code from _responsive.scss\n\n@media screen and (min-width: 768px){\n    .navbar-form {\n      margin-top: 21px;\n      margin-bottom: 21px;\n      padding-left: 5px;\n      padding-right: 5px;\n    }\n    .navbar-search-form{\n      display: none;\n    }\n    .navbar-nav .dropdown-item .dropdown-menu,\n    .dropdown .dropdown-menu,\n    .dropdown-btn .dropdown-menu{\n      transform: translate3d(0px, -40px, 0px);\n      transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;\n    }\n    .navbar-nav .dropdown-item.show .dropdown-menu,\n    .dropdown.show .dropdown-menu,\n    .dropdown-btn.show .dropdown-menu{\n      transform: translate3d(0px, 0px, 0px);\n      visibility: visible !important;\n    }\n    .bootstrap-select .dropdown-menu{\n      -webkit-transition: all 150ms linear;\n      -moz-transition: all 150ms linear;\n      -o-transition: all 150ms linear;\n      -ms-transition: all 150ms linear;\n      transition: all 150ms linear;\n    }\n    .bootstrap-datetimepicker-widget{\n      visibility: visible !important;\n    }\n\n    .bootstrap-select .show .dropdown-menu{\n      transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;\n      transform: translate3d(0px, 0px, 0px);\n    }\n\n    .navbar-nav.navbar-right li .dropdown-menu:before,\n    .navbar-nav.navbar-right li .dropdown-menu:after{\n        left: auto;\n        right: 12px;\n    }\n\n\n    .footer:not(.footer-big){\n        nav ul{\n           li:first-child{\n             margin-left: 0;\n           }\n        }\n    }\n\n// no dragging the others navs in page\n    body > .navbar-collapse.collapse{\n        display: none !important;\n    }\n}\n\n.dropdown-sharing{\n    .dropup-item{\n        color: $font-color;\n        font-size: $font-size-base;\n\n        .social-line{\n            line-height: 28px;\n            padding: 10px 20px 5px 20px !important;\n\n            [class*=\"icon-\"]{\n                font-size: 20px;\n            }\n        }\n        &:last-child{\n            margin: 0 13px;\n            display: block;\n        }\n        .btn{\n            margin: 10px;\n        }\n    }\n\n    .dropup-item:hover,\n    .dropup-item:focus{\n        .social-line,\n        .action-line{\n            background-color: $white-color;\n            color: $font-color;\n            opacity: 1;\n            text-decoration: none;\n        }\n    }\n}\n.show .dropdown-sharing,\n.show .dropdown-actions{\n    margin-bottom: 1px;\n}\n\n.dropdown-actions{\n    .dropdown-item{\n        margin: -15px 35px;\n        .action-line{\n            padding: 5px 10px;\n            line-height: 24px;\n            font-weight: bold;\n            [class*=\"icon-\"]{\n                font-size: 24px;\n            }\n            .col-sm-9{\n                line-height: 34px;\n            }\n        }\n        .link-danger{\n            color: $danger-color;\n            &:hover, &:active, &:focus{\n                color: $danger-color;\n            }\n        }\n    }\n    li:hover,\n    li:focus{\n        a{\n            color: $font-color;\n            opacity: 1;\n            text-decoration: none;\n        }\n    }\n    .action-line{\n        .icon-simple{\n            margin-left: -15px;\n        }\n    }\n}\n.dropdown .dropdown-menu[x-placement=\"top-start\"]:before,\n.dropdown .dropdown-menu[x-placement=\"top-end\"]:before,\n.dropup .dropdown-menu:before{\n    border-top: 11px solid #DCD9D1;\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: 12px;\n    bottom: -12px;\n}\n\n.dropdown .dropdown-menu[x-placement=\"top-start\"]:after,\n.dropdown .dropdown-menu[x-placement=\"top-end\"]:after,\n.dropup .dropdown-menu:after{\n    border-top: 11px solid #FFF;\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: 12px;\n    bottom: -11px;\n}\n\n.dropup,\n.dropdown{\n    .dropdown-toggle:after{\n        margin-left: 0;\n    }\n}\n\n.dropdown-notification{\n    .dropdown-notification-list{\n            .notification-item{\n                border-bottom: 1px solid #F1EAE0;\n                font-size: 16px;\n                color: #66615b;\n\n                .notification-text{\n                    padding-left: 40px;\n                    position: relative;\n                    min-width: 330px;\n                    min-height: 70px;\n                    white-space: normal;\n\n\n                    .label{\n                        display: block;\n                        position: absolute;\n                        top: 50%;\n                        margin-top: -12px;\n                        left: 7px;\n                    }\n                    .message{\n                        font-size: 0.9em;\n                        line-height: 0.7;\n                        margin-left: 10px;\n                    }\n                    .time{\n                        color: #9A9A9A;\n                        font-size: 0.7em;\n                        margin-left: 10px;\n                    }\n                }\n                .read-notification{\n                    font-size: 12px;\n                    opacity: 0;\n                    position: absolute;\n                    right: 5px;\n                    top: 50%;\n                    margin-top: -12px;\n                }\n                &:hover{\n                    text-decoration: none;\n\n                    .notification-text{\n                        color: #66615b;\n                        background-color: #F0EFEB !important;\n                    }\n                    .read-notification{\n                        opacity: 1 !important;\n                    }\n                }\n            }\n\n    }\n    .dropdown-footer{\n        background-color: #E8E7E3;\n        border-radius: 0 0 8px 8px;\n\n        .dropdown-footer-menu{\n            list-style: outside none none;\n            padding: 0px 5px;\n            li{\n                display: inline-block;\n                text-align: left;\n                padding: 0 10px;\n\n                a{\n                    color: #9C9B99;\n                    font-size: 0.9em;\n                    line-height: 35px;\n                }\n            }\n        }\n    }\n}\n",".alert{\n    border: 0;\n    border-radius: $border-radius-small;\n    color: $white-color;\n    padding-top: .9rem;\n    padding-bottom: .9rem;\n    position: relative;\n\n    &.alert-success{\n        background-color: lighten($success-color, 5%);\n    }\n\n    &.alert-danger{\n        background-color: lighten($danger-color, 5%);\n    }\n\n    &.alert-warning{\n        background-color: lighten($warning-color, 5%);\n    }\n\n    &.alert-info{\n        background-color: lighten($info-color, 5%);\n    }\n\n    &.alert-primary{\n        background-color: lighten($primary-color, 5%);\n    }\n\n    .close{\n      color: $white-color;\n      opacity: .9;\n      text-shadow: none;\n      line-height: 0;\n      outline: 0;\n\n      i.fa,\n      i.nc-icon{\n          font-size: 14px !important;\n      }\n\n      &:hover,\n      &:focus {\n        opacity: 1;\n      }\n    }\n\n    span[data-notify=\"icon\"]{\n        font-size: 27px;\n        display: block;\n        left: 19px;\n        position: absolute;\n        top: 50%;\n        margin-top: -11px;\n    }\n\n    button.close{\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        margin-top: -13px;\n        width: 25px;\n        height: 25px;\n        padding: 3px;\n    }\n\n    .close ~ span{\n        display: block;\n        max-width: 89%;\n    }\n\n    &.alert-with-icon{\n        padding-left: 65px;\n    }\n}\n","img{\n    max-width: 100%;\n    border-radius: $border-radius-small;\n}\n.img-raised{\n    box-shadow: $box-shadow-raised;\n}\n","/*--------------------------------\n\nnucleo-icons Web Font - built using nucleoapp.com\nLicense - nucleoapp.com/license/\n\n-------------------------------- */\n@font-face {\n  font-family: 'nucleo-icons';\n  src: url('~assets/fonts/nucleo-icons.eot');\n  src: url('~assets/fonts/nucleo-icons.eot') format('embedded-opentype'), url('~assets/fonts/nucleo-icons.woff2') format('woff2'), url('~assets/fonts/nucleo-icons.woff') format('woff'), url('~assets/fonts/nucleo-icons.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n/*------------------------\n\tbase class definition\n-------------------------*/\n.nc-icon {\n  display: inline-block;\n  font: normal normal normal 14px/1 'nucleo-icons';\n  font-size: inherit;\n  speak: none;\n  text-transform: none;\n  /* Better Font Rendering */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n/*------------------------\n  change icon size\n-------------------------*/\n.nc-icon.lg {\n  font-size: 1.33333333em;\n  vertical-align: -16%;\n}\n.nc-icon.x2 {\n  font-size: 2em;\n}\n.nc-icon.x3 {\n  font-size: 3em;\n}\n/*----------------------------------\n  add a square/circle background\n-----------------------------------*/\n.nc-icon.square,\n.nc-icon.circle {\n  padding: 0.33333333em;\n  vertical-align: -16%;\n  background-color: #eee;\n}\n.nc-icon.circle {\n  border-radius: 50%;\n}\n/*------------------------\n  list icons\n-------------------------*/\n.nc-icon-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n.nc-icon-ul > li {\n  position: relative;\n}\n.nc-icon-ul > li > .nc-icon {\n  position: absolute;\n  left: -1.57142857em;\n  top: 0.14285714em;\n  text-align: center;\n}\n.nc-icon-ul > li > .nc-icon.lg {\n  top: 0;\n  left: -1.35714286em;\n}\n.nc-icon-ul > li > .nc-icon.circle,\n.nc-icon-ul > li > .nc-icon.square {\n  top: -0.19047619em;\n  left: -1.9047619em;\n}\n/*------------------------\n  spinning icons\n-------------------------*/\n.nc-icon.spin {\n  -webkit-animation: nc-icon-spin 2s infinite linear;\n  -moz-animation: nc-icon-spin 2s infinite linear;\n  animation: nc-icon-spin 2s infinite linear;\n}\n@-webkit-keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@-moz-keyframes nc-icon-spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n/*------------------------\n  rotated/flipped icons\n-------------------------*/\n.nc-icon.rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.nc-icon.rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.nc-icon.rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n.nc-icon.flip-y {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n.nc-icon.flip-x {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n/*------------------------\n\tfont icons\n-------------------------*/\n\n.nc-air-baloon::before {\n    content: \"\\ea01\";\n}\n\n.nc-album-2::before {\n    content: \"\\ea02\";\n}\n\n.nc-alert-circle-i::before {\n    content: \"\\ea04\";\n}\n\n.nc-align-center::before {\n    content: \"\\ea03\";\n}\n\n.nc-align-left-2::before {\n    content: \"\\ea05\";\n}\n\n.nc-ambulance::before {\n    content: \"\\ea06\";\n}\n\n.nc-app::before {\n    content: \"\\ea07\";\n}\n\n.nc-atom::before {\n    content: \"\\ea08\";\n}\n\n.nc-badge::before {\n    content: \"\\ea09\";\n}\n\n.nc-bag-16::before {\n    content: \"\\ea0a\";\n}\n\n.nc-bank::before {\n    content: \"\\ea0b\";\n}\n\n.nc-basket::before {\n    content: \"\\ea0c\";\n}\n\n.nc-bell-55::before {\n    content: \"\\ea0d\";\n}\n\n.nc-bold::before {\n    content: \"\\ea0e\";\n}\n\n.nc-book-bookmark::before {\n    content: \"\\ea0f\";\n}\n\n.nc-bookmark-2::before {\n    content: \"\\ea10\";\n}\n\n.nc-box-2::before {\n    content: \"\\ea11\";\n}\n\n.nc-box::before {\n    content: \"\\ea12\";\n}\n\n.nc-briefcase-24::before {\n    content: \"\\ea13\";\n}\n\n.nc-bulb-63::before {\n    content: \"\\ea14\";\n}\n\n.nc-bullet-list-67::before {\n    content: \"\\ea15\";\n}\n\n.nc-bus-front-12::before {\n    content: \"\\ea16\";\n}\n\n.nc-button-pause::before {\n    content: \"\\ea17\";\n}\n\n.nc-button-play::before {\n    content: \"\\ea18\";\n}\n\n.nc-button-power::before {\n    content: \"\\ea19\";\n}\n\n.nc-calendar-60::before {\n    content: \"\\ea1a\";\n}\n\n.nc-camera-compact::before {\n    content: \"\\ea1b\";\n}\n\n.nc-caps-small::before {\n    content: \"\\ea1c\";\n}\n\n.nc-cart-simple::before {\n    content: \"\\ea1d\";\n}\n\n.nc-chart-bar-32::before {\n    content: \"\\ea1e\";\n}\n\n.nc-chart-pie-36::before {\n    content: \"\\ea1f\";\n}\n\n.nc-chat-33::before {\n    content: \"\\ea20\";\n}\n\n.nc-check-2::before {\n    content: \"\\ea21\";\n}\n\n.nc-circle-10::before {\n    content: \"\\ea22\";\n}\n\n.nc-cloud-download-93::before {\n    content: \"\\ea23\";\n}\n\n.nc-cloud-upload-94::before {\n    content: \"\\ea24\";\n}\n\n.nc-compass-05::before {\n    content: \"\\ea25\";\n}\n\n.nc-controller-modern::before {\n    content: \"\\ea26\";\n}\n\n.nc-credit-card::before {\n    content: \"\\ea27\";\n}\n\n.nc-delivery-fast::before {\n    content: \"\\ea28\";\n}\n\n.nc-diamond::before {\n    content: \"\\ea29\";\n}\n\n.nc-email-85::before {\n    content: \"\\ea2a\";\n}\n\n.nc-favourite-28::before {\n    content: \"\\ea2b\";\n}\n\n.nc-glasses-2::before {\n    content: \"\\ea2c\";\n}\n\n.nc-globe-2::before {\n    content: \"\\ea2d\";\n}\n\n.nc-globe::before {\n    content: \"\\ea2e\";\n}\n\n.nc-hat-3::before {\n    content: \"\\ea2f\";\n}\n\n.nc-headphones::before {\n    content: \"\\ea30\";\n}\n\n.nc-html5::before {\n    content: \"\\ea31\";\n}\n\n.nc-image::before {\n    content: \"\\ea32\";\n}\n\n.nc-istanbul::before {\n    content: \"\\ea33\";\n}\n\n.nc-key-25::before {\n    content: \"\\ea34\";\n}\n\n.nc-laptop::before {\n    content: \"\\ea35\";\n}\n\n.nc-layout-11::before {\n    content: \"\\ea36\";\n}\n\n.nc-lock-circle-open::before {\n    content: \"\\ea37\";\n}\n\n.nc-map-big::before {\n    content: \"\\ea38\";\n}\n\n.nc-minimal-down::before {\n    content: \"\\ea39\";\n}\n\n.nc-minimal-left::before {\n    content: \"\\ea3a\";\n}\n\n.nc-minimal-right::before {\n    content: \"\\ea3b\";\n}\n\n.nc-minimal-up::before {\n    content: \"\\ea3c\";\n}\n\n.nc-mobile::before {\n    content: \"\\ea3d\";\n}\n\n.nc-money-coins::before {\n    content: \"\\ea3e\";\n}\n\n.nc-note-03::before {\n    content: \"\\ea3f\";\n}\n\n.nc-palette::before {\n    content: \"\\ea40\";\n}\n\n.nc-paper::before {\n    content: \"\\ea41\";\n}\n\n.nc-pin-3::before {\n    content: \"\\ea42\";\n}\n\n.nc-planet::before {\n    content: \"\\ea43\";\n}\n\n.nc-refresh-69::before {\n    content: \"\\ea44\";\n}\n\n.nc-ruler-pencil::before {\n    content: \"\\ea45\";\n}\n\n.nc-satisfied::before {\n    content: \"\\ea46\";\n}\n\n.nc-scissors::before {\n    content: \"\\ea47\";\n}\n\n.nc-send::before {\n    content: \"\\ea48\";\n}\n\n.nc-settings-gear-65::before {\n    content: \"\\ea49\";\n}\n\n.nc-settings::before {\n    content: \"\\ea4a\";\n}\n\n.nc-share-66::before {\n    content: \"\\ea4b\";\n}\n\n.nc-shop::before {\n    content: \"\\ea4c\";\n}\n\n.nc-simple-add::before {\n    content: \"\\ea4d\";\n}\n\n.nc-simple-delete::before {\n    content: \"\\ea4e\";\n}\n\n.nc-simple-remove::before {\n    content: \"\\ea4f\";\n}\n\n.nc-single-02::before {\n    content: \"\\ea50\";\n}\n\n.nc-single-copy-04::before {\n    content: \"\\ea51\";\n}\n\n.nc-sound-wave::before {\n    content: \"\\ea52\";\n}\n\n.nc-spaceship::before {\n    content: \"\\ea53\";\n}\n\n.nc-sun-fog-29::before {\n    content: \"\\ea54\";\n}\n\n.nc-support-17::before {\n    content: \"\\ea55\";\n}\n\n.nc-tablet-2::before {\n    content: \"\\ea56\";\n}\n\n.nc-tag-content::before {\n    content: \"\\ea57\";\n}\n\n.nc-tap-01::before {\n    content: \"\\ea58\";\n}\n\n.nc-tie-bow::before {\n    content: \"\\ea59\";\n}\n\n.nc-tile-56::before {\n    content: \"\\ea5a\";\n}\n\n.nc-time-alarm::before {\n    content: \"\\ea5b\";\n}\n\n.nc-touch-id::before {\n    content: \"\\ea5c\";\n}\n\n.nc-trophy::before {\n    content: \"\\ea5d\";\n}\n\n.nc-tv-2::before {\n    content: \"\\ea5e\";\n}\n\n.nc-umbrella-13::before {\n    content: \"\\ea5f\";\n}\n\n.nc-user-run::before {\n    content: \"\\ea60\";\n}\n\n.nc-vector::before {\n    content: \"\\ea61\";\n}\n\n.nc-watch-time::before {\n    content: \"\\ea62\";\n}\n\n.nc-world-2::before {\n    content: \"\\ea63\";\n}\n\n.nc-zoom-split::before {\n    content: \"\\ea64\";\n}\n\n\n/* all icon font classes list here */\n",".table{\n\n    .img-wrapper{\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      overflow: hidden;\n      margin: 0 auto;\n    }\n\n    .img-row{\n      max-width: 60px;\n      width: 60px;\n    }\n\n    .form-check{\n        margin: 0;\n\n        & label .form-check-sign::before,\n        & label .form-check-sign::after{\n            top: -17px;\n            left: 4px;\n        }\n    }\n\n    .btn{\n        margin: 0;\n    }\n\n    small,.small{\n      font-weight: 300;\n    }\n\n    .card-tasks .card-body &{\n        margin-bottom: 0;\n\n        > thead > tr > th,\n        > tbody > tr > th,\n        > tfoot > tr > th,\n        > thead > tr > td,\n        > tbody > tr > td,\n        > tfoot > tr > td{\n            padding-top: 0;\n            padding-bottom: 0;\n        }\n    }\n\n   > thead > tr > th{\n       font-size: 14px;\n       font-weight: $font-weight-bold;\n       padding-bottom: 0;\n       text-transform: uppercase;\n       border: 0;\n   }\n\n   .radio,\n   .checkbox{\n       margin-top: 0;\n       margin-bottom: 0;\n       padding: 0;\n       width: 15px;\n\n       .icons{\n           position: relative;\n       }\n\n        label{\n            &:after,\n            &:before{\n                top: -17px;\n                left: -3px;\n            }\n        }\n   }\n   > thead > tr > th,\n   > tbody > tr > th,\n   > tfoot > tr > th,\n   > thead > tr > td,\n   > tbody > tr > td,\n   > tfoot > tr > td{\n       padding: 12px 7px;\n       vertical-align: middle;\n   }\n\n   .th-description{\n       max-width: 150px;\n   }\n   .td-price{\n       font-size: 26px;\n       font-weight: $font-weight-light;\n       margin-top: 5px;\n       position: relative;\n       top: 4px;\n       text-align: right;\n   }\n   .td-total{\n        font-weight: $font-weight-bold;\n        font-size: $font-size-h5;\n        padding-top: 20px;\n        text-align: right;\n    }\n\n   .td-actions .btn{\n    margin: 0px;\n    }\n\n    > tbody > tr{\n        position: relative;\n    }\n}\n\n.table-shopping{\n    > thead > tr > th{\n        font-size: $font-size-h6;\n        text-transform: uppercase;\n    }\n    > tbody > tr > td{\n        font-size: $font-paragraph;\n\n        b{\n            display: block;\n            margin-bottom: 5px;\n        }\n    }\n    .td-name{\n        font-weight: $font-weight-normal;\n        font-size: 1.5em;\n        small{\n            color: $dark-gray;\n            font-size: 0.75em;\n            font-weight: $font-weight-light;\n        }\n    }\n    .td-number{\n       font-weight: $font-weight-light;\n       font-size: $font-size-h4;\n   }\n    .td-name{\n        min-width: 200px;\n    }\n    .td-number{\n        text-align: right;\n        min-width: 170px;\n\n        small{\n            margin-right: 3px;\n        }\n    }\n\n    .img-container{\n        width: 120px;\n        max-height: 160px;\n        overflow: hidden;\n        display: block;\n\n        img{\n            width: 100%;\n        }\n    }\n}\n\n.table-responsive{\n  overflow: scroll;\n  padding-bottom: 10px;\n}\n\n#tables .table-responsive{\n    margin-bottom: 30px;\n}\n\n.table-hover>tbody>tr:hover{\n  background-color: #f5f5f5;\n}\n",".wrapper{\n    position: relative;\n    top: 0;\n    height: 100vh;\n\n    &.wrapper-full-page{\n        min-height: 100vh;\n        height: auto;\n    }\n}\n\n.sidebar,\n.off-canvas-sidebar{\n    position: fixed;\n    top: 0;\n    height: 100vh;\n    bottom: 0;\n    width: 260px;\n    left: 0;\n    z-index: 1030;\n    border-right: 1px solid #ddd;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden; \n\n    .sidebar-wrapper{\n        position: relative;\n        flex: 1; \n        overflow: auto;\n        width: 260px;\n        z-index: 4;\n        overflow-y: auto; \n\n        .dropdown .dropdown-backdrop {\n          display: none !important;\n        }\n        .navbar-form {\n            border: none;\n        }\n    }\n    \n    .sidebar-footer {\n        flex-shrink: 0;\n        padding: 3px;\n        background-color: transparent;\n        z-index: 4;\n\n        .footer-content {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n        }\n\n        .eu-flag {\n            width: 5rem;\n            flex-shrink: 0;\n            margin-top: 2px;\n        }\n\n        .funding-statement {\n            font-size: 10px;\n            line-height: 1.3;\n            margin: 0;\n            color: inherit;\n            font-weight: 400;\n        }\n    }\n\n    .navbar-minimize{\n      position: absolute;\n      right: 20px;\n      top: 2px;\n      opacity: 1;\n\n      @extend .animation-transition-general;\n    }\n    .logo-tim{\n      border-radius: 50%;\n      border: 1px solid #333;\n      display: block;\n      height: 61px;\n      width: 61px;\n      float: left;\n      overflow: hidden;\n\n      img{\n          width: 60px;\n          height: 60px;\n      }\n    }\n\n    .nav{\n        margin-top: 20px;\n        display: block;\n\n        .caret{\n            top: 14px;\n            position: absolute;\n            right: 10px;\n        }\n\n        li{\n            > a + div .nav li > a{\n                margin-top: 7px;\n            }\n\n            > a{\n                margin: 10px 15px 0;\n                color: $white-color;\n                display: block;\n                text-decoration: none;\n                position: relative;\n                text-transform: uppercase;\n                cursor: pointer;\n                font-size: 12px;\n                padding: 10px 8px;\n                line-height: 30px;\n                opacity: .7;\n            }\n\n            .nav > li > a{\n              padding: 5px 8px;\n            }\n\n            &.active > a,\n            &.active > a > i {\n              opacity: 1;\n            }\n\n            &:hover:not(.active) > a,\n            &:focus:not(.active) > a {\n                opacity: 1;\n            }\n        }\n\n        i{\n            font-size: 24px;\n            float: left;\n            margin-right: 12px;\n            line-height: 30px;\n            width: 34px;\n            text-align: center;\n            color: $opacity-5;\n            position: relative;\n        }\n\n        p {\n          margin-bottom: 0;\n        }\n\n        .collapse,\n        .collapsing {\n          .nav {\n            margin-top: 0;\n          }\n        }\n    }\n\n    .sidebar-background{\n        position: absolute;\n        z-index: 1;\n        height: 100%;\n        width: 100%;\n        display: block;\n        top: 0;\n        left: 0;\n        background-size: cover;\n        background-position: center center;\n\n        &:after{\n            position: absolute;\n            z-index: 3;\n            width: 100%;\n            height: 100%;\n            content: \"\";\n            display: block;\n            background: #FFFFFF;\n            opacity: 1;\n        }\n    }\n\n    .logo{\n        position: relative;\n        padding: 7px $padding-base-horizontal;\n        z-index: 4;\n\n        a.logo-mini,\n        a.logo-normal{\n            @extend .animation-transition-general;\n        }\n\n        a.logo-mini{\n            opacity: 1;\n            float: left;\n            width: 34px;\n            text-align: center;\n            margin-left: 10px;\n            margin-right: 12px;\n        }\n\n        a.logo-normal{\n            display: block;\n            opacity: 1;\n            padding: 11px 0 8px;\n            @include transform-translate-x(0px);\n        }\n\n        &:after{\n            content: '';\n            position: absolute;\n            bottom: 0;\n            right: 15px;\n            height: 1px;\n            width: calc(100% - 30px);\n            background-color: $opacity-5;\n\n        }\n\n        p{\n            float: left;\n            font-size: 20px;\n            margin: 10px 10px;\n            color: $white-color;\n            line-height: 20px;\n            font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n        }\n\n        .simple-text{\n            text-transform: uppercase;\n            padding: $padding-base-vertical 0;\n            display: block;\n            white-space: nowrap;\n            font-size: $font-size-large;\n            color: $white-color;\n            text-decoration: none;\n            font-weight: $font-weight-normal;\n            line-height: 30px;\n            overflow: hidden;\n        }\n    }\n\n    .logo-tim{\n        border-radius: 50%;\n        border: 1px solid #333;\n        display: block;\n        height: 61px;\n        width: 61px;\n        float: left;\n        overflow: hidden;\n\n        img{\n            width: 60px;\n            height: 60px;\n        }\n    }\n\n    &:before,\n    &:after{\n        display: block;\n        content: \"\";\n        opacity: 1;\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n    }\n\n    &:after{\n        @include icon-gradient($default-color);\n        z-index: 3;\n    }\n\n    &[data-color=\"white\"]{\n      @include sidebar-color($white-color);\n      @include sidebar-text-color($default-color);\n    }\n    &[data-color=\"black\"]{\n      @include sidebar-color($dark-color);\n    }\n\n\n    // Active color changing\n\n    &[data-active-color=\"primary\"]{\n        @include sidebar-active-color($primary-color);\n    }\n    &[data-active-color=\"info\"]{\n        @include sidebar-active-color($info-color);\n    }\n    &[data-active-color=\"success\"]{\n        @include sidebar-active-color($success-color);\n    }\n    &[data-active-color=\"warning\"]{\n        @include sidebar-active-color($warning-color);\n    }\n    &[data-active-color=\"danger\"]{\n        @include sidebar-active-color($danger-color);\n    }\n}\n\n.visible-on-sidebar-regular{\n    display: inline-block !important;\n}\n.visible-on-sidebar-mini{\n    display: none !important;\n}\n\n.off-canvas-sidebar{\n    .nav {\n        > li > a,\n        > li > a:hover{\n            color: $white-color;\n        }\n\n        > li > a:focus{\n            background: rgba(200, 200, 200, 0.2);\n        }\n    }\n}\n\n\n.main-panel{\n    position: relative;\n    float: right;\n    width: $sidebar-width;\n    background-color: #f4f3ef;;\n\n\n    @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n\n    > .content{\n        padding: 0 30px 30px;\n        min-height: calc(100vh - 180px);\n        margin-top: 93px;\n    }\n\n    > .navbar{\n        margin-bottom: 0;\n    }\n\n\n    .header{\n        margin-bottom: 50px;\n    }\n}\n\n\n.perfect-scrollbar-on{\n  .sidebar,\n  .main-panel{\n      height: 100%;\n      max-height: 100%;\n  }\n}\n\n.panel-header {\n  height: 260px;\n  padding-top: 80px;\n  padding-bottom: 45px;\n  background: #141E30;  /* fallback for old browsers */\n  background: -webkit-gradient(linear, left top, right top, from(#0c2646), color-stop(60%, #204065), to(#2a5788));\n  background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);\n  position: relative;\n  overflow: hidden;\n\n  .header{\n    .title{\n      color: $white-color;\n    }\n    .category{\n      max-width: 600px;\n      color: $opacity-5;\n      margin: 0 auto;\n      font-size: 13px;\n\n      a{\n        color: $white-color;\n      }\n    }\n  }\n}\n\n.panel-header-sm{\n  height: 135px;\n}\n\n.panel-header-lg{\n  height: 380px\n}\n\n\n.sidebar-footer {\n    padding: 15px;\n    background-color: inherit; // Keeps the same color as the sidebar\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n    width: 100%;\n    z-index: 10; // Ensures it stays above any background decorations\n    \n    .footer-content {\n        display: flex;\n        align-items: flex-start;\n        gap: 10px;\n    }\n\n    .eu-flag {\n        width: 35px;\n        flex-shrink: 0;\n    }\n\n    .funding-statement {\n        font-size: 10px;\n        line-height: 1.2;\n        margin: 0;\n        color: rgba(255, 255, 255, 0.8);\n    }\n}",".footer{\n    padding: 24px 0px 10px;\n\n    &.footer-default{\n        background-color: #f2f2f2;\n    }\n\n    nav{\n        display: inline-block;\n        float: left;\n        padding-left: 0;\n    }\n\n    ul{\n        margin-bottom: 0;\n        padding: 0;\n        list-style: none;\n\n        li{\n            display: inline-block;\n\n            a{\n                color: inherit;\n                padding: $padding-base-vertical;\n                font-size: $font-size-small;\n                text-transform: uppercase;\n                text-decoration: none;\n\n                &:hover{\n                    text-decoration: none;\n                }\n            }\n        }\n    }\n\n    .copyright{\n        font-size: $font-size-small;\n        line-height: 1.8;\n    }\n\n    &:after{\n        display: table;\n        clear: both;\n        content: \" \";\n    }\n}\n",".fixed-plugin{\n    position: fixed;\n    right: 0;\n    width: 64px;\n    background: rgba(0,0,0,.3);\n    z-index: 1031;\n    border-radius: 8px 0 0 8px;\n    text-align: center;\n    top: 120px;\n\n    li > a,\n    .badge{\n        transition: all .34s;\n        -webkit-transition: all .34s;\n        -moz-transition: all .34s;\n    }\n\n    .fa-cog{\n        color: #FFFFFF;\n        padding: 10px;\n        border-radius: 0 0 6px 6px;\n        width: auto;\n    }\n\n    .dropdown-menu{\n        right: 80px;\n        left: auto !important;\n        top: -52px !important;\n        width: 290px;\n        border-radius: 10px;\n        padding: 0 10px;\n    }\n\n    .dropdown .dropdown-menu .nc-icon{\n      top: 2px;\n      right: 10px;\n      font-size: 14px;\n    }\n\n    .dropdown-menu:after,\n    .dropdown-menu:before{\n        right: 10px;\n        margin-left: auto;\n        left: auto;\n    }\n\n    .fa-circle-thin{\n        color: #FFFFFF;\n    }\n\n    .active .fa-circle-thin{\n        color: #00bbff;\n    }\n\n    .dropdown-menu > .active > a,\n    .dropdown-menu > .active > a:hover,\n    .dropdown-menu > .active > a:focus{\n        color: #777777;\n        text-align: center;\n    }\n\n    img{\n        border-radius: 0;\n        width: 100%;\n        height: 100px;\n        margin: 0 auto;\n    }\n\n    .dropdown-menu li > a:hover,\n    .dropdown-menu li > a:focus{\n        box-shadow: none;\n    }\n\n    .badge{\n        border: 3px solid #FFFFFF;\n        border-radius: 50%;\n        cursor: pointer;\n        display: inline-block;\n        height: 23px;\n        margin-right: 5px;\n        position: relative;\n        width: 23px;\n\n      &.badge-light {\n        border: 1px solid $light-gray;\n\n        &.active,\n        &:hover {\n          border: 3px solid #0bf;\n        }\n      }\n    }\n\n    .badge.active,\n    .badge:hover{\n        border-color: #00bbff;\n    }\n\n    .badge-blue{\n        background-color: $brand-info;\n    }\n    .badge-green{\n        background-color: $brand-success;\n    }\n    .badge-orange{\n        background-color: $brand-primary;\n    }\n    .badge-yellow{\n        background-color: $brand-warning;\n    }\n    .badge-red{\n        background-color: $brand-danger;\n    }\n\n    h5{\n        font-size: 14px;\n        margin: 10px;\n    }\n\n    .dropdown-menu li{\n        display: block;\n        padding: 15px 2px;\n        width: 25%;\n        float: left;\n    }\n\n    li.adjustments-line,\n    li.header-title,\n    li.button-container{\n        width: 100%;\n        height: 35px;\n        min-height: inherit;\n    }\n\n    li.button-container{\n        height: auto;\n\n        div{\n            margin-bottom: 5px;\n        }\n    }\n\n    #sharrreTitle{\n        text-align: center;\n        padding: 10px 0;\n        height: 50px;\n    }\n\n    li.header-title{\n        height: 30px;\n        line-height: 25px;\n        font-size: 12px;\n        font-weight: 600;\n        text-align: center;\n        text-transform: uppercase;\n    }\n\n    .adjustments-line{\n        p{\n            float: left;\n            display: inline-block;\n            margin-bottom: 0;\n            font-size: 1em;\n            color: #3C4858;\n        }\n\n        a{\n            color: transparent;\n\n            .badge-colors{\n                position: relative;\n                top: -2px;\n            }\n\n            a:hover,\n            a:focus{\n                color: transparent;\n            }\n        }\n\n        .togglebutton{\n            text-align: center;\n\n            .label-switch{\n              position: relative;\n              left: -10px;\n              font-size: $font-size-mini;\n              color: $default-color;\n\n              &.label-right{\n                left: 10px;\n              }\n            }\n\n            .toggle{\n                margin-right: 0;\n            }\n        }\n\n        .dropdown-menu > li.adjustments-line > a{\n              padding-right: 0;\n              padding-left: 0;\n              border-bottom: 1px solid #ddd;\n              border-radius: 0;\n              margin: 0;\n        }\n    }\n\n\n\n    .dropdown-menu{\n        > li{\n            & > a.img-holder{\n                  font-size: 16px;\n                  text-align: center;\n                  border-radius: 10px;\n                  background-color: #FFF;\n                  border: 3px solid #FFF;\n                  padding-left: 0;\n                  padding-right: 0;\n                  opacity: 1;\n                  cursor: pointer;\n                  display: block;\n                  max-height: 100px;\n                  overflow: hidden;\n                  padding: 0;\n\n                  img{\n                     margin-top: auto;\n                  }\n            }\n\n            a.switch-trigger:hover,\n            & > a.switch-trigger:focus{\n                background-color: transparent;\n            }\n\n            &:hover,\n            &:focus{\n                > a.img-holder{\n                    border-color: rgba(0, 187, 255, 0.53);;\n                }\n            }\n        }\n\n        > .active > a.img-holder,\n        > .active > a.img-holder{\n            border-color: #00bbff;\n            background-color: #FFFFFF;\n        }\n\n    }\n\n    .btn-social{\n        width: 50%;\n        display: block;\n        width: 48%;\n        float: left;\n        font-weight: 600;\n    }\n\n    .btn-social{\n        i{\n            margin-right: 5px;\n        }\n\n        &:first-child{\n            margin-right: 2%;\n        }\n    }\n\n    .dropdown{\n        .dropdown-menu{\n          transform-origin: 0 0;\n\n          &:before{\n             border-bottom: 16px solid rgba(0, 0, 0, 0);\n             border-left: 16px solid rgba(0,0,0,0.2);\n             border-top: 16px solid rgba(0,0,0,0);\n             right: -27px;\n             bottom: 425px;\n          }\n\n          &:after{\n             border-bottom: 16px solid rgba(0, 0, 0, 0);\n             border-left: 16px solid #FFFFFF;\n             border-top: 16px solid rgba(0,0,0,0);\n             right: -26px;\n             bottom: 425px;\n          }\n\n          &:before,\n          &:after{\n             content: \"\";\n             display: inline-block;\n             position: absolute;\n             width: 16px;\n             transform: translateY(-50px);\n             -webkit-transform: translateY(-50px);\n             -moz-transform: translateY(-50px);\n          }\n        }\n\n      &.show-dropdown .show{\n        .dropdown-menu .show{\n          transform: translate3d(0, -60px, 0)!important;\n          bottom: auto!important;\n          top: 0!important;\n        }\n      }\n    }\n\n    .bootstrap-switch{\n        margin:0;\n    }\n}\n\n.fixed-plugin {\n  .show-dropdown {\n    .dropdown-menu[x-placement=bottom-start] {\n      @include transform-translate-y-fixed-plugin (-100px);\n\n      &:before,\n      &:after {\n        top: 100px;\n      }\n    }\n    .dropdown-menu[x-placement=top-start] {\n      @include transform-translate-y-fixed-plugin (100px);\n    }\n\n    &.show {\n      .dropdown-menu.show[x-placement=bottom-start] {\n        @include transform-translate-y-fixed-plugin (-60px);\n      }\n\n      .dropdown-menu.show[x-placement=top-start] {\n        @include transform-translate-y-fixed-plugin (470px);\n      }\n    }\n  }\n}\n",".card{\n  border-radius: $border-radius-extreme;\n  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);\n  background-color: #FFFFFF;\n  color: $card-black-color;\n  margin-bottom: 20px;\n  position: relative;\n  border: 0 none;\n\n  -webkit-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\n  -moz-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\n  -o-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\n  -ms-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\n  transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\n\n    .card-body{\n        padding: 15px 15px 10px 15px;\n\n        &.table-full-width{\n            padding-left: 0;\n            padding-right: 0;\n        }\n    }\n\n    .card-header{\n      &:not([data-background-color]){\n        background-color: transparent;\n      }\n      padding: 15px 15px 0;\n      border: 0;\n\n      .card-title{\n          margin-top: 10px;\n      }\n    }\n\n    .map{\n        border-radius: $border-radius-small;\n\n        &.map-big{\n          height: 400px;\n        }\n    }\n\n    &[data-background-color=\"orange\"]{\n        background-color: $primary-color;\n\n        .card-header{\n            background-color: $primary-color;\n        }\n\n        .card-footer{\n            .stats{\n                color: $white-color;\n            }\n        }\n    }\n\n    &[data-background-color=\"red\"]{\n        background-color: $danger-color;\n    }\n\n    &[data-background-color=\"yellow\"]{\n        background-color: $warning-color;\n    }\n\n    &[data-background-color=\"blue\"]{\n        background-color: $info-color;\n    }\n\n    &[data-background-color=\"green\"]{\n        background-color: $success-color;\n    }\n\n    .image{\n        overflow: hidden;\n        height: 200px;\n        position: relative;\n    }\n\n    .avatar{\n        width: 30px;\n        height: 30px;\n        overflow: hidden;\n        border-radius: 50%;\n        margin-bottom: 15px;\n    }\n\n    .numbers {\n      font-size: 2em;\n    }\n\n    .big-title {\n      font-size: 12px;\n      text-align: center;\n      font-weight: 500;\n      padding-bottom: 15px;\n    }\n\n    label{\n        font-size: $font-size-small;\n        margin-bottom: 5px;\n        color: $dark-gray;\n    }\n\n    .card-footer{\n        background-color: transparent;\n        border: 0;\n\n\n        .stats{\n            i{\n                margin-right: 5px;\n                position: relative;\n                top: 0px;\n                color: $default-color;\n            }\n        }\n\n        .btn{\n            margin: 0;\n        }\n    }\n\n    &.card-plain{\n        background-color: transparent;\n        box-shadow: none;\n        border-radius: 0;\n\n\n        .card-body{\n            padding-left: 5px;\n            padding-right: 5px;\n        }\n\n        img{\n            border-radius: $border-radius-extreme;\n        }\n    }\n}\n","\n.card-plain{\n    background: transparent;\n    box-shadow: none;\n\n    .card-header,\n    .card-footer{\n        margin-left: 0;\n        margin-right: 0;\n        background-color: transparent;\n    }\n\n    &:not(.card-subcategories).card-body{\n        padding-left: 0;\n        padding-right: 0;\n    }\n}\n",".card-chart {\n  .card-header{\n    .card-title{\n      margin-top: 10px;\n      margin-bottom: 0;\n    }\n    .card-category{\n      margin-bottom: 5px;\n    }\n  }\n\n  .table{\n    margin-bottom: 0;\n\n    td{\n      border-top: none;\n      border-bottom: 1px solid #e9ecef;\n    }\n  }\n\n  .card-progress {\n    margin-top: 30px;\n  }\n\n  .chart-area {\n    height: 190px;\n    width: calc(100% + 30px);\n    margin-left: -15px;\n    margin-right: -15px;\n  }\n  .card-footer {\n    margin-top: 15px;\n\n    .stats{\n      color: $dark-gray;\n    }\n  }\n\n  .dropdown{\n    position: absolute;\n    right: 20px;\n    top: 20px;\n\n    .btn{\n      margin: 0;\n    }\n  }\n}\n",".card-user{\n    .image{\n        height: 130px;\n\n      img {\n        border-radius: 12px;\n      }\n    }\n\n    .author{\n        text-align: center;\n        text-transform: none;\n        margin-top: -77px;\n\n        a +  p.description{\n            margin-top: -7px;\n        }\n    }\n\n    .avatar{\n        width: 124px;\n        height: 124px;\n        border: 1px solid $white-color;\n        position: relative;\n    }\n\n    .card-body{\n        min-height: 240px;\n    }\n\n    hr{\n        margin: 5px 15px 15px;\n    }\n\n    .card-body + .card-footer {\n      padding-top: 0;\n    }\n\n    .card-footer {\n      h5 {\n        font-size: 1.25em;\n        margin-bottom: 0;\n      }\n    }\n\n    .button-container{\n        margin-bottom: 6px;\n        text-align: center;\n    }\n}\n",".map{\n    height: 500px;\n}\n","%card-stats{\n  hr{\n    margin: 5px 15px;\n  }\n}\n\n\n.card-stats{\n    .card-body{\n        padding: 15px 15px 0px;\n\n        .numbers{\n          text-align: right;\n          font-size: 2em;\n\n            p{\n                margin-bottom: 0;\n            }\n            .card-category {\n              color: $dark-gray;\n              font-size: 16px;\n              line-height: 1.4em;\n            }\n        }\n    }\n    .card-footer{\n        padding: 0px 15px 15px;\n\n        .stats{\n          color: $dark-gray;\n        }\n\n        hr{\n          margin-top: 10px;\n          margin-bottom: 15px;\n        }\n    }\n    .icon-big {\n        font-size: 3em;\n        min-height: 64px;\n\n        i{\n            line-height: 59px;\n        }\n    }\n\n\n}\n","@media screen and (max-width: 991px){\n\n  .navbar {\n    padding: 0;\n\n    &.navbar-absolute {\n      padding-top: 0;\n    }\n\n    .navbar-brand {\n      font-size: 16px;\n      margin-right: 0;\n    }\n  }\n\n    .profile-photo .profile-photo-small{\n        margin-left: -2px;\n    }\n\n    .button-dropdown{\n        display: none;\n    }\n\n    #minimizeSidebar{\n        display: none;\n    }\n\n    .navbar{\n        .container-fluid{\n            padding-right: 15px;\n            padding-left: 15px;\n        }\n\n        .navbar-collapse{\n          .input-group{\n            margin: 0;\n            margin-top: 5px;\n          }\n        }\n\n        .navbar-nav{\n            .nav-item:first-child{\n              margin-top: 10px;\n            }\n            .nav-item:not(:last-child){\n                margin-bottom: 10px;\n            }\n        }\n\n        .dropdown.show .dropdown-menu{\n            display: block;\n        }\n\n        .dropdown .dropdown-menu{\n            display: none;\n        }\n\n        .dropdown.show .dropdown-menu,\n        .dropdown .dropdown-menu{\n            border: 0;\n            transition: none;\n            -webkit-box-shadow: none;\n            width: auto;\n            margin: 0px 1rem;\n            margin-top: 0px;\n            box-shadow: none;\n            position: static;\n            padding-left: 10px;\n\n            &:before{\n                display: none;\n            }\n        }\n\n        .dropdown-menu .dropdown-item:focus,\n        .dropdown-menu .dropdown-item:hover{\n            color: $white-color;\n        }\n\n        &.bg-white .dropdown-menu .dropdown-item:focus,\n        &.bg-white .dropdown-menu .dropdown-item:hover{\n            color: $default-color;\n        }\n\n        .navbar-toggler-bar{\n            display: block;\n            position: relative;\n            width: 22px;\n            height: 1px;\n            border-radius: 1px;\n            background: $default-color;\n\n            & + .navbar-toggler-bar{\n                margin-top: 7px;\n            }\n\n            & + .navbar-toggler-bar.navbar-kebab{\n                margin-top: 3px;\n            }\n\n            &.bar2{\n                width: 17px;\n                transition: width .2s linear;\n            }\n        }\n\n        &.bg-white:not(.navbar-transparent) .navbar-toggler-bar{\n            background-color: $default-color;\n        }\n\n        & .toggled .navbar-toggler-bar{\n            width: 24px;\n\n            & + .navbar-toggler-bar{\n                margin-top: 5px;\n            }\n        }\n\n    }\n\n    .wrapper{\n        @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n    }\n\n    .nav-open{\n        .main-panel{\n            right: 0;\n            @include transform-translate-x(260px);\n        }\n\n        .sidebar{\n            @include transform-translate-x(0px);\n        }\n\n        body{\n            position: relative;\n            overflow-x: hidden;\n        }\n\n        .menu-on-right{\n            .main-panel{\n                @include transform-translate-x(-260px);\n            }\n\n            .navbar-collapse,\n            .sidebar{\n                @include transform-translate-x(0px);\n            }\n\n            .navbar-translate{\n                @include transform-translate-x(-300px);\n            }\n\n            #bodyClick{\n                right: 260px;\n                left: auto;\n            }\n        }\n    }\n\n    .menu-on-right{\n        .sidebar{\n            left: auto;\n            right:0;\n            @include transform-translate-x(260px);\n        }\n    }\n\n    .bar1,\n    .bar2,\n    .bar3 {\n      outline: 1px solid transparent;\n    }\n    .bar1 {\n      top: 0px;\n      @include bar-animation($topbar-back);\n    }\n    .bar2 {\n      opacity: 1;\n    }\n    .bar3 {\n      bottom: 0px;\n      @include bar-animation($bottombar-back);\n    }\n    .toggled .bar1 {\n      top: 6px;\n      @include bar-animation($topbar-x);\n    }\n    .toggled .bar2 {\n      opacity: 0;\n    }\n    .toggled .bar3 {\n      bottom: 6px;\n      @include bar-animation($bottombar-x);\n    }\n\n    @include topbar-x-rotation();\n    @include topbar-back-rotation();\n    @include bottombar-x-rotation();\n    @include bottombar-back-rotation();\n\n    @-webkit-keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n    @-moz-keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n    @keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n\n    #bodyClick{\n        height: 100%;\n        width: 100%;\n        position: fixed;\n        opacity: 1;\n        top: 0;\n        right: 0;\n        left: 260px;\n        content: \"\";\n        z-index: 9999;\n        overflow-x: hidden;\n        background-color: transparent;\n        @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n    }\n\n    .footer{\n        .copyright{\n            text-align: right;\n        }\n    }\n\n    .section-nucleo-icons .icons-container{\n        margin-top: 65px;\n    }\n\n    .navbar-nav{\n        .nav-link{\n            i.fa,\n            i.nc-icon{\n                opacity: .5;\n            }\n        }\n    }\n\n    .sidebar,\n    .bootstrap-navbar {\n        position: fixed;\n        display: flex !important;\n        flex-direction: column !important;\n        top: 0;\n        height: 100vh !important; \n        width: 260px;\n        right: auto;\n        left: 0;\n        z-index: 1032;\n        visibility: visible;\n        overflow: hidden;\n        padding: 0;\n        @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n\n        @include transform-translate-x(-260px);\n    }\n\n    .sidebar {\n        .sidebar-wrapper {\n            flex: 1;\n            height: auto !important; \n            padding-bottom: 0px;\n            overflow-y: auto;\n        }\n    }\n\n\n    .main-panel{\n      width: 100%;\n    }\n\n    .timeline{\n      &:before{\n          left: 5% !important;\n      }\n\n      > li > .timeline-badge{\n          left: 5% !important;\n      }\n\n      > li > .timeline-panel{\n          float: right !important;\n          width: 82% !important;\n\n          &:before{\n              border-left-width: 0 !important;\n              border-right-width: 15px !important;\n              left: -15px !important;\n              right: auto !important;\n          }\n\n          &:after{\n              border-left-width: 0 !important;\n              border-right-width: 14px !important;\n              left: -14px !important;\n              right: auto !important;\n          }\n      }\n  }\n\n}\n@media (max-width: 991px) and (min-width: 768px){\n  .nav-tabs-navigation.verical-navs {\n    padding: 0px 2px;\n  }\n}\n\n@media screen and (min-width: 768px){\n  .footer {\n    .footer-nav {\n      padding-left: 21px;\n    }\n\n    .credits {\n      padding-right: 15px;\n    }\n  }\n}\n\n@media screen and (min-width: 992px){\n    .navbar-collapse{\n        background: none !important;\n    }\n\n    .navbar .navbar-toggle{\n        display: none;\n    }\n\n    .navbar-nav{\n        .nav-link{\n            &.profile-photo{\n                padding: 0;\n                margin: 7px $padding-base-horizontal;\n            }\n        }\n    }\n\n    .section-nucleo-icons .icons-container{\n        margin: 0 0 0 auto;\n    }\n\n    .dropdown-menu .dropdown-item{\n        color: inherit;\n    }\n\n    .footer{\n        .copyright{\n            float: right;\n            padding-right: 15px;\n        }\n    }\n\n    .sidebar{\n      .sidebar-wrapper{\n        li.active{\n          > a:not([data-toggle=\"collapse\"]),\n          > [data-toggle=\"collapse\"] + div .nav li {\n            &:before{\n              border-right: 17px solid $medium-gray;\n              border-top: 17px solid transparent;\n              border-bottom: 17px solid transparent;\n              content: \"\";\n              display: inline-block;\n              position: absolute;\n              right: -16px;\n              opacity: 1;\n              top: 7px;\n              transition: opacity 150ms ease-in;\n            }\n\n            &:after{\n              border-right: 17px solid $default-body-bg;\n              border-top: 17px solid transparent;\n              border-bottom: 17px solid transparent;\n              content: \"\";\n              display: inline-block;\n              position: absolute;\n              right: -17px;\n              opacity: 1;\n              top: 7px;\n              transition: opacity 150ms ease-in;\n            }\n          }\n          >[data-toggle=\"collapse\"] + div .nav li {\n            a{\n              &:before,\n              &:after {\n                top: 0;\n              }\n            }\n          }\n        }\n      }\n    }\n\n}\n\n@media screen and (max-width: 768px){\n  .card-stats [class*=\"col-\"] .statistics::after {\n    display: none;\n  }\n\n  .main-panel .content {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n    .footer{\n        nav{\n            display: block;\n            margin-bottom: 5px;\n            float: none;\n        }\n    }\n\n    .landing-page .section-story-overview .image-container:nth-child(2){\n        margin-left: 0;\n        margin-bottom: 30px;\n    }\n\n    .card {\n      .form-horizontal {\n        .col-md-3.col-form-label {\n          text-align: left;\n        }\n      }\n    }\n\n}\n\n@media screen and (max-width: 767px){\n  .nav-tabs-navigation.verical-navs{\n    padding: 0 28px;\n  }\n\n  .typography-line {\n    padding-left: 23% !important;\n\n    span {\n      width: 60px !important;\n    }\n  }\n\n  .login-page,\n  .lock-page,\n  .register-page {\n    .navbar{\n      padding: .5rem 1rem;\n    }\n  }\n\n  .footer {\n    .footer-nav,\n    .credits {\n      margin: 0 auto !important;\n    }\n\n    .footer-nav {\n      margin-bottom: 10px !important;\n    }\n  }\n\n  .register-page {\n    .content {\n      padding-top: 5vh;\n    }\n    .footer {\n      position: relative;\n    }\n    .info-area.info-horizontal {\n      margin-top: 0;\n    }\n  }\n}\n\n@media screen and (max-width: 374px){\n  .login-page {\n    .content {\n      padding-top: 10vh;\n    }\n  }\n}\n\n@media screen and (max-width: 413px){\n  .fixed-plugin {\n    .dropdown.show-dropdown.show{\n      .dropdown-menu.show {\n        width: 225px !important;\n\n        &[x-placement=top-start] {\n          transform: translate3d(0,400px,0)!important;\n        }\n\n        &:before,\n        &:after {\n          bottom: 360px !important;\n        }\n      }\n    }\n  }\n\n}\n\n\n@media screen and (max-width: 576px){\n    .navbar[class*='navbar-toggleable-'] .container{\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    .card-contributions .card-stats{\n      flex-direction: column;\n\n      .bootstrap-switch{\n        margin-bottom: 15px;\n      }\n    }\n\n    .footer{\n        .copyright{\n            text-align: center;\n        }\n    }\n\n    .section-nucleo-icons{\n        .icons-container{\n            i{\n                font-size: 30px;\n\n                &:nth-child(6){\n                    font-size: 48px;\n                }\n            }\n        }\n    }\n\n    .page-header{\n        .container h6.category-absolute{\n            width: 90%;\n        }\n    }\n\n    .card-timeline .timeline {\n      .timeline-panel {\n        width: 38%;\n        padding: 15px;\n      }\n    }\n}\n",".alert{\n  .close{\n    font-weight: 300;\n    font-size: 29px;\n    i.fa,\n    i.fas,\n    i.far,\n    i.fal,\n    i.fab,\n    i.nc-icon{\n      font-size: 14px !important;\n    }\n  }\n}\n",".btn,\n.navbar .navbar-nav > a.btn{\n  &.btn-icon {\n    &.btn-sm{\n      .fa,\n      .far,\n      .fas,\n      .fal,\n      .fab,\n      .nc-icon{\n        font-size: $btn-icon-font-size-small;\n      }\n    }\n    &.btn-lg{\n      .fa,\n      .far,\n      .fas,\n      .fal,\n      .fab,\n      .nc-icon{\n        font-size: $btn-icon-font-size-lg;\n      }\n    }\n    &:not(.btn-footer) .nc-icon,\n    &:not(.btn-footer) .fa,\n    &:not(.btn-footer) .far,\n    &:not(.btn-footer) .fas,\n    &:not(.btn-footer) .fal,\n    &:not(.btn-footer) .fas{\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-12px, -12px);\n      line-height: 1.5626rem;\n      width: 24px;\n    }\n  }\n}\n",".form-check {\n  .form-check-sign{\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n    -webkit-font-smoothing: antialiased;\n    display: inline-block;\n    font-style: normal;\n    font-variant: normal;\n    text-rendering: auto;\n    line-height: 1;\n  }\n}\n\n.form-check-radio .form-check-sign{\n  // font-family: 'FontAwesome';\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 400;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  line-height: 1;\n  &::before{\n    font-size: 22px;\n    content: \"\\f111\";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    display: inline-block;\n    position: absolute;\n    opacity: .50;\n    left: 5px;\n    top: -5px;\n  }\n}\n.form-check .form-check-sign:after{\n  font-family: \"Font Awesome 5 Free\";\n  top: 4px;\n}\n.form-check-radio .form-check-sign::after,.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n  font-family: \"Font Awesome 5 Free\";\n  top: -1px;\n}\n.form-check-radio .form-check-sign::before, .form-check-radio input[type=\"radio\"]:checked + .form-check-sign::before {\n  font-family: \"Font Awesome 5 Free\";\n  top: -1px;\n}\n",".dropup .dropdown-toggle:after, .dropdown .dropdown-toggle:after {\n    margin-left: 3px;\n}\n",".fixed-plugin{\n  .dropdown{\n    .dropdown-menu{\n\n      &:before{\n        right: -17px;\n        top: 28%;\n      }\n\n      &:after{\n        right: -16px;\n        top: 28%;\n      }\n    }\n  }\n  .gh-btn,\n  .gh-count,\n  .gh-ico {\n    float: left;\n  }\n  .gh-btn,\n  .gh-count {\n    padding: 2px 5px 2px 4px;\n    color: #333;\n    text-decoration: none;\n    white-space: nowrap;\n    cursor: pointer;\n    border-radius: 3px;\n  }\n  .gh-btn {\n    background-color: #eee;\n    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #fcfcfc), color-stop(100%, #eee));\n    background-image: -webkit-linear-gradient(top, #fcfcfc 0, #eee 100%);\n    background-image: -moz-linear-gradient(top, #fcfcfc 0, #eee 100%);\n    background-image: -ms-linear-gradient(top, #fcfcfc 0, #eee 100%);\n    background-image: -o-linear-gradient(top, #fcfcfc 0, #eee 100%);\n    background-image: linear-gradient(to bottom, #fcfcfc 0, #eee 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fcfcfc', endColorstr='#eeeeee', GradientType=0);\n    background-repeat: no-repeat;\n    border: 1px solid #d5d5d5;\n  }\n  .gh-btn:hover,\n  .gh-btn:focus {\n    text-decoration: none;\n    background-color: #ddd;\n    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #eee), color-stop(100%, #ddd));\n    background-image: -webkit-linear-gradient(top, #eee 0, #ddd 100%);\n    background-image: -moz-linear-gradient(top, #eee 0, #ddd 100%);\n    background-image: -ms-linear-gradient(top, #eee 0, #ddd 100%);\n    background-image: -o-linear-gradient(top, #eee 0, #ddd 100%);\n    background-image: linear-gradient(to bottom, #eee 0, #ddd 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#dddddd', GradientType=0);\n    border-color: #ccc;\n  }\n  .gh-btn:active {\n    background-image: none;\n    background-color: #dcdcdc;\n    border-color: #b5b5b5;\n    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15);\n  }\n  .gh-ico {\n    width: 14px;\n    height: 14px;\n    margin-right: 4px;\n    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjQwcHgiIGhlaWdodD0iNDBweCIgdmlld0JveD0iMTIgMTIgNDAgNDAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMTIgMTIgNDAgNDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxwYXRoIGZpbGw9IiMzMzMzMzMiIGQ9Ik0zMiAxMy40Yy0xMC41IDAtMTkgOC41LTE5IDE5YzAgOC40IDUuNSAxNS41IDEzIDE4YzEgMC4yIDEuMy0wLjQgMS4zLTAuOWMwLTAuNSAwLTEuNyAwLTMuMiBjLTUuMyAxLjEtNi40LTIuNi02LjQtMi42QzIwIDQxLjYgMTguOCA0MSAxOC44IDQxYy0xLjctMS4yIDAuMS0xLjEgMC4xLTEuMWMxLjkgMC4xIDIuOSAyIDIuOSAyYzEuNyAyLjkgNC41IDIuMSA1LjUgMS42IGMwLjItMS4yIDAuNy0yLjEgMS4yLTIuNmMtNC4yLTAuNS04LjctMi4xLTguNy05LjRjMC0yLjEgMC43LTMuNyAyLTUuMWMtMC4yLTAuNS0wLjgtMi40IDAuMi01YzAgMCAxLjYtMC41IDUuMiAyIGMxLjUtMC40IDMuMS0wLjcgNC44LTAuN2MxLjYgMCAzLjMgMC4yIDQuNyAwLjdjMy42LTIuNCA1LjItMiA1LjItMmMxIDIuNiAwLjQgNC42IDAuMiA1YzEuMiAxLjMgMiAzIDIgNS4xYzAgNy4zLTQuNSA4LjktOC43IDkuNCBjMC43IDAuNiAxLjMgMS43IDEuMyAzLjVjMCAyLjYgMCA0LjYgMCA1LjJjMCAwLjUgMC40IDEuMSAxLjMgMC45YzcuNS0yLjYgMTMtOS43IDEzLTE4LjFDNTEgMjEuOSA0Mi41IDEzLjQgMzIgMTMuNHoiLz48L3N2Zz4=');\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n  }\n  .gh-count {\n    position: relative;\n    display: none; /* hidden to start */\n    margin-left: 4px;\n    background-color: #fafafa;\n    border: 1px solid #d4d4d4;\n  }\n  .gh-count:hover,\n  .gh-count:focus {\n    color: #4183C4;\n  }\n  .gh-count:before,\n  .gh-count:after {\n    content: '';\n    position: absolute;\n    display: inline-block;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid;\n  }\n  .gh-count:before {\n    top: 50%;\n    left: -3px;\n    margin-top: -4px;\n    border-width: 4px 4px 4px 0;\n    border-right-color: #fafafa;\n  }\n  .gh-count:after {\n    top: 50%;\n    left: -4px;\n    z-index: -1;\n    margin-top: -5px;\n    border-width: 5px 5px 5px 0;\n    border-right-color: #d4d4d4;\n  }\n  .github-btn-large {\n    height: 30px;\n  }\n  .github-btn-large .gh-btn,\n  .github-btn-large .gh-count {\n    padding: 3px 10px 3px 8px;\n    font-size: 16px;\n    line-height: 22px;\n    border-radius: 4px;\n  }\n  .github-btn-large .gh-ico {\n    width: 20px;\n    height: 20px;\n  }\n  .github-btn-large .gh-count {\n    margin-left: 6px;\n  }\n  .github-btn-large .gh-count:before {\n    left: -5px;\n    margin-top: -6px;\n    border-width: 6px 6px 6px 0;\n  }\n  .github-btn-large .gh-count:after {\n    left: -6px;\n    margin-top: -7px;\n    border-width: 7px 7px 7px 0;\n  }\n  .github-btn{\n    display: inline-block;\n    .gh-btn{\n      .gh-ico{\n        margin-top: 3px;\n      }\n    }\n  }\n  .SocialMediaShareButton{\n    display: inline-block;\n  }\n}\n@media screen and (max-width: 400px){\n  .fixed-plugin .dropdown-menu {\n    width: 250px;\n  }\n}\n","select.form-control:not([size]):not([multiple]) {\n  height: calc(2.25rem + 4px);\n}\n\n.form-control {\n  height: unset;\n}\n// Input files - hide actual input - requires specific markup in the sample.\n.form-group input[type=file] {\n  opacity: 1;\n  position: unset;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: unset;\n  z-index: unset;\n}\n",".navbar{\n  .navbar-nav{\n    .nav-link{\n      i.fa + p,\n      i.fal + p,\n      i.fas + p,\n      i.fab + p,\n      i.far + p,\n      i.nc-icon + p{\n        margin-left: 7px;\n      }\n      i.fa,\n      i.fal,\n      i.fas,\n      i.fab,\n      i.far,\n      i.nc-icon{\n        font-size: 18px;\n        position: relative;\n        top: 3px;\n        text-align: center;\n        width: 21px;\n      }\n    }\n  }\n}\n","/*--------------------------------\n\nnucleo-icons Web Font - built using nucleoapp.com\nLicense - nucleoapp.com/license/\n\n-------------------------------- */\n@font-face {\n  font-family: 'nucleo-icons';\n  src: url('~assets/fonts/nucleo-icons.eot');\n  src: url('~assets/fonts/nucleo-icons.eot') format('embedded-opentype'), url('~assets/fonts/nucleo-icons.woff2') format('woff2'), url('~assets/fonts/nucleo-icons.woff') format('woff'), url('~assets/fonts/nucleo-icons.ttf');\n  font-weight: normal;\n  font-style: normal;\n}\n","@media screen and (max-width: 991px){\n  .navbar-nav{\n    .nav-link{\n      i.fa,\n      i.fal,\n      i.fas,\n      i.fab,\n      i.far,\n      i.nc-icon{\n        opacity: .5;\n      }\n    }\n  }\n  .navbar .dropdown.show .dropdown-menu{\n    border: 0;\n    -webkit-transition: none;\n    transition: none;\n    -webkit-box-shadow: none;\n    width: auto;\n    margin: 0 1rem;\n    box-shadow: none;\n    position: static!important;\n    padding-left: 10px;\n    display: block!important;\n    -webkit-transform: translateZ(0)!important;\n    transform: translateZ(0)!important;\n    background: inherit;\n    &:before,&:after{\n      display: none;\n    }\n  }\n  .navbar.bg-dark .dropdown.show .dropdown-menu a{\n    color: $white-color;\n  }\n}\n\n@media screen and (min-width: 992px){\n\n  .sidebar{\n    .sidebar-wrapper{\n      li.active{\n        > a:not([data-toggle=\"collapse\"]){\n          &:before{\n            border-right: 18px solid $medium-gray;\n            border-top: 18px solid transparent;\n            border-bottom: 18px solid transparent;\n            right: -15px;\n            top: 6px;\n          }\n\n          &:after{\n            border-right: 17px solid $default-body-bg;\n            border-top: 17px solid transparent;\n            border-bottom: 17px solid transparent;\n            right: -15px;\n            top: 7px;\n          }\n        }\n      }\n    }\n  }\n\n}\n","*,a{\n  &,&:focus{\n    outline: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
